// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/images/MagicPattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/images/form-43.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/bold_font.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/italic_font.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/underline_font.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/align-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/align-center.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/align-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/align-justify.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/link.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/list_order.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/undo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/redo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  /* background: #FBFBFB; */
  margin: 0 !important;
  padding: 0px !important;
  font-family: "Manrope", sans-serif;
  height: 100vh;
}
.rdw-link-decorator-wrapper {
  margin-bottom: 10px !important;
}

.rdw-link-decorator-icon {
  position: absolute !important;
  left: 100% !important;
  top: 10px !important;
  cursor: pointer !important;
  background-color: white !important;
  width: 30% !important;
  margin-bottom: 20px;
}

.componentScroll {
  position: relative;
}

.componentScroll .sub-acc {
  background-color: #fff;

  /* position: fixed;
  top: 112px;
  right: 20px;
  flex: 0 0 auto;
  width: 25.333333%;
  z-index: 100; */
}

.buildLeftDiv .left-fixed {
  flex: 0 0 auto;

  position: sticky;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 100;
}

.form-features.bxShw.wraper.outer_bord.scrollling-editzz {
  /* padding: 2rem; */
  overflow-y: auto;
  /*height: 100%;*/
}

.edit-right-fixes {
  /*background-color: #FFF;*/
  position: sticky;
  right: 20px;
  flex: 0 0 auto;
  width: 100%;
  /* z-index: 100;*/
  top: 100px;
}
.setupRightDiv {
  position: relative;
}

.buildLeftDiv {
  position: relative;
}
.container_main.containerSpace.mainWrap .componentScroll .sub-acc {
  width: 25.2%;
}
.container_main.collapseView .componentScroll .sub-acc {
  width: 28.35% !important;
}

.sidebar_open.main-content.edit.hight-av .scrollling-editzz {
  /*height: 1000px !important;*/
  position: relative;
}

/* body::-webkit-scrollbar {
    display: none;
} */
a,
button {
  transition: all ease 0.5s;
}

html,
body,
p,
h1,
h2,
h3,
h4,
h5,
h6,
img,
form,
input,
select,
textarea,
ul,
li {
  margin: 0;
  padding: 0;
  color: #000;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Manrope", sans-serif;
  color: #302b3a !important;
}

ul li {
  list-style: none;
}

img {
  border: none;
  width: 100%;
}

p {
  font-size: 15px;
  color: var(--color3);
  font-size: 15px;
}

a {
  transition: all ease 0.5s;
  text-decoration: none !important;
  color: var(--color2);
}

.clear {
  height: 0;
  margin: 0;
  padding: 0;
  clear: both;
  font-size: 0;
  line-height: 0;
}

:root {
  --color1: #3a68d8;
  --color2: #252628;
  --color3: #302b3a;
  --colorGrey: #666666;
}

.rightCont.top-id-fixes {
  margin-top: 95px;
}
label.w4form-l.sounth {
  margin: -35px 0px 0px 33px;
  font-size: 15px;
}
.logoContainer img {
  /*width: 130px;
     width: 100%;
    height: 72px;
      width: 50px;*/
  width: 130px;
  height: 50px;
  margin: 0px 0px 0px 3px;
}
.hd-can.create-form-wrp p {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: px 0px 0px 40px;
}
.nav-link {
  display: flex;
  align-items: center;
}

ul {
  list-style: none;
  padding-left: 0px !important;
}
button.send-req-btn.rounded.p-2 {
  color: #fff;
  border: 0;
  width: auto;
  justify-content: space-between;
  background: #3a68d8;
  text-align: center;
  max-width: 140px;
  font-size: 15px;
  padding: 10px 10px 10px 10px !important;
}
span.act-ever {
  float: right;
  cursor: auto;
}

a.text-primary.cont-admin {
  cursor: pointer;
}
/* ul.nav {
    display: flex;
    flex-direction: column;
} */
ul#accordionFlushExample {
  /*max-height: calc(100vh - 9rem);*/
  overflow-y: auto;
  width: 100%;
}
.sidebar ul#accordionFlushExample {
  overflow: unset;
}
.logoContainer h1 {
  margin-bottom: 0px;
  font-size: 30px;
}

nav.sidebar {
  /* padding: 0px 25px;*/
  padding: 0px 0px;
}

.searchere input {
  padding: 8px 0px 3px 30px;
  border: 0;
  box-shadow: none;
}

.searchere {
  position: relative;
  display: flex;
  width: 100%;
  padding-bottom: 0px;
  align-items: center;
  /* gap: 17px; */
  border-bottom: 1px solid var(--graphic-objects-components-wcagaa, #949494);
  margin: 0px;
}

.searchere-sidebar {
  position: relative;
  display: flex;
  width: 100%;
  padding: 0px;
  align-items: center;
  /* gap: 17px; */
  /* border-bottom: 1px solid var(--graphic-objects-components-wcagaa, #949494); */
}
.searchere-sidebar img {
  width: 12px;
}
.form-contro .side-input {
  padding: 6px 4px 10px 50px;
}

.serach-width-div img.menu_icon.search {
  position: absolute;
  left: 8px;
  top: 21px;
  width: 15px;
}
.q-btns.my-3.d-flex.justify-content-end.modal-bttn.footer-bttn {
  margin: 0 0 20px !important;
}

.form-name-edit {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-weight: 500;
}

.form-name {
  /*color: var(--Avenu-Black, #302B3A);*/
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-weight: 600;
  color: var(--Active-State, #3a68d8);
}
img.menu_icon.search-sidebar {
  position: absolute;
  left: 25px;
  top: 17px;
  text-decoration: none;
}

.righTitles {
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--Avenu-Black, #302b3a);
}

form.form {
  margin: 0px 0px 0px 105px;
}
.container-upload {
  background-color: #fff;
  padding: 40px 80px;
  border-radius: 8px;
  box-shadow: 0px 0px 24.08px 3.92px rgba(0, 0, 0, 0.25);
  margin: 70px 0px 0px 20px;
  width: 95%;
}
.detail-tabs .tabSpace .react-tabs__tab:nth-child(1) {
  margin-left: 1rem;
}
.detail-tabs ul.tabSpace {
  margin: 0 0 0.6rem;
}
button.accordion-button {
  padding: 0px 0px;
}

/* .sidebar.active a.nav-link.active {
    border-radius: 10px;
} */
.accordion-button:focus {
  border-color: none;
  box-shadow: none;
}

.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: #fff !important;
  box-shadow: none !important;
}

.form-control:focus {
  box-shadow: none;
}

.accordion-body {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  margin-bottom: 5px;
}

ul.nav.submenu li a span {
  color: #949494;
}

.searchere img {
  width: 12px;
}

.layoutmain {
  display: flex;
}

main {
  flex: 1 1;
}

header {
  /*display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
    height: 75px;*/
  display: flex;
  width: 100%;
  height: 92px;
  padding: 0px 20px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid #ccc;
  background: #fff;
  padding-left: 10px;
}

.hd-left {
  display: flex;
  align-items: center;
}

ol.breadcrumb {
  margin-bottom: 0px;
}

Header select.form-select {
  border-radius: 0px !important;
  margin-left: 15px;
  border: 0;
}

button.menu-btn img {
  width: 22px;
  height: 24px;
}

button.menu-btn {
  border: 0;
  background: none;
}

.txt-black {
  color: #000;
}

.txt-blue {
  /* color: blue;*/
  color: #083ab5;
  text-decoration: underline;
  text-decoration-color: blue;
}

.userarea img {
  width: 40px;
}

.userarea button {
  background: none !important;
  border: 0;
  padding: 0 0 0 10px;
}

span.username {
  margin-left: 10px;
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.form-select:focus {
  border-color: #fff;
  outline: 0 !important;
  box-shadow: none !important;
}

.logoContainer::after {
  content: "";
  position: absolute;
  background: #ccccccad;
  bottom: -1px;
  /* left: -50px;*/
  width: 320px;
  height: 1px;
}

.logoContainer {
  position: relative;
}

nav.sidebar.active .logoContainer h1,
nav.sidebar.active span.menu-title,
nav.sidebar.active .accordion-button::after {
  font-size: 0;
}
nav.sidebar.active .res-icon {
  display: none;
}
nav.sidebar.active .logo-bttn {
  display: none;
}

nav.sidebar.active .give-us {
  display: flex;
  justify-content: center;
  display: none;
}

nav.sidebar.active .advan-text {
  display: flex;
  justify-content: center;
  display: none;
}

nav.sidebar .menu_icon .sub-iicons.active {
}

nav.sidebar.active {
  /* width: 35%; */

  width: 85px;
  padding: 0px 10px;
}

span.username img {
  width: 10px;
}

/* edit forms css start */

.onb-actions {
  display: flex;
  align-items: center;
}

.onb-actions a img {
  width: 23px;
}

.onb-actions select {
  width: 40%;
  margin-right: 20px;
}

.onb-actions a {
  display: flex;
  min-width: 140px;
  justify-content: center;
  color: #302b3a;
}
.onb-actions.fontSty .btn-primary {
  color: var(--color3);
  font-size: 15px;
  font-family: "Manrope", sans-serif !important;
  font-weight: 400;
  cursor: pointer;
}
.action-itms-forms {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.onb-actions a img {
  margin-right: 12px;
}

.info img {
  width: 15px;
}

.create-sec.onb-actions a {
  width: inherit;
}

.create-sec.onb-actions a {
  width: inherit;
}

.create-sec.onb-actions {
  justify-content: flex-end;
}

.f-btns .btn img {
  width: 20px;
}
.formInner .f-btns .btn {
  background: transparent;
}
.hight-av .upload-btns a {
  color: #666 !important;
}

.formInner .upload-btns .up-btn.btn {
  margin: 0;
  color: #302b3a;
  font-weight: 500;
  font-size: 15px;
  font-family: "Manrope", sans-serif !important;
}
.inpAlig .subtits {
  color: #666;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.wraper {
  float: left;
  width: 100%;
}
/* .formInner .form-hd .left_titlSpc{
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: left;
} */
.left_titlSpc p {
  font-size: 14px;
  color: #666666;
  margin: 5px 0;
  padding: 0 0 0 15px;
}
.b-0 {
  border: 0 !important;
}

.inpAlig .subHead_inp.main-title {
  color: #302b3a;
  font-size: 15px !important;
  font-weight: 600 !important;
  padding: 5px 0 !important;
}
.inpAlig .subHead_inp {
  font-size: 13px;
  font-weight: 500;
  font-family: "Manrope", sans-serif !important;
  color: #666666;
  padding: 0;
}
.formAlg-new .inpAlig .subHead_inp {
  font-size: 13px;
  font-weight: 500;
  font-family: "Manrope", sans-serif !important;
}
.formAlg-new .inpAlig .main-title {
  font-size: 15px !important;
  font-weight: 500 !important;
  margin: 5px 0 0px;
  font-family: "Manrope", sans-serif !important;
  padding: 0;
  color: var(--color3);
}
.formAlg-new .inpAlig .main-title::placeholder {
  color: var(--color3);
}

.formInner .form-features.newone {
  padding: 0px;
}
.f-itm.newOne .f-btns .btn {
  height: 30px;
  margin: 0px 5px;
  padding: 0;
}
.form-features.outer_bord {
  padding: 2rem;
}
.formInner .bxborder.newPads_editform {
  padding: 15px 15px;
}
.formInner .bxborder {
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
  padding: 39px 40px;
}

.titDrag {
  color: #302b3a;
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

input.form-control.widthInp.input-edit-text1.my-0 {
  color: #666;
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

input.form-control.widthInp.input-edit-text.my-0 {
  color: #302b3a;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.sub-head-color {
  font-size: 14px;
  color: #666666;
  font-weight: 500;
  font-family: "Manrope", sans-serif !important;
}
.titDrag-sub {
  color: #666;
  font-family: "Manrope", sans-serif !important;
  font-size: 13px;
  font-weight: 500;
}
.f-btns .btn {
  width: 44px;
  height: 44px;
  background: #fbfbfb;
  margin: 5px 5px;
  text-align: center;
  border: none;
}
.dragBtn {
  width: 30px;
  height: 44px;
  background: #fbfbfb;
  margin-right: 10px;
  text-align: center;
  padding: 3px !important;
}
.dragBtn img {
  width: 6px !important;
  margin: 0 !important;
}

/* .f-btns .btn:last-child img {
    width: 5px;
} */

.f-btns .btn:last-child {
  margin-right: 0px;
}

.f-itm {
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 10px;
  align-items: center;
  margin-bottom: 12px;
}

.form-features {
  width: 100%;
  background: #fbfbfb;
  padding: 20px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
}

.f-itm span img {
  width: 18px;
  margin-right: 20px;
}

h6.form-hd img {
  width: 5px;
  margin-left: 10px;
}
h6.form-hd img.mrR {
  margin: 0 10px 0 0;
}

.upload {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload img {
  width: 40px;
  margin-bottom: 12px;
}

.fileupload {
  border: 1px dashed #3a68d8;
  border-radius: 30px;
  padding: 40px;
}

.fileuploadExceed {
  border: 1px dashed red;
  border-radius: 30px;
  padding: 40px;
}

.file-view {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 20px;
}

.upload h3 {
  font-size: 22px;
}

button.up-btn.btn {
  border: 1px solid #949494;
  border-radius: 10px;
  background: #fff;
  margin-right: 20px;
  padding: 10px 25px;
}

.upload-btns a {
  color: #949494;
  text-decoration: underline !important;
}

buton.up-btn.btn:hover {
  background: var(--color1);
  border-color: var(--color1);
  color: #fff;
}

/* edit forms css end */

.ReactModal__Content.ReactModal__Content--after-open {
  position: inherit;
  max-width: 550px;
  width: 100%;
  margin: auto;
  height: 390px;
}

/*
.ReactModal__Overlay.ReactModal__Overlay--after-open {
    background-color: rgb(0 0 0 / 33%);
}.ReactModal__Overlay.ReactModal__Overlay--after-open {
    display: flex;
    justify-content: center;
    align-items: center;
} .modal-body {
    overflow: scroll;
    height: 55vh;
} */

/*select {
    -webkit-appearance: listbox !important;
}*/

.modal-footer .btn-primary {
  background: #ecf1ff;
  border: 0;
  color: var(--color1);
  padding: 8px 35px;
}
.modal-footer .Cancel-pop {
  background: transparent;
  border: 0;
  color: #666;
  padding: 8px 30px;
  border-radius: 5px;
  min-height: 39px;
}
.modal-footer .Cancel-pop:hover {
  background: #666666;
  border: 0;
  color: #fff;
  padding: 8px 30px;
}
.vdo.mt-4.mb-3 {
  position: relative;
  display: flex;
  justify-content: space-around;
}

img.send_icon {
  position: absolute;
  right: 20px;
  top: 0px !important;
  /* left: 10px; */
  /* bottom: 50%; */
}
img.play-btn {
  width: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.filter-divs {
  display: contents;
}
.chathead {
  position: absolute;
  top: 84%;
  left: 16px;
  right: 16px;
}
.w4form-l {
  margin: 3px 0px 0px 10px;
  font-size: 15px;
}
select#your-message {
  height: 63px;
}
.head-l {
  font-size: 16px;
  text-align: center;
}
.mul-txt {
  color: #000;
  background-color: rgb(255, 255, 255);
  font-size: 15px;
  font-family: Manrope, sans-serif;
}
.text-class {
  max-height: 65px;
}
.radio-sizee {
  font-size: 20px;
}
.para-fonts {
  font-size: 15px;
}

input.form-control.mesg-cht {
  min-height: 65px;
  padding-right: 10%;
}
.msgScroll {
  min-height: 100% !important;
}

.container {
  max-width: 1170px;
  margin: auto;
}
img {
  max-width: 100%;
}
.inbox_people {
  background: #f8f8f8 none repeat scroll 0 0;
  float: left;
  /*overflow: hidden;*/
  width: 40%;
  border-right: 1px solid #c4c4c4;
}
.inbox_msg {
  border: 1px solid #c4c4c4;
  clear: both;
  overflow: hidden;
}
.top_spac {
  margin: 20px 0 0;
}

.recent_heading {
  float: left;
  width: 40%;
}
.srch_bar {
  display: inline-block;
  text-align: right;
  width: 60%;
}
.headind_srch {
  padding: 10px 29px 10px 20px;
  overflow: hidden;
  border-bottom: 1px solid #c4c4c4;
}

.recent_heading h4 {
  color: #05728f;
  font-size: 21px;
  margin: auto;
}
.srch_bar input {
  border: 1px solid #cdcdcd;
  border-width: 0 0 1px 0;
  width: 80%;
  padding: 2px 0 4px 6px;
  background: none;
}
.srch_bar .input-group-addon button {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  padding: 0;
  color: #707070;
  font-size: 18px;
}
.srch_bar .input-group-addon {
  margin: 0 0 0 -27px;
}

.chat_ib h5 {
  font-size: 15px;
  color: #464646;
  margin: 0 0 8px 0;
}
.chat_ib h5 span {
  font-size: 13px;
  float: right;
}
.chat_ib p {
  font-size: 14px;
  color: #989898;
  margin: auto;
}
.chat_img {
  float: left;
  width: 11%;
}
.chat_ib {
  float: left;
  padding: 0 0 0 15px;
  width: 88%;
}

.chat_people {
  overflow: hidden;
  clear: both;
}
.chat_list {
  border-bottom: 1px solid #c4c4c4;
  margin: 0;
  padding: 18px 16px 10px;
}
.inbox_chat {
  height: 550px;
  overflow-y: scroll;
}

.active_chat {
  background: #ebebeb;
}

.incoming_msg_img {
  display: inline-block;
  width: 30px;
}
.received_msg {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 92%;
}
.received_withd_msg p {
  /*background: #ebebeb none repeat scroll 0 0;
  border-radius: 3px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  width: 100%;*/
  background-color: #e9ecef85;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.5rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  padding: 5px 10px;
  word-break: break-all;
  width: -moz-fit-content;
  width: fit-content;
}

.time_date-left {
  color: #666666;
  display: block;
  font-size: 12px;
  /*padding: 0px 0px 0px 75px; */
  margin-bottom: 5px;
  float: left;
  position: relative;
  left: 80px;
  top: -10px;
}
.time_date-right {
  color: #666666;
  display: block;
  font-size: 12px;
  padding: 0px;
  margin-bottom: 9px;
  float: right;
  position: relative;
  left: -65px;
  top: -5px;
}
.time_date {
  color: #666666;
  display: block;
  font-size: 12px;

  padding: 0px;
  margin-bottom: 9px;
}
/*.received_withd_msg { width: 57%;}*/
.mesgs {
  float: left;
  padding: 30px 15px 0 25px;
  width: 60%;
}

.sent_msg p {
  border-radius: 3px;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  /* width: 100%;  */
  text-align: end;
}
.outgoing_msg {
  overflow: hidden;
  margin: 26px 0 26px;
}
.sent_msg {
  float: right;
  /* width: 46%; */
}
.input_msg_write input {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  color: #4c4c4c;
  font-size: 15px;
  min-height: 48px;
  width: 100%;
}

.type_msg {
  border-top: 1px solid #c4c4c4;
  position: relative;
}
.msg_send_btn {
  background: #05728f none repeat scroll 0 0;
  border: medium none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 17px;
  height: 33px;
  position: absolute;
  right: 0;
  top: 11px;
  width: 33px;
}
.messaging {
  padding: 0 0 50px 0;
}
.msg_history {
  /*height: 516px;*/
  overflow-y: auto;
}

.msg_send_btn {
  background: transparent;
  border: 0;
  outline: 0;
  border-radius: 0;
  color: #fff;
  cursor: pointer;
  font-size: 0;
  width: 36px;
  height: 36px;
  margin: 0;
  padding: 0;
  float: right;
}
.input_msg_write input {
  background: #fff;
  border: 0;
  color: #302b3a;
  font-size: 16px;
  font-weight: 500;
  min-height: 58px;
  width: calc(100% - 38px);
  border-radius: 0px;
}
.input_msg_write {
  background: #fff;
  border: 1px solid #dfdfdf;
  padding: 0 15px;
  border-radius: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.d-flex.detail-user {
  position: relative !important;
}

.video-thumb {
  height: 476px;
  width: 100%;
  border-radius: 15px;
}

.secBox {
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  color: #302b3a;
  background-color: #fff;
}
.sidebar_open.noBg {
  background-color: transparent;
  border: 0;
  padding: 5px;
  border-radius: 0;
  height: 80vh;
}
.serchField {
  border-bottom: 1px solid #a4a4a4;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 10px;
  margin: 0;
}
.serchField .serc_icon {
  width: 15px;
  float: left;
  margin-right: 8px;
}
.serchField .sercInp {
  /* border: 0;
    width: 100%;
    box-shadow: inherit;
    font-size: 14px;
    outline: 0;*/
  color: var(--graphic-objects-components-wcagaa, #949494);
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: 100%;
  box-shadow: inherit;
  border: 0;
  outline: 0;
}
.inpCheckbx {
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.inpCheckbx input[type="checkbox"] {
  margin-right: 5px;
}
.inpCheckbx .DltBtn {
  margin: 0 10px;
  padding: 0;
  line-height: 12px;
}
.inpCheckbx .DltBtn img.menu_icon {
  width: 16px;
}

.fileTable .arrow_icon {
  width: 10px;
}
table.fileTable {
  color: #302b3a;
  position: relative;
  border-collapse: collapse;
}
.tableFixHead .fileTable th {
  background: white;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}
.fileTable th {
  font-weight: 600;
  font-size: 18px;
  color: #302b3a;
  vertical-align: middle;
  padding: 0.7rem 0.8rem !important;
}
.fileTable td {
  font-weight: 400;
  font-size: 14px;
  color: #302b3a;
  border: 0;
  vertical-align: middle;
  padding: 0.7rem 0.8rem !important;
}
.fileTable select {
  background: #ffb900;
  color: #000;
  border: 1px solid #ffb900;
  border-radius: 60px;
  font-size: 13px;
  font-weight: 500;
  padding: 0px 5px;
  outline: 0;
  box-shadow: inherit;
}

.fileTable .actionBtn {
  background: transparent;
  border: 0;
  outline: 0;
  box-shadow: inherit;
  padding: 5px;
  margin: 0 5px 0 0;
}
.fileTable .actionBtn img {
  width: 16px;
}
.fileTable tr {
  border-bottom: 1px solid #e8e8e8;
}
.fileTable .frntTxt {
  display: flex;
  flex-direction: row;
  float: left;
  margin: 2px 7px 0 0;
}
.fileTable .frntTxt .folder_icon {
  width: 16px;
  margin: 0 5px 0 8px;
}

.tableFixHead {
  overflow-y: auto;

  /*
  max-height: 945px;max-height: 450px; height: 100%;*/
}

tbody.table-text-body.on-docs-dive {
  height: 100%;
  /* display: contents; */
}
.pagination {
  margin: 10px 0 5px;
  text-align: center;
  width: 100%;
}
.pagination.centPag {
  display: flex;
  justify-content: center;
}
.pagination > a {
  background: transparent;
  color: #302b3a;
  width: 30px;
  height: 30px;
  border-radius: 60px;
  text-align: center;
  line-height: 28px;
  margin-right: 5px;
  font-size: 14px;
}
.pagination > a.active {
  background: #3a68d8;
  color: #fff;
}

.alignBox ul {
  width: 100%;
}

.alignBox.fn-main ul li {
  width: 100%;
  padding: 5px;
}

.alignBox.fn-main ul .boxDiv {
  width: 50%;
  float: left;
  margin: 0px;
}
.alignBox.fn-main ul li .component {
  padding: 10px 5px !important;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: white;
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.leftCont {
  width: 100%;
}
/* .BuilderWrap{

} */
.formSect {
  background: #fff;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  width: 100%;
}
.inp_titles {
  /* font-size: 24px;*/
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0px !important;
}
.textArea {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  resize: none;
}
.formSect .inpTxt {
  border: 0;
  width: 100%;
  padding: 10px;
  box-shadow: inherit;
  outline: 0;
  /* color: #949494; */
  color: var(--avenu-black, #302b3a);
  margin: 0;
}
.formSect .inpTxt::placeholder,
.public-DraftEditorPlaceholder-root {
  color: #949494 !important;
  margin-top: 10px;
}

.algLabel .public-DraftEditorPlaceholder-root {
  margin: 0;
  font-size: 14px !important;
  font-weight: 400;
}
.padd-titles {
  padding-left: 5px !important;
}

.form_titles {
  padding: 0 0 10px;
  margin: 5px 0 15px;
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.iconGrp .inp-icon {
  width: 19px;
  margin: 0 5px 0 15px;
  cursor: pointer;
}
.formSect .topSect {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.formSect .iconGrp {
  border-left: 1px solid #dfdfdf;
  padding: 5px 0;
  margin: 0 0 0 10px;

  display: flex;
  flex-direction: row-reverse;
}

.formSect .topSect h6 {
  margin: 5px 0;
  padding: 0;
  font-size: 15px;
  font-weight: 600;
}

.formSect .align-icon {
  max-width: 19px;
  margin-right: 10px;
  height: auto;
  max-height: 19px;
}

.formSect hr {
  opacity: 0.1;
}

.formSect .close-icon {
  width: 23px;
}

.sub-acc.padSpace {
  padding: 15px 25px;
}

.formSect .inpWid {
  width: calc(100% - 50px);
  float: left;
}

.formSect .btnWid {
  width: 50px;
  /* float: right; */
}
.alginBtn {
  justify-content: end;
  display: flex;
  align-items: center;
}
.alginBtn img.close-icon {
  margin: 0;
  cursor: default;
}

.alinBx {
  display: flex;
  align-items: center;
  width: 100%;
}
.alinBx .LeftCont {
  width: 35px;
}
.alinBx .RightCont {
  width: calc(100% - 35px);
}

.alinBx .btn {
  padding: 5px;
  border: 0;
  outline: 0;
}
.alinBx .btn img {
  width: 7px;
}

label.switch.togSw.create-toogle {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 17px;
  max-width: 42px;
  margin-left: 0px;
}
.switch.togSw {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 17px;
  max-width: 42px;
  margin-left: 15px;
}

.switch.togSw input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch.togSw .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  border: 2px solid #949494;
  transition: 0.4s;
}

.switch.togSw .slider:before {
  position: absolute;
  content: "";
  height: 9px;
  width: 9px;
  left: 3px !important;
  bottom: 2px;
  background-color: #949494;
  transition: 0.4s;
  top: 3px;
}

.switch.togSw input:checked + .slider {
  background-color: #fff;
  border: 2px solid #3a68d8;
}

.switch.togSw input:focus + .slider {
  box-shadow: 0 0 1px #3a68d8;
}

.switch.togSw input:checked + .slider:before {
  transform: translateX(24px);

  background-color: #3a68d8;
  left: 0px;
}

.switch.togSw .slider.round {
  border-radius: 34px;
}

.switch.togSw .slider.round:before {
  border-radius: 50%;
}

.reqDiv {
  display: flex;
  align-items: center;
}

.reqDiv .labTog {
  margin-right: 20px;
  font-size: 14px;
  font-weight: 600;
}

.topSect label.form-check-label {
  font-size: 15px;
  font-weight: 600;
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;

  font-style: normal;

  line-height: normal;
}

.btnTxts .btn.txtBtn {
  background: #3a68d8;
  color: #fff;
  border-radius: 0;
  border: 0;
  width: 30px;
  height: 25px;
  padding: 2px;
  line-height: 10px;
  border-right: 1px solid #ffffff70;
}
.btnTxts .btn.txtBtn img {
  width: 13px;
}

.btnTxts .btn.txtBtn:hover,
.btnTxts .btn.txtBtn:focus {
  background: #204dbd;
  box-shadow: inherit;
  outline: 0;
}
.pl-0 {
  padding-left: 0 !important;
}
.pr-0 {
  padding-right: 0 !important;
}

.adBtn_mr img.add-more {
  width: 18px;
  margin-right: 5px;
}

.formSect .adBtn_mr {
  display: flex;
  align-items: center;
  padding: 5px 0;
  font-size: 14px;
  color: #949494;
  margin: 10px 0;
}
.email-table {
  color: #302b3a;
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.sub-text-link {
  font-size: 13px;
  margin: 0px 5px 0px 0px;
}
.sub-text {
  font-size: 12px;
  color: #666;
  margin: 0px 0px 0px 0px;
}
.form-select .drop-select:focus {
  border: 1px solid transparent;
  border-bottom: 1px solid #dee2e6 !important;
  box-shadow: inherit !important;
}
.close-bttn {
  border: none;
  background: none;
  /* margin-left: 260px; */
  margin-top: 14px;
  float: right;
}

.topnav {
  overflow: hidden;
}
.topnav a {
  float: left;
  text-align: center;
  padding: 4px 30px;
  text-decoration: none;
  font-size: 15px;
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 12.133px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  position: relative;
  margin-bottom: 15px;
}

/* Create a right-aligned (split) link inside the navigation bar */
.topnav a.split {
  float: right;
  background-color: #04aa6d;
  color: white;
}

.tage-menu {
  background: #9be7ff;
  color: #000000;
  padding: 2px 36px 8px 20px;
  border-radius: 30px;
  justify-content: center;
  position: relative;
  display: inline-block;
  margin-right: 15px;

  height: 25px;
}

.tag-img {
  width: 20px;
  margin: 0px 0px 0px -25px;
  /* z-index: 1000 !important; */
}

.accordion-flush .accordion-item .accordion-button,
.accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0
    var(--bs-accordion-border-color);
}
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled),
button:not(:disabled) {
  cursor: pointer !important;
}
.accordion-button.tag {
  width: 100% !important;
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: #fff !important;
  box-shadow: none !important;
}
.accordion-button {
  width: 100% !important;
}

/*pv*/

button.update-btn.rounded.p-2.appro-btton-gray {
  float: right;
  background: gray;
}

button.update-btn.rounded.p-2.appro-btton {
  float: right;
  background: #3a68d8;
}

.Copy-Process-mod-inner {
  padding: 20px 25px 0px 25px;
}

button.submits-btn.rounded.p-2.sub-bttn-right-sides.temp-creat-bttn.on-temp.mx-2 {
  min-width: 118px;
  width: 100%;
  height: 35px;
}

button.submits-btn.rounded.p-2.sub-bttn-right-sides.e-vef-bttn-sub.on-temp.mx-2 {
  min-width: 118px;
  width: 100%;
  height: 35px;
}

button.btn.btn-primary.doct-upload {
  height: 30px;
  padding: 0px 7px 0px 7px;
  font-size: 12px;
}

/* Container for Toggle */
.toggle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  /*height: 100vh;
  background-color: #f0f0f0;*/
}

/* Hide the checkbox */
.toggle-input {
  display: none;
}

/* Toggle Background */
.toggle-label {
  width: 55px;
  height: 23px;
  /* background-color: #ccc; */
  border-radius: 50px;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s ease;

  border: 2px solid #3a68d8;
}

/* Circle inside the Toggle */
.toggle-circle {
  width: 20px;
  height: 20px;
  background-color: #3a68d8;
  border-radius: 50%;
  position: absolute;
  top: 1px;
  left: 0px;
  transition: transform 0.3s ease;
}

/* When Checkbox is Checked */
.toggle-input:checked + .toggle-label {
  /*background-color: #4caf50;*/
  border: 2px solid #3a68d8;
}

.toggle-input:checked + .toggle-label .toggle-circle {
  transform: translateX(30px);
}

.form-features-xy-wrapper {
    display: flex;
    gap: 1.5rem;
}

.form-features-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}
/* .container_main.containerSpace.mainWrap .componentScroll .sub-acc {
    width: 100% !important;
    max-width: 100% !important;
    position: sticky !important;
    right: 0;
    z-index: 1;
    top: 110px !important;
} */

/* .sub-acc.h-100.padSpace {
    position: sticky !important;
    right: 0 !important;
} */
.onb-actions.fontSty.edits-fil {
    display: flex;
    gap: 10px;
}
.onb-actions.fontSty.edits-fil .btn-primary {
       padding: 5px 10px;
    border-radius: 5px;
    border: 0;
    background: #979797;
    color: #fff;
}
.onb-actions.fontSty.edits-fil .btn-primary img {
    filter: brightness(0) invert(1);
    width: 16px;
}
.onb-actions.fontSty.edits-fil button, .onb-actions.fontSty.edits-fil a {
  font-size: 16px;
  font-weight: 400;
}
.form-features-xy-wrapper .sub-acc
 {
    /* width: calc(100% / 2) !important; */
    position: relative !important;
    max-width: 100% !important;
    flex: 1 1;
}
.sub-acc.padSpace.sticky-right {
    position: inherit;
    top: 100px;
}
.componentScroll .sub-acc.padSpace.sticky-right {
    position: fixed;
    width: 27% !important;
    max-width: 100% !important;
    right: 20px;
}
.f-btns doc .document-image {
    margin-right: 5px !important;
}
.col-md-5.d-flex.justify-content-between.up-down-btn {
    justify-content: flex-end !important;
    align-items: center;
    gap: 20px;
}
.form-features-xy-wrapper select {
    font-size: 14px !important;
}
.detail-user .iner-sc {
        height: 62.8vh !important;
    }
    .search.serach-width-div.col-md-6 a, .search.serach-width-div.col-md-6 button {
    min-width: 120px !important;
}

@media (max-width: 1745px) {
 .componentScroll .sub-acc.padSpace.sticky-right {
    width: 26.3% !important;
  }
      .detail-user .iner-sc {
        height: 60.5vh !important;
    }
}
@media (max-width: 1536px) {
  .componentScroll .sub-acc.padSpace.sticky-right {
    width: 25.3% !important;
  }
      .detail-user .iner-sc {
        height: 54.7vh !important;
    }
}
@media screen and (max-width: 1440px) {
  .componentScroll .sub-acc.padSpace.sticky-right {
    width: 24.5% !important;
  }
}
@media screen and (max-width: 1366px) {
  .componentScroll .sub-acc.padSpace.sticky-right {
    width: 23.8% !important;
  }
}
@media (max-width: 1280px) {
  .componentScroll .sub-acc.padSpace.sticky-right {
    width: 23.8% !important;
  }
      .detail-user .iner-sc {
        height: 46.5vh !important;
    }
}




/* Responsive Design */
@media (max-width: 768px) {
  .searchere.mb-0.serach-div.resours-div {
    margin-right: 10px;
  }

  .temp-top-section {
    display: inline-block !important;
    justify-content: space-between;
  }
  .toggle-label {
    width: 50px;
    height: 25px;
  }
  a.av-res {
    padding: 5px !important;
  }

  .toggle-circle {
    width: 22px;
    height: 22px;
    transform: translateX(23px); /* Adjusted for the smaller size */
  }

  .toggle-input:checked + .toggle-label .toggle-circle {
    transform: translateX(25px);
  }
}

.tableFixHead.first-tble-mytem {
  display: flex;
  flex-direction: column;
  /*height: 100vh;*/
}

.modal-width.dltPops:focus-visible {
  outline: none;
}

.para-fonts-match {
  font-size: 15px;
  margin-bottom: 20px;
}
.right-side-lable-match.mt-2 {
  display: flex;
  float: right;
}
.right-side-lable-match {
  display: flex;
  float: right;
}
.right-side-lable-match.mt-2x {
  display: flex;
  float: right;
}
.butts-div-photo-match {
  margin-top: 25px;
  margin-bottom: -10%;
}
section.formSect.txtfComp.mb-4:focus-visible {
  outline: none;
}
.ReactModal__Content.ReactModal__Content--after-open.tem-hide-dives:focus-visible {
  outline: none;
}
input.on-details-edits:focus-visible {
  outline: none;
}
button.download-icon.case-left-down-icon2 {
  display: flex;
  /* / justify-content: start; / */
  /* flex-direction: column; 
     left: -30px;*/
  position: relative;
  left: -25px;
  /* / right: 20px; / */
  top: 0px;
}

input.input-temp-edts:focus-visible {
  outline: none;
}
@media screen and (max-height: 713px) {
  .new-temp-onbord-main.my-3.py-5.px-4 {
    padding: 25px !important;
    min-height: 75vh;
  }
}

.createBg {
  min-height: 80vh;
  display: flex;
  align-items: center;
}

.create-process .tmpRadio input[type="radio"] {
  margin: 0 7px 0 0 !important;
  width: 20px !important;
}
button.btn.btn-primary.btn_wid.btn-check-and-submit {
  /* width: 100%; */
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  min-height: 50px;
  width: 100%;
  border: 1px solid #003aca;
  background: linear-gradient(
    265deg,
    #316af7 13.26%,
    rgba(0, 58, 202, 0.55) 96.34%
  );
  box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.25) inset,
    0px -2px 0px 0px #003aca inset;
}
.create-process.tmpRadio label {
  float: left;
  margin-right: 20px;
  font-size: 13px;
  font-weight: 500;
  color: #666666;
  font-family: Manrope;

  font-style: normal;

  line-height: normal;
}
.create-process .form-control {
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  min-height: 45px;
  padding: 5px 15px;
}

h3.card-title-cp {
  color: #302b3a;
  font-size: 24px;
  font-weight: 600;
  margin: 5px 0 15px;
}

.create-process .subTitle {
  color: #666666;
  font-size: 15px;
  font-weight: 500;
  margin: 5px 0;
}

.new-temp-onbord-main.my-3.py-5.px-4 {
  border: 1px solid #dfdfdf;
}
.create-process {
  border-radius: 20px;
  border: 1px solid #dfdfdf;
  background: #fff;
  max-width: 100%;
  width: 707px;
  margin: 0 auto;
  padding: 2.5rem;
  min-height: 60vh;
}

.create-process {
  min-height: 60vh;
}
select.procc-selet {
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  min-height: 45px;
  padding: 5px 15px;
  width: 100%;
}
select.procc-selet:focus-visible {
  outline: none;
}

label.pro-title {
  color: #666666;
  font-size: 15px;
  font-weight: 500 !important;
  margin-right: 20px;
}
/*.new-temp-onbord-main {
  border: 1px solid #DFDFDF;
  border-radius: 10px;
  background-color: #FFF;
  overflow: hidden;
  padding: 25px !important;
  min-height: 75vh;
}*/

a.create-comp-popup-text.box-left {
  padding: 10px;
  border-left: 5px solid transparent;
  margin-bottom: 10px;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

a.create-comp-popup-text.box-left:active {
  border-left-color: #007bff;
  background-color: #f0f8ff;
}
.everify-column-temp-head {
  float: left;
  width: 50%;
  padding: 13px;
  display: flex;
}
.everify-column-temp-head-one {
  float: left;
  width: 23%;
  padding-left: 30px;
  display: flex;
}
span.everify-head-temp-head {
  font-size: 15px;
  font-weight: 700;
}

.col-md-4.section {
  padding: 8px;
  background-color: #f8f9fa;
  /* border: 1px solid #dee2e6; */
  margin-bottom: 0px;
  width: 48%;
}

table.temp-head {
  border-collapse: collapse;
  width: 100%;
  position: relative;
  left: 25px;
}

img.archive-icon {
  width: 10%;
  margin: 7px;
}

button.btn.btn-link.case-bttnss {
  width: 15%;
  font-weight: 600;
  font-size: 14px;
  margin-left: -15px;
}

button.primary-bttn.bros-bttn {
  width: 15%;

  position: relative;
}

p.file-chose-img {
  position: relative;
  top: 8px;
}
input.bros-input {
  display: flex;
  position: relative;
  top: -35px;
  left: 0%;
  max-width: 195px;
  font-size: 33px;
  /* width: 100%; */
  max-height: 36px;
  padding: 2px;
  opacity: 0;
  right: 0;
}

button.primary-bttn.cont-gry-bttn {
  width: 15%;
  background: #ccc !important;
  color: black;
}

button.btn.btn-outline-primary.primay-linr-bttn:hover {
  color: white;
  background-color: #3a68d8;
}
button.btn.btn-outline-primary.primay-linr-bttn {
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  min-width: 100px;
  min-height: 35px;
  border-radius: 7px !important;
  line-height: inherit !important;
  width: 15%;
  color: #3a68d8;
}

button.primary-bttn {
  color: #fff;
  border: 0;
  width: 100%;
  justify-content: space-between;
  background: #3a68d8 !important;
  margin: 0px 12px 0px 0px;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  min-width: 100px;
  min-height: 35px;
  border-radius: 7px !important;
  line-height: inherit !important;
  width: 20%;
  /* float: right;*/
}

.dot-border {
  display: flex;
  border-bottom: dotted;
  border-bottom-color: #ccc;
  /* margin-bottom: 8px; */
}
.photo-text {
  font-weight: 600;
}
.photo-heading {
  color: #005288;
  font-size: 26px;
  font-weight: 600;
}

.form-floating.creat-form-inputss {
  width: 50%;
}
.cer-temps {
  padding: 4px 4px 4px 4px !important;
}

.hd-can.create-form-wrp.hegNew.formSect.mb-3.edits-divs {
  height: 14vh;
  position: relative;
  top: -30px;
  padding: 0px;
  width: 100%;
  border: none;
  background: none !important;
}
.trash-edit {
  /*float: right;
    right: 27%;
    position: absolute;
    display: flex;
  float: right;
  right: 5%;
  position: relative;
  display: flex;
  height: 20px;
  margin-top: 0px;
  width: 25%;*/

  float: right;
  /* right: 5%; */
  position: relative;
  display: flex;
  /*height: 20px;*/
  margin-top: 0px;
  width: 40%;
  color: #000;
}
.trash-edit:active,
.trash-edit:hover {
  color: var(--color1) !important;
}
.icons-ed {
  float: right;
  display: flex;
  width: 100%;
  justify-content: space-between;
}

th.last-handle-name {
  /*padding-left: 52px !important;*/
  padding: 0px 0px 8px 5px !important;
  width: 10%;
}
p.subHead.top-texts-create {
  display: flex;
  justify-content: space-between;
  float: left;
  margin-top: 10px !important;
  margin-left: 4px;
  margin-bottom: 0px;
}

.texts-save-bttn {
  width: 100%;
  margin: 0px 0px 0px 10px;
}

textarea.inpTxt.textArea.blkCl.pt-0.red-border {
  height: 5vh;
  /* padding-top: 20px; */
  /* border-radius: 50px !important; */
  height: 50px;
  padding-right: 22px;
  padding-left: 10px;
  padding-top: 15px !important;
  width: 85%;
  margin-bottom: 5px;
}

button.Save.top-save-bbtn {
  display: flex;
  float: right;
  position: relative;
  top: -45px;
  min-height: 40px;
}

.form-floating > label.font-enter-color {
  z-index: 0;
}
.form-control.text-class.delay-textarea-height.mt-2 {
  padding: 15px 0px 15px 15px;
  width: 100%;
  height: 180px;
  overflow: hidden;
  line-height: 25px;
}

.form-select.select-height.delay-sele-height {
  height: 50px !important;
  /*padding: 15px 0px 15px 15px;*/
  padding-top: 0px;
  line-height: normal;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form-floating.wraper.minH.mb-3.over-ride.delay-sele-height-div {
  left: 20px;
  margin: 0 auto;
  position: relative;
  width: 93%;
}

.full-box {
  display: grid;
  /*flex-wrap: wrap;
    flex-direction: row;*/
}
.match-border {
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  border-radius: 10px;
  padding: 20px;
}

.top-match-align {
  margin-top: -50px;
}
.box-two.mt-4 {
  display: grid;
}

.active-boxs {
  order: -1;
  flex: 1 0 100%;
  display: grid;
}

.close-final-bg {
  color: #080808;
  background-color: #f5f5f6;
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
  /* margin-bottom: 9px; */
}

.close-final-bg-list {
  color: #3a68d8;
  /* background-color: #d6e3ec; */
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
  /* margin-bottom: 9px; */
}

.open-final-bg-list {
  color: #3a68d8;
  /* background-color: #d6e3ec; */
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
  /* margin-bottom: 9px; */
}
.open-final-bg {
  color: #080808;
  background-color: #d6e3ec;
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
  /* margin-bottom: 9px; */
}

.employment-text-bg {
  background: #477326;
  color: white;
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;
}

.Final-text-bg {
  background: #c41230;
  color: white;
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;
}

.Resubmit-text-bg {
  background: #080808;
  color: white;
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;
}

.case-incom {
  background-color: #5a5b5d;
  color: white;
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;
}

p.common-padding {
  padding: 15px 0px 0px 0px;
}
.tent-non-bg {
  background-color: #ffbe2e;
  color: #080808;
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;
}

.emp-dhs-bg {
  background-color: #005288;
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}

.display-gds {
  display: grid;
}

.red-color-text {
  color: red;
}
button.dfan-btn.close.rounded.p-2.mt-2 {
  margin: 10px;
  background: #666;
  float: none;
}

.w4form-l.micmatch {
  margin: 3px 0px 0px 10px;
  font-size: 15px;
  display: contents;
}

input.form-check-input.radio-sizee.mis {
  margin: 2px 15px 15px 0px;
}
.after-mathw-divs {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 10px;
}

ul.if-mathew li {
  list-style: disc;
  margin-left: 20px;
}

button.dfan-btn {
  color: #fff;
  border: 0;
  /* width: 100% !important; */
  justify-content: space-between;
  background: #3a68d8;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  /* min-width: 260px; */
  min-height: 42px;
  border-radius: 7px !important;
  line-height: inherit !important;
  background: #3a68d8;
  margin: 0 12px 0 0;
  width: 100%;
  width: 25%;
}

button.dfan-btn.rounded.Download-Notice.p-2 {
  color: #fff;
  border: 0;
  /* width: 100% !important; */
  justify-content: space-between;
  background: #3a68d8;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  min-width: 260px;
  min-height: 42px;
  border-radius: 7px !important;
  line-height: inherit !important;
  width: 30%;
}

.col-6.on-everify {
  float: right;
  margin-right: 10px;
}
.everify-column {
  float: left;
  width: 25%;
  padding: 5px;
}
span.everify-head {
  font-size: 15px;
  font-weight: 600;
}

p.everify-head-para {
  font-size: 12px;
  font-weight: 400;
}

.heading-everify {
  font-size: 15px;
}
.heading-para-everify {
  font-size: 12px;
}

table.table.everify-mains {
  border-collapse: separate;
}
.tble-everify {
  padding: 15px;
}

.alignTops.e-verify.mb-0.p-3 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf) !important;
}

img.caselogoi9-are-top {
  width: 10%;
  float: left;
}

button.submits-btn.rounded.p-2.sub-bttn-right-sides-ev {
  color: #fff;
  border: 0;
  width: 100%;
  justify-content: space-between;
  background: #3a68d8;
  min-width: 140px;
  min-height: 35px;
}

button.submits-btn.rounded.p-2.sub-bttn-right-sides-ev.Contine-Case {
  width: 92% !important;
}

.col-3.on-everify {
  float: right;
}
.mx-auto.main-padds {
  padding: 0px 5px 5px 5px;
}

.all-caselogo {
  /*  width: 100%;
    display: flex; */
  /* justify-content: space-between; */
  /* float: left; 
     max-width: 80px;*/

  /* position: relative; */
  top: 18px;
  height: 17px;
}
button.submits-btn.rounded.p-2.sub-bttn-right-sides-download-ev {
  color: #fff;
  border: 0;
  width: 100%;
  margin: 0px 15px 0px 0px;
  justify-content: space-between;
  background: #666666;
  min-width: 140px;
  min-height: 35px;
}

button.submits-btn.rounded.p-2.sub-bttn-right-sides-download {
  color: #fff;
  border: 0;
  width: 100%;
  justify-content: space-between;
  background: #666666;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  min-width: 100px;
  min-height: 35px;
  border-radius: 7px !important;
  line-height: inherit !important;
  width: 10%;
  float: right;
}

button.submits-btn.rounded.p-2.sub-bttn-right-sides {
  color: #fff;
  border: 0;
  width: 100%;
  justify-content: space-between;
  background: #3a68d8;
  /* margin: 0px 12px 0px 0px;*/
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  min-width: 100px;
  min-height: 35px;
  border-radius: 7px !important;
  line-height: inherit !important;
  width: 15%;
  float: right;
}

/*button.submits-btn.rounded.p-2.sub-bttn-right-sides.e-vef-bttn-sub {
    color: #fff;
    border: 0;
    width: 100%;
    justify-content: space-between;
    background: #3A68D8;
    margin: 0px 12px 0px 0px;
    text-align: center;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: 'Manrope', sans-serif;
    min-width: 100px;
    min-height: 42px;
    border-radius: 7px !important;
    line-height: inherit !important;
    width: 20%;
    float: right;
}*/
.fonts-styless {
  font-weight: 700;
  font-family: serif;
}

input:focus-visible {
  /*outline: red;*/
  border: var(--bs-border-width) solid var(--bs-border-color);
}
.form-select.drop-filter.customFilt.select-box {
  height: 40px;
  overflow-y: auto;
  width: 150px;
}
.form-select.drop-filter.customFilt.option {
  overflow-y: scroll;
}

.input-group-append.pass-div-width {
  width: 100% !important;
  height: 60px !important;
}
.eye-img {
  width: 20px;
}
span.count-t-details {
  background: red;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 40px;
  color: #fff;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0px 7px 0px 0px;
  padding: 10px;
  font-size: 12px;
}

.mesg-cht {
  color: #302b3a;
  font-size: 16px;
  font-weight: 500;
  padding: 20px 4px 3px 20px;
}
span.count-t-mesg {
  background: red;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 40px;
  color: #fff;
  align-items: center;
  display: flex;
  justify-content: center;
  float: right;
  font-size: 12px;
}
.bold-name {
  color: var(--avenu-black, #302b3a);
  font-family: Manrope, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
}
.pop-app {
  margin-bottom: 0px !important;
  color: var(--avenu-black, #302b3a);
  font-family: Manrope, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
}

.inbox_people {
  background: #f8f8f8 none repeat scroll 0 0;
  float: left;
  overflow: hidden;
  width: 40%;
  border-right: 1px solid #c4c4c4;
}
.inbox_msg {
  border: 1px solid #c4c4c4;
  clear: both;
  overflow: hidden;
}
.top_spac {
  margin: 20px 0 0;
}

.recent_heading {
  float: left;
  width: 40%;
}
.srch_bar {
  display: inline-block;
  text-align: right;
  width: 60%;
}
.headind_srch {
  padding: 10px 29px 10px 20px;
  overflow: hidden;
  border-bottom: 1px solid #c4c4c4;
}

.recent_heading h4 {
  color: #05728f;
  font-size: 21px;
  margin: auto;
}
.srch_bar input {
  border: 1px solid #cdcdcd;
  border-width: 0 0 1px 0;
  width: 80%;
  padding: 2px 0 4px 6px;
  background: none;
}
.srch_bar .input-group-addon button {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  padding: 0;
  color: #707070;
  font-size: 18px;
}
.srch_bar .input-group-addon {
  margin: 0 0 0 -27px;
}

.chat_ib h5 {
  font-size: 15px;
  color: #464646;
  margin: 0 0 8px 0;
}
.chat_ib h5 span {
  font-size: 13px;
  float: right;
}
.chat_ib p {
  font-size: 14px;
  color: #989898;
  margin: auto;
}
.chat_img {
  float: left;
  width: 11%;
}
.chat_ib {
  float: left;
  padding: 0 0 0 15px;
  width: 88%;
}

.chat_people {
  overflow: hidden;
  clear: both;
}
.chat_list {
  border-bottom: 1px solid #c4c4c4;
  margin: 0;
  padding: 18px 16px 10px;
}
.inbox_chat {
  height: 550px;
  overflow-y: scroll;
}

.active_chat {
  background: #ebebeb;
}

.received_msg {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 92%;
}

button.btn.btn-info.btn-lg.mesg-bttn {
  background: none;
  border: none;
}

.borders-part {
  border: 1px solid #ddd !important;
  padding: 10px 0px 10px 15px;
}
.modal-text-blue {
  /* padding: 15px 0px 0; */
  margin: 0;
  /* font-size: 18px; */
  /* font-weight: 600; */
  color: #316af7 !important;
}

.user_registration_details ul {
  list-style-type: none;
  border: 1px solid #ddd;
  padding: 5px 20px;
}
.question-text {
  background-color: #e9ecef85;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.5rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  padding: 5px 10px;
  word-break: break-all;
  width: -moz-fit-content;
  width: fit-content;
}

.user_registration_details ul li {
  margin-bottom: 2px;
}

.mesgs {
  float: left;
  padding: 10px 15px 0 0px;
  width: 100%;
}

.sent_msg p {
  background-color: #316af7;
  border-color: #316af7;
  padding: 5px 10px;
  display: inline-block;
  border-radius: 0.5rem;
  color: #fff;
}

.outgoing_msg {
  overflow: hidden;
  margin: 26px 0 26px;
}
.sent_msg {
  float: right;
  /* width: 46%; */
}
.input_msg_write input {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  color: #4c4c4c;
  font-size: 15px;
  min-height: 48px;
  width: 100%;
}

.type_msg {
  border-top: 1px solid #c4c4c4;
  position: relative;
}
.msg_send_btn {
  /* background: #05728f none repeat scroll 0 0;*/
  border: medium none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 17px;
  height: 33px;
  position: absolute;
  right: 0;
  top: 11px;
  width: 33px;
}
.messaging {
  padding: 0 0 50px 0;
}
.scrol-app {
  width: 100%;
}

.modal-text-textarea.borders-part {
  border: 1px solid #626262;
  margin-left: 25px;
  /* margin-right: 20px; */
  width: 90%;
  margin-top: 15px;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  max-width: 400px;
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
}
.mesg-icon {
  width: 22px;
  height: 22px;
}

.accordion-toggle {
  display: none;
}

.accordion-button {
  background-color: #f4f4f4;
  border: none;
  cursor: pointer;
  padding: 10px;
  width: 100%;
  text-align: left;
}

.accordion-content {
  background-color: #f9f9f9;
  padding: 10px;
  display: none;
}

.accordion-toggle:checked + .accordion-button + .accordion-content {
  display: block;
}

tr:not(:last-child) .accordion-content {
  border-bottom: 1px solid #ddd; /* Optional: Add border between rows */
}
span.usernamelogout-arrow {
  color: var(--avenu-black, #302b3a);
  font-family: Manrope, sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-left: 10px;
}

.usernamelogout-arrow .dropdown .dropdown-toggle:after {
  border-bottom: 0;
  border-left: 0.3em solid transparent !important;
  border-right: 0.3em solid transparent !important;
  color: red;
  margin: 0 0 0 6px;
}
.mobile-over-divz {
  display: none;
}

.over-divz {
  display: flex;
}
.i9-text {
  color: #d15d49;
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 7px 0px 0px 10px;
}
button.btn.btn-success.Overrided-bttn {
  border-radius: 300px !important;
  background: #d15d49 !important;
  color: white !important;

  border: none !important;

  height: 35px !important;
  /* padding: 6px; */
  margin: 0px 0px 0px 15px !important;
}

.dropbtn {
  background-color: #04aa6d;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-contentside.form-menus a {
  color: white;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-family: Manrope !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0px 0px 0px 15px;
}
.dropdown-contentside.form-menus {
  display: block;
  background: none !important;
  position: relative;
  width: 100%;
  /* height: 300px;
     color: white; */
  border: none;
  margin-top: 15px;
}

.tempops-border {
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: #fff;
  height: 83vh;
}
h6.create-comp-popup-text-heading.pops-text-width {
  /*width: 100%;
   display: flex;
   */

  float: right;
}
.create-comp-popup-text-heading-not-found.temple-edits-cen {
  text-align: center;
}
.wraper.scrlHe-tab.scroll.scroll1.temppos-height {
  height: 63vh;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 135px;
  /* box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2); */
  z-index: 1;
  font-size: 12px;
  border: 1px solid #cccc;
  border-radius: 15px;
  height: 40px;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.alignHead_review.right-side-align {
  justify-content: flex-end;
}

.popup {
  margin: 75px auto;
  padding: 20px;
  background: #fff;
  border: 1px solid #666;
  width: 300px;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.5);
  position: relative;
  .light & {
    border-color: #aaa;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
  }
  h2 {
    margin-top: 0;
    color: #666;
    font-family: "Trebuchet MS", Tahoma, Arial, sans-serif;
  }
  .close {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 20px;
    right: 20px;
    opacity: 0.8;
    transition: all 200ms;
    font-size: 24px;
    font-weight: bold;
    text-decoration: none;
    color: #666;
    &:hover {
      opacity: 1;
    }
  }
  .content {
    max-height: 400px;
    overflow: auto;
  }
  p {
    margin: 0 0 1em;
    &:last-child {
      margin: 0;
    }
  }
}
button.btn.btn-success.comp-bttn {
  color: white !important;
  background: #2ebf2e !important;
  border: none !important;
  border-radius: 20px !important;
  height: 35px !important;
  /* padding: 6px; */
  margin: 0px 0px 0px 15px !important;
}

button.dropbtn {
  width: 100%;
  background: none;
  border: none;
}

.three-dots-img {
  width: 25px;
}
.name-alin {
  display: contents;
}
.edit_icon.ml-2 {
  background: none !important;
  border: none;
  width: 30px;
}
/* .new-spans{
    background-color: red;
    /* width: 10%; 
    border-radius: 20px;
    display: flex;
    /* text-align: center; 
    padding: 10px;
    height: 18px;
 }*/

.list-group-item:first-child {
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}

.list-group-item:last-child {
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}
.profie-width {
  width: 85%;
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 0px 0px 0px 0px;
}
.new-letter {
  background-color: red;
  border-radius: 30px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  margin-right: 5px;
  padding: 1px 7px;
  margin-bottom: 0px;
}
.tableFixHead {
  overflow-y: scroll;
  /*height: 280px; */
}
.tableFixHead thead th {
  position: sticky;
  border-bottom: 1px solid #f0f0f0;
  top: 0px;
}

.sub-fonts-stylez {
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

button.aligmt-icon {
  border: none;
  background: none;
}

/*.btn-group .aligmt-icon-divx:hover ,.btn-group .aligmt-icon-divx:active{    
    border: 1px solid red;
}
.img-div-actives :active{ border: 1px solid red;}*/

.img-alignWraper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btn-group.aligmt-icon-divx {
  width: auto;
}

.icon-trash {
  cursor: pointer;
}

.btn-group.aligmt-icon-divx .aligmt-icon.active {
  border: 1px solid #ccc;
  width: 40px;
  border-radius: 5px;
  padding: 5px 5px;
  height: 35px;
  line-height: 20px;
}
.btn-group.aligmt-icon-divx .aligmt-icon {
  margin: 0;
  width: 40px;
  border-radius: 5px;
  padding: 5px 5px;
  height: 35px;
  line-height: 20px;
  border: 1px solid transparent;
}

.btn-group.aligmt-icon-divx .aligmt-icon img {
  margin: 0;
  width: 21px;
  height: auto;
}

.image-sizes-small {
  max-width: 30%;
  max-height: 200px;
  /* height: auto;
  width: auto; */
}
.image-sizes-medm {
  max-width: 50%;
  /* height: auto; */
  /* width: auto; */
  max-height: 400px;
}
.image-sizes-large {
  max-width: 100%;
  /* height: auto;
  width: auto; */
  max-height: 600px;
}

.imgs-right-algment {
  float: right;
}
.imgs-center-algment {
  float: center;
}
.imgs-left-algment {
  float: left;
}

.divs-left-algment {
  text-align: left;
}
.divs-center-algment {
  text-align: center;
}

.divs-right-algment {
  text-align: right;
}

/*.rightCont.top-id-fixes {
    margin-top: 95px;
}*/
.image-size {
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf) !important;
  background: var(--White, #fff);
  /* display: flex; */
  padding: 5px 10px;
  margin-left: 10px;
  /* font-size: 15px; */
  /* font-weight: 400; */
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.image-name {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: contents;
}

.aligmt-icon {
  width: 100%;
  margin-bottom: 10px;
}
.review-pre-cand-link:hover {
  color: blue;
  cursor: pointer;
}
.rdw-colorpicker-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 175px;
  height: 175px;
  border: 1px solid #f1f1f1;
  padding: 15px;
  border-radius: 2px;
  z-index: 10000000000 !important;
  background: white;
  box-shadow: 3px 3px 5px #bfbdbd;
}

.rdw-link-modal {
  background: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 2px;
  box-shadow: 3px 3px 5px #bfbdbd;
  display: flex;
  flex-direction: column;
  height: 205px;
  left: 5px;
  padding: 15px;
  position: absolute;
  top: 35px;
  width: 235px;
  z-index: 100000000000000 !important;
}

.deletBtns .Actsbtn,
.deletBtns:hover .bfsBtn {
  display: none;
}

.deletBtns:hover .Actsbtn {
  display: inline-block;
}

.leftDivs {
  width: 75%;
}
.pass-inpt {
  border: 1px solid #dfdfdf;
  /* background: unset; */
  border-right: none;
}
.input-group-append.pass-div-width {
  width: 60%;
}
img.top-drp {
  width: 100%;
  /* height: 15px; */
  min-width: 15px;
}
.align-div-edits {
  position: absolute;
  left: 10%;
  right: 0%;
  /* transform: translate(-50%, -50%); */
  /* width: 100%; */
  top: 55%;
}

.border-divs-edits {
  border: 2px dashed #3a68d8;
  height: 100vh;
}

.two-bttnn-pdf .e-scroll-left-nav,
.two-bttnn-pdf .e-scroll-right-nav {
  display: none;
}
.two-bttnn-pdf .e-control,
.two-bttnn-pdf .e-toolbar-items,
.two-bttnn-pdf .e-lib .two-bttnn-pdf .e-hscroll {
  display: inline-block !important;
}

.e-toolbar
  .e-toolbar-items
  .e-hscroll-bar
  .e-hscroll-content
  .e-toolbar-right
  .e-toolbar-item {
  margin: 0;
  display: grid !important;
}
.two-bttnn-pdf {
  margin-top: 40px;
  display: flex;
  flex-direction: inherit;
}

.background-img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100%;
  height: 100vh;
}
.sign-padd-preview {
  margin-top: 45px;
}

.iner-sc.candScroll.scrlHe-tab.top-space-tag.scroll1.top-spaceing {
  margin: 0px 0px 0px 0px !important;
}

.action-itms .padd-review-inner {
  padding: 15px 0px;
}

.action-itms .padd-review-page {
  padding: 0px 0px 0px 0px !important;
}

.task-count.rev-marg-lft {
  margin: 0px 20px 0px 0px !important;
}

.buildsubHead {
  color: var(--gray-accessible-text, #666);
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.buildHead {
  color: var(--Avenu-Black, #302b3a);

  font-family: Manrope;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.filter-main-div {
  display: flex;
}

#page-no-border {
  border: 1px solid #ccc;
}

ul.MuiList-root.MuiList-padding {
  /* height: 100vh;*/
  padding-bottom: 0;
}

.trag-list-build {
  min-height: 900px;
  width: 100%;
  /* overflow: auto; */
}

div#container_sideBarToolbarSplitter {
  height: 100% !important;
}
.line-under {
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  margin-bottom: 20px;
}
.check-tetxz {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.review-texts {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 20px;
}

/*.container_main.containerSpace.mainWrap {
    background: #FBFBFB;
}*/

.padd-ajust {
  padding: 0px !important;
}
.build-choose {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: contents;
}

.e-pv-viewer-main-container {
  background-color: white !important;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  /* border: none; */
}
.modal-text1.text-marg {
  margin: 0;
}

.ReactModal__Content.ReactModal__Content--after-open .modal-width hr {
  margin-bottom: 0;
  margin-top: 0.7rem;
}

.trash-icon-popups {
  float: right;
  width: 100%;
  min-width: 20px;
}

.form-select .drop-filter {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ReactModal__Overlay.ReactModal__Overlay--after-open .scrlHe-tab {
  margin-top: 0;
}

.main-filter {
  /*display: flex;
    margin: 0px 15px 0px 0px;
    align-items: center;*/

  display: flex;
  margin: 0px 23px 0px 0px;
  align-items: center;
  display: flex;
  width: 100%;
  padding: 10px;
  align-items: center;
  /* gap: 10px; */
  /* align-self: stretch; */
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: #fff;
}
select.form-select.drop-filter {
  /* width: 150px;*/
  height: 35px;
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-overflow: ellipsis;
}

.filter-name {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
}
li.list-group-item.same-line {
  display: flex;
  /*justify-content: space-between;*/
  border: none;
}
li.list-group-item.same-line.rigt-alginn {
  justify-content: space-between;
}
.filterAlign {
  width: 100%;
}
.searchere.mb-0.serach-div {
  /* width: 387px;*/

  align-items: center;
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: #fff;
  height: 55px;
  justify-content: flex-end;
  display: flex;
}
.underline {
  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf);
  width: 100%;
  display: flex;
  padding: 15px 20px;
}

span.e-tbar-btn-text {
  color: #666 !important;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.doct-name-save-bttn {
  width: 100%;
  display: flex;
}
.hd-can.create-form-wrp.box-height {
  min-height: 40px !important;
}
input#currentPage {
  border-radius: 5px;
  border: 1px solid #dfdfdf;
  display: flex;
  width: 39px;
  height: 39px;
  padding: 8px 10px;
  justify-content: center;
}

button#form_designer {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-repeat: no-repeat !important;
  border-left: 1px solid #ccc;
  padding: 0px 0px 0px 30px;
  height: 30px;
}

button#next_page {
  border-right: 1px solid #ccc;
}
button#file_Open {
  border-right: 1px solid #ccc;
}
button#chooseTemplates {
  border-right: 1px solid #ccc;
}
.e-control.e-toolbar.e-lib.e-keyboard {
  margin-top: 12px;
}
.e-pdf-toolbar.custIcons.bottom-space {
  margin-bottom: 12px;
}

.e-toolbar .e-toolbar-item .e-tbar-btn {
  background: none !important;
  box-shadow: none;
  color: rgba(0, 0, 0, 0.87);
  border: none;
}
.e-toolbar {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background: none !important;
  border: 1px none rgba(0, 0, 0, 0.12);
  box-shadow: none;
}
.doct-divz {
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  padding: 0px;
  background: none;
}

.doct-upload-div .control-section.doct-divz {
  border-radius: 10px 10px 0 0;
}

.doct-upload-div {
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
  /* display: flex; */
  padding: 20px;
  /* flex-direction: column; */
  align-items: center;
}

span.tooltiptext.lock-tip {
  right: 40px;
  bottom: -70px !important;
  top: -20px;
  height: 65px;
  min-width: 260px;
}

button.resetform-btn {
  color: #3a68d8;
  border: 0;
  width: auto;
  min-width: 100px;
  justify-content: space-between;
  /* background: #3A68D8; */
  text-align: center;
  font-size: 15px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  margin-left: 10px;
  background: none !important;
  text-decoration-line: underline;
  font-weight: 600;
}

/* .ReactModal__Content.ReactModal__Content--after-open {
    width: 35% !important;
} */
.notes-title {
  font-size: 15px;
  font-weight: 500;
}

img.dragBtn-fist.mrR {
  width: 6px !important;
  margin: 0 !important;
}

span.tooltiptext.edit-tip {
  min-width: 100px;
}

.filetext-img {
  width: 18px;
  margin-left: 10px;
  margin-left: 10px;
  width: 100%;
  max-width: 13px;
}

.rdw-link-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  min-height: 230px !important;
  border: 1px solid #f1f1f1;
  padding: 15px;
  border-radius: 2px;
  z-index: 10000000000000;
  background: white;
  box-shadow: 3px 3px 5px #bfbdbd;
}
.modal-check-bttn {
  margin: -20px 0px 0px -5px;
  padding: 20px;
}
.check-space {
  margin: 5px;
}
.onboard-text-popup {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 10px;
}

.tempList.create-comp-temp {
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
  display: flex;
  padding: 15px 20px;
  /* flex-direction: column;
    align-items: center;*/
}
.adds-sub-text {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

button.thank-close-button {
  /* max-width: 61%; */
  min-width: 85px;
  width: auto;
  min-height: 40px;
  border: 1px solid var(--Active-State, #3a68d8);
  color: var(--White, #fff);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  /* padding: 11.761px 25.234px; */
  border-radius: 10px;
  background: var(--Active-State, #3a68d8);
  outline: 0;
  box-shadow: inherit;
}
.card-1 {
  text-align: center;
  padding: 70px;
}
.thanku-sub-heading {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: justify;
  margin: 10px;
}
.thanku-text {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
  margin-bottom: 10px;
}

.thanku-cards {
  min-height: 260px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  flex-shrink: 0;
  border-radius: 10px;
  border: 0.776px solid var(--light-gray-outline, #dfdfdf);
  /*background: var(--White, #FFF);*/
  width: 40%;
  margin: 12rem auto;
  text-align: center;
}

.form-floating.doc_form input {
  padding: 0.5rem 0.75rem !important;
}

/*.img-divs{
    width: 70%;
    margin: auto;
}*/

.modal-footer.footer-marg-pdf {
  margin: -25px 10px 0px 0px;
  padding: 10px;
}

.modal-footer.footer-marg {
  margin: 0;
  padding: 1rem 20px 20px;
}

.pad-20 {
  padding: 20px;
}

.all-candidate-list {
  text-align: center;
}

.or-text {
  color: var(--gray-accessible-text, #666) !important;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0px 0px 0px 0px;
}

.choose-text {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-radius: 10px;
  border: 1px solid var(--graphic-objects-components-wcagaa, #949494);
  background: var(--White, #fff);
}

a.createa.form {
  cursor: pointer;
  color: #666;
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-bottom: 1px solid #dfdfdf !important;
  text-decoration: none !important;
  /*border-bottom: 1px solid #DFDFDF !important;*/
}
.modal-dialog.modal-dialog-centered.boz-width {
  max-width: 50%;
}

.font-enter-color {
  color: #a4a4a4;
  font-family: "Manrope", sans-serif !important;
}

/*button.btn.btn-primary.mx-2 {
    background: var(--Active-State, #3A68D8);
    padding: 5.761px 25.234px;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
    border-radius: 10.093px;
    width: 50%;
    height: 40px;
}
*/

.text-ends {
  text-align: left;
  padding-left: 20px !important;
  /*display: flex;*/
}

.col-lg-6.text-ends {
  margin-top: -29px;
}

.form-control .inputs-text-size {
  font-size: 15px;
  margin: -20px 0px 0px 0px;
  color: #a4a4a4;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
label.form-label.name-size {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 9px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 12px;
}
.addCand select.form-select {
  min-height: 53px;
  border-radius: 8px;
  border: 0.899px solid var(--light-gray-outline, #dfdfdf);
  font-size: 15px;
  font-weight: 500;
  font-family: "Manrope", sans-serif;
}
.form-group-default {
  display: flex;
  width: 100%;
  padding: 6.989px 13.967px;
  align-items: flex-start;
  align-content: flex-start;
  gap: 7.473px;
  align-self: stretch;
  flex-wrap: wrap;
  border-radius: 8px;
  border: 0.899px solid var(--light-gray-outline, #dfdfdf);
  background: #fff;
}
.archi-labels {
  margin-left: 20px;
}
.archi-text {
  color: var(--gray-accessible-text, #666);
  font-family: Manrope;
  margin-left: 20px;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
button.update-btn-archive {
  color: #fff;
  border: 0;
  width: auto;
  justify-content: space-between;
  border-radius: 10.093px;
  background: #3a68d8;
  margin: -8px 25px 0px 70px;
  text-align: center;
  min-width: 80px;
  font-size: 15px;
}

.Cancel-pop {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
  border: none;
  background: none;
}

.form-group-default.focused {
  background-color: #f0f0f0;
}

.form-group-default.required:after {
  color: #f55753;
  content: "*";
  font-family: "Manrope", sans-serif;
  font-size: 20px;
  position: absolute;
  right: 12px;
  top: 6px;
}

.form-group-default .form-control {
  border: 0;
  padding: 0;
  margin-top: -24px;
  background: 0 0;
  border-radius: 0;
  resize: vertical;
  font-size: 15px;
  font-weight: 500;
  font-family: "Manrope", sans-serif;
}

.form-group-default .form-control:not(textarea) {
  height: 25px;
  min-height: 25px;
}

.form-group-default .form-control:focus {
  outline: 0 !important;
  box-shadow: none;
}

.form-group-default .control-label {
  margin: 0;
  display: block;
  line-height: 20px;
  margin-bottom: 2px;
  opacity: 1;
  transition: opacity 0.2s ease;
}

.form-group .control-label {
  font-size: 10.5px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 500;
}

.form-group-default .custom-select.is-invalid,
.form-group-default .form-control.is-invalid,
.was-validated .form-group-default .custom-select:invalid,
.was-validated .form-group-default .form-control:invalid {
  box-shadow: none;
  border-bottom: 1px solid #dc3545;
}

.form-group-default .custom-select.is-valid,
.form-group-default .form-control.is-valid,
.was-validated .form-group-default .custom-select:valid,
.was-validated .form-group-default .form-control:valid {
  box-shadow: none;
}

/* imp */

label.form-label.job-text {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.under-line-add {
  width: 100%;
  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
  margin: 50px 0px 0px -20px;
  display: flex;
  position: absolute;
}

.preview-bck-icon {
  width: 25px;
  top: 0;
  left: 0;
  position: absolute;
  margin: 20px 0px 0px 35px;
  z-index: 9999;
  cursor: pointer;
}

.text-choose-margn {
  margin: 0px 0px 0px 10px;
}

.per-align {
  margin-left: 45px;
  text-align: center;
  font-weight: 600;
  font-size: 15px;
}
textarea#floatingTextarea {
  height: 20px !important;
  width: 60%;
}

.sub-head-color {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.pdf-scrolls {
  max-height: 80vh;
  overflow-y: scroll;
}

.Spinnerbackground {
  background-color: #fff;
}

.userarea.new.review-div {
  position: absolute;
  right: 25px;
  top: 17px;
  z-index: 0;
}
.dele-icon {
  width: 17px;
}

.scroll {
  width: 20px;
  height: 200px;
  overflow: auto;
  float: left;
  margin: 0 10px;
}

.scroll1::-webkit-scrollbar {
  width: 5px;
}

.scroll1::-webkit-scrollbar-track {
  background: #ddd;
}

.scroll1::-webkit-scrollbar-thumb {
  background: #666;
}

.move-div {
  padding-top: 10px;
  max-height: 225px !important;
  width: 100%;
  overflow-y: scroll !important;
  margin-top: 20px;
}

.icon-dele {
  margin-top: -35px;
  float: right;
  width: 2%;
}
.main-verif {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-verif .algOtps {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-verif img.verifi-code-imgs {
  width: 19px;
  margin: 0 7px;
}
.verifi-code-no p {
  margin: 0;
}
/*.chk-text{margin: 52px 0px 0px 0px !important;}*/

.modal-delect-text.txtFonts {
  /* font-size: 18px;*/
  letter-spacing: 0.2px;
  font-size: 15px;
}

.modal-delect-text {
  padding: 15px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  text-align: center;
  justify-content: center;
}

.add-btn {
  cursor: pointer;
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.footer_collapse.mt-2 p {
  transform: translate(6%, 0);
  font-size: 13px;
}
.Powered-by-text {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0px 10px -5px 0px;
}

.verifi-code-text {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  float: left;
  margin: 0px;
}
.outerWidth .spaceWidth {
  display: flex;
  align-items: center;
  width: 500px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 10px 15px;
}
.verifi-code-no {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.rating {
  margin: 0px 0px 0px 0px;
}

.resend-text {
  color: var(--Active-State, #3a68d8);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  float: right;
  margin: 0;
}

.otp-field {
  flex-direction: row;
  column-gap: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.otp-enter {
  width: 100%;
  justify-content: center;
}

.otp-field input {
  height: 62px;
  width: 12%;
  border-radius: 6px;
  outline: none;
  font-size: 1.125rem;
  text-align: center;
  border: 1px solid #ddd;
}
.otp-field input:focus {
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
}
.otp-field input::-webkit-inner-spin-button,
.otp-field input::-webkit-outer-spin-button {
  display: none;
}

.input-size {
  width: 50px;
  height: 50px;
}

.line-border {
  width: 100%;
  border-top: 2px solid #f6f6f6;
  margin: 35px 0 0;
}
.text-padd {
  padding: 30px;
}
.action-itms.full-drp.inner-scrll {
  /*overflow: scroll;
    height: auto;
    display: flex;
    margin-bottom: 25px !important;
    position: relative;
    padding: 25px 0px 0px 0px !important;*/
  max-height: 345px;
  display: block;
  margin-bottom: 25px !important;
  position: relative;
}
.cards.has-text-centered {
  position: relative;
  margin: -30px auto;
  width: 800px;
  max-width: 100%;
  min-height: 520px;
  border-radius: 10px;
  border: 0.776px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
  transform: translate(0%, 30%);
}

/* .cards-otp.has-text-centered {
    position: absolute;
    margin: 23vh auto;
    right: 0;
    bottom: 0;
    left: 0;
    width: 35%;
    height: 445px !important;
    border-radius: 10px;
    border: 0.776px solid var(--light-gray-outline, #DFDFDF);
    background: var(--White, #FFF);
    top: 0%;
    
} */

/*.otp-page {
 
    padding: 10% 0 0;
  
    margin: auto;
    display: flex;
    justify-content: center;
}*/

.otp-body {
  position: relative;
  z-index: 1;
  background: #ffffff;
  max-width: 100%;
  margin: 0 auto 100px;
  padding: 0px;
  text-align: center;
  border-radius: 10px;
  border: 0.776px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
}

.otp-enter input[type="tel"] {
  width: 65px !important;
  height: 70px !important;
  flex-shrink: 0;
  border-radius: 15px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
  margin: 0 10px !important;
  font-style: italic;
  max-width: 100%;
}

.register-form {
  margin-bottom: 0px;
  padding: 40px;
}
.need-text {
  display: flex;
  width: 100%;
  min-height: 72px;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  padding: 25px 0;
}

button.otp-button {
  max-width: 100%;
  width: 500px;
  min-height: 40px;
  border: 1px solid var(--Active-State, #3a68d8);
  color: var(--White, #fff);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  padding: 10px 25px;
  border-radius: 10px;
  background: var(--Active-State, #3a68d8);
  outline: 0;
  box-shadow: inherit;
}

.need-text .message {
  color: var(--Active-State, #3a68d8);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
}

.otp-text {
  color: var(--gray-accessible-text, #666);
  text-align: center;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.otp-no {
  color: var(--Active-State, #3a68d8);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.wel-text-one {
  align-self: stretch;
  color: var(--gray-accessible-text, #666);
  text-align: center;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.welcome-text {
  color: var(--Avenu-Black, #302b3a);
  margin: 20px 0;
  font-family: "Manrope", sans-serif;
  font-size: 34px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
}
.cardPost {
  position: absolute;
  bottom: 20px;
  left: 0;
}

.userarea .dropdown .dropdown-toggle:after {
  /*border-bottom: 0;
    border-left: 0.3em solid transparent !important;
    border-right: 0.3em solid transparent !important;
    border-top: 0.3em solid #949494 !important; */
  border-bottom: 0;
  border-left: 0.3em solid transparent !important;
  border-right: 0.3em solid transparent !important;
  /* border-top: 0.3em solid #949494 !important; */
  color: #fff;
  margin: 0px 0px 0px 6px;
}
.userarea .dropdown span.username img {
  display: none;
}

.count-number {
  /* font-size: 15px;
    font-weight: 600;
    text-align: center;*/
  /* align-items: center; */
  /* justify-content: center; */
  /*color: #fff;
    margin: 0px 0px 0px -2px;*/
  /*font-size: 15px; */
  /* font-weight: 600; */
  /* text-align: center; */
  /* align-items: center; */
  /* justify-content: center; */
  /* color: #fff; */
  margin: 0px 0px 0px -2px;
  /* background: #3A68D8; */
  line-height: 31px;
  /* min-width: 30px; */
  /* height: 30px; */
  /* border-radius: 60px; */
  display: inline-block;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  padding: 0 7px;
  margin-left: 8px;
}

.toast-message {
  background-color: #fff;
  color: #000;
  font-size: 20px;
  padding: 1rem 0.5rem;
  transform: translate(-50%, -50%);
  top: 120px !important;
  left: 50%;
  z-index: 4;
}

.right-align {
  display: flex;
  align-items: center;
}

.doc-name {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.doc-img-review {
  width: 100%;
}

.dropbtn {
  padding: 10px;
  font-size: 15px;

  width: 205px;
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
}
.dropdown {
  position: relative;
  display: inline-block;
}
.dropText {
  display: none;
  cursor: pointer;
  position: absolute;
  /* 
    
      background-color: skyblue; */
  z-index: 101;
  min-width: 120px;

  width: 100%;
  border: 1px solid #dfdfdf;
  margin-top: -7px;
  border-radius: 0px 0px 10px 10px;
  background: var(--White, #fff);
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 0 15px;
}
.detail-user .dropdown .dropText a {
  border-bottom: 2px solid #f8f8f8;
  box-shadow: inherit;
  background: transparent;
  border-radius: 0;
}
.disableditem-my {
  background: transparent;
  color: #ddd !important;
  border-radius: 0;
  box-shadow: inherit;
}

.dropText a {
  padding: 10px 5px;
  text-decoration: none;
  display: block;
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
/* .dropText a:hover {
    background-color:#f8f8f8;
    color: #3A68D8 ;
    border-bottom:1px solid #E8E8E8 ;
    align-self: stretch;
    border-radius: 30px;
    background: #F8F8F8;
 } */
.dropdown:hover .dropText {
  display: block;
}
.dropdown:hover .dropbtn {
  background-color: #f8f8f8;
}

 {
  /*button#zoom_in {
    border-right: 1px solid #ccc;
}*/
}

.textArea-form-build {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 2px 0px 0px 10px;
}

/* .topnav-tab a.active {
    background-color: #3A68D8;
    background-color: #3A68D8;
    color: white;
    height: 50px;
    padding: 10px;
} */

.create-comp-popup-text:hover,
.create-comp-popup-text.active {
  /*background: #3a68d8; */
  color: #060606 !important;
  border-left: 4px solid blue;
}
/*.create-comp-popup-text:hover .icon-trash,
.create-comp-popup-text.active .icon-trash {
  filter: brightness(0) invert(1);
}
*/

tr.temp-table-border:hover::after,
tr.temp-table-border:hover::after {
  color: var(--color1) !important;
}

.create-comp-popup-text.active .create-comp-popup-text-heading {
  color: #000 !important;
}

.create-comp-popup-text.create-comp-popup-text-heading,
.create-comp-popup-text-heading:hover {
  color: var(--color1) !important;
}
tr.temp-table-border:hover {
  color: var(--color1) !important;
}
.detail-tabs {
  margin: -30px 0px 0px 0px !important;
}

.modal-body .detail-tabs {
  margin: 0 !important;
}

.create-comp-modal-body {
  height: inherit !important;
  margin: 0;
}
.create-comp-under-line {
  width: 100%;
  border: 1px solid #dcdcdc;
  margin: -10px 0px 0px 0px;
}

.create-comp-scroll {
  margin: 15px 0px !important;
  padding: 0;
  /* background-color: green; */
  width: 100%;
  height: 30vh;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: left;
}

.create-comp-popup-text-heading {
  /* color: var(--Avenu-Black, #302B3A) !important; */
  font-family: Manrope, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
  width: 100%;
}
.create-comp-popup-text {
  display: flex;
  width: 100%;
  padding: 15px 15px;
  align-items: center;
  /* gap: 97px; */
  border-bottom: 1px solid #e8e8e8;
  margin: 0;
}

.create-comp-popup-text-heading-not-found {
  /* color: var(--Avenu-Black, #302B3A) !important; */
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
  text-align: center;
}
.create-comp-popup-text-not-found {
  /* display: flex;*/
  width: 100%;
  padding: 15px 15px;
  align-items: center;
  /* gap: 97px; 
    border-bottom: 1px solid #E8E8E8;*/
  margin: 0;
}
.send-job-check {
  padding: 10px;
}

.backgroud-check-image {
  padding: 7px;
  padding: 7px;
  width: 20% !important;
  margin: -2px 0px 0px 0px;
}

.backgroud-check {
  display: flex;
  /* width: 182.75px; */
  padding: 3.761px 4.234px;
  justify-content: space-between;
  align-items: center;
  float: right;
  border-radius: 10.093px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
  margin: -75px 0px 0px 0px !important;
}

.pop-tab-text {
  font-size: 14px !important;
  font-weight: 600;
}
.expire-text {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 25px 0px 0px 7px;
}

.tage-text {
  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.doct-name {
  width: 46px;
}
.resetchk-text {
  padding: 10px;
}
.resetpopup {
  float: left;
  position: relative;
  margin: 0px 272px 0px 0px;
}
.doct-choose {
  width: 45%;
  height: 25px;
  border: none;
  font-size: 12px;
  margin: 0px 0px 0px 0px;
}
.Documents-upload {
  width: 70%;
  /* border: 1px solid;  height: 50px; */
  padding: 10px 0px;
}

.document-image {
  cursor: pointer;
  /* display: -webkit-box; */
  margin: 0 auto;
  /* float: right; */
  /* margin-top: -30px; 
    margin-right: -175px;*/
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.select.drop-select.form-select {
  display: flex;
  width: 213px;
  padding: 15px 25px;
  align-items: center;
  gap: 20px;
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
}
.tag-design {
  display: flex;
  padding: 4.667px 9.333px;
  align-items: flex-start;
  gap: 28px;
  border-radius: 30px;
  background: #9be7ff;
  width: 15% !important;
  height: 25px;
}
.notes-box {
  margin: 15px 0px 0px 0px;
  height: 80px !important;
  display: flex;
  padding: 20px;
  align-items: flex-start;
  align-content: flex-start;
  gap: 22.473px;
  flex: 1 0;
  align-self: stretch;
  flex-wrap: wrap;
  border-radius: 8.989px;
  border: 0.899px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
  width: 100% !important;
  font-size: 15px;
}

.textarea {
  border-radius: 10px;
  border: 1px solid #dfdfdf;
  background: var(--White, #fff);
  outline: none;
}

.textarea:focus {
  border: 1px solid #dfdfdf;
}

label.nores-text {
  color: var(--graphic-objects-components-wcagaa, #949494);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0px 0px 0px 30px;
}

table {
  border: none;
}

.text-danger {
  font-weight: 600;
}
.padd-main {
  padding: 20px;
}

.listTmplt .create-comp-not-found .create-comp-text-not-found {
  margin: 0;
  padding: 0;
  width: 100%;
  text-align: center !important;
}

.sub-acc.pLR-space {
  padding-left: 10%;
  padding-right: 10%;
}
.create-comp-text,
.subtittle {
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.review-blue {
  color: var(--active-state, #3a68d8);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline !important;
  text-decoration-thickness: 1px !important;
  cursor: pointer;
}
.table-text-body {
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.table-text {
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-bottom: 1px solid #f0f0f0;
}

.modal-close {
  float: right;
  margin: 0;
  border: none;
  background-color: white;
  padding: 0;
  position: absolute;
  right: 15px;
  top: 13px;
  z-index: 10;
}

img.close-icon {
  margin: 0;
  width: 25px;
}

.hiddenRow {
  padding: 0 !important;
}
.modal-width {
  width: 100%;
}

.modal-text {
  padding: 15px 18px 0;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  word-wrap: break-word;
}

/*.modal-footer{
    padding: 10px !important;
    margin-top: -30px !important;
}

.modal-footer {
    margin: -15px 10px 10px 0px;
}
*/
.modal-text-pdf {
  padding: 0px 15px 0;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
.modal-padding {
  padding: 30px;
}
/*.modal-padding-pause{
    margin: -17px 0px 0px 0px;
   height: 115px;
}*/
.modal-text1 {
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  font-size: 15px;
  color: #666666;
  font-family: "Manrope", sans-serif;
  font-weight: 500;
}
.pause-txt {
  padding: 20px;
  background: #f1f3f4;
  border: none;
  width: 100%;
  outline: none;
  /*margin: -25px 0px 0px -20px;*/
  display: flex;
  font-size: 15px;
  font-weight: 500;
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  border-bottom: 2px solid var(--gray-accessible-text, #666);
  background: #f1f3f4;
  height: 140px;
}

.modal-text-textarea {
  padding: 17px 0px 0px 45px;
  display: flex;
  /*height: 160px;*/
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  /*border-bottom: 2px solid var(--gray-accessible-text, #666);
    background: #F1F3F4;*/
  width: 100%;
  border: none;
  /*margin-left: 55px;*/
}
.modal-bttn {
  padding: 0px 20px;
}

.pop-text {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 10px 0px 0px -20px;
}

.cancel-bttn {
  min-width: 80px;
  padding: 0.5rem;
  text-align: center;
  margin: 0;
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
}

.cancel-bttn-onbord {
  margin: 10px 30px 0px 0px;
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
}

.label-text {
  margin: 0px 0px 0px 10px;
}

.review-text {
  margin: 0px 0px 0px 30px;
  color: black;
}
.doc-img {
  width: 100%;
  margin: 0px 10px 2px 0px;
}

.board-main {
  background-color: #fbfbfb;
}

.userarea img {
  width: 30px;
}
.header-user-icon {
  width: 30px !important;
  padding: 0px 10px 5px 0px;
}
.profile-width {
  width: 100%;
}
.align-items-center {
  margin: 0px 0px 0px 0px;
}
input.form-control.side-input {
  padding: 10px 0px 10px 45px;
  border: none;
}

/*pv*/
button.Save.top-save-bbtn.eidt-temp-save-bttn {
  top: -7px;
}

img.inp-icon.copyicon {
  margin: 0px 3px 0px 0px;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgb(58 104 216) !important;
}
.text-success.team-algmt.pr-2 {
  padding-bottom: 6px;
  padding-top: 6px;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
}
.text-primary.team-algmt.pr-2 {
  padding-bottom: 6px;
  padding-top: 6px;
  padding-left: 10px;
  padding-right: 0px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
}
.text-danger.team-algmt.pr-2 {
  padding-bottom: 6px;
  padding-top: 6px;
  /* padding-left: 14px; */
  padding-right: 20px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 0.25rem;
}

.card-cprocess {
  word-wrap: break-word;
  background-clip: border-box;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  min-width: 0;
  position: relative;
}

.temp-table-border {
  border-collapse: collapse;
  border-bottom: 1px solid #edebeb;
}
.btnAlg_same .review-btn {
  color: #fff;
  border: 0;
  width: auto;
  min-width: 100px;
  justify-content: space-between;
  background: #3a68d8;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  background: #3a68d8;
  /* margin: 0 15px 0 0; */
  width: 100%;
}

.filter-divs-temp.col-lg-6 {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 10px;
  margin: 0;
  width: 100%;
}

.main-filter.temp-filters {
  max-height: 38px;
}

img.temp-edits-icon {
  width: 12px;
  margin-left: 10px;
  width: 100%;
  max-width: 13px;
}

img.temp-edits-icon:hover {
  /* filter: brightness(0) invert(1); */
}

.edit-in-width-divs {
  width: 100%;
}

input.input-temp-edts {
  border: none;
  /* padding: 2px; */
  border-bottom: 1px solid #ccc;
}

.logout-icon-img {
  border-radius: 50%;
  width: 100% !important;
  height: 100%;
  object-fit: cover !important;
  /* padding: 20px;*/
}
.circle {
  /* width: 100%;
    height: 50px;
    /* border-radius: 50%; */
  overflow: hidden;
  display: contents;
  justify-content: flex-start;
  align-items: center;
  /* border: 5px solid #000;*/
}

.circle img {
  margin-top: -5px;
  width: 100%; /* Make the image fill the container */
  height: 100%;
  object-fit: cover; /* Ensure the image covers the circle */
}

.tooltip-caseimg .tooltiptext-case {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-caseimg .tooltiptext-case::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltip-caseimg:hover .tooltiptext-case {
  visibility: visible;
  opacity: 1;
}

.text-danger.in-com.tooltip.caselogo-div {
  /*left: -5%;
    display: flex; */
  height: 20px;
  width: 100%;
  justify-content: center;
  flex-direction: inherit;
  text-align: center;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  display: flex;
}
img.caselogo {
  width: 100%;
  float: right;
  position: relative;
  /* left: -20%; */
  min-height: 13px;
  padding: 0px;
  top: -6px;
  /* text-align: center; */
  /* align-items: center; */
  display: flex;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
}

.alert9-div {
  padding-left: 35px !important;
}

.box-two.mt-2 {
  display: grid;
}

.alert9 {
  padding: 5px 9px 10px 2px;
  width: 3%;
}
.para-fonts-new {
  font-size: 15px;
  margin-bottom: 5px !important;
  margin-top: 10px !important;
}

.no-scroll {
  overflow: hidden;
}

img.caselogoi9 {
  width: 100%;
  float: right;
  position: relative;
  /* left: -20%; */
  min-height: 13px;
  padding: 0px;
  top: 0px;
  /* text-align: center; */
  /* align-items: center; */
  display: flex;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
}
button.submits-btn.rounded.p-2.case-bttn {
  background-color: white;
  border: 1px solid #ccc;
  /* margin: 10px 0px 0px 0px; */
}
img.case {
  /*width: 30%;
    float: left;
    position: relative;
    left: 5%;
    height: 20px;*/
}
button.download-icon.case-left-down-icon3 {
  left: -5px;
  position: relative;
  background: none;
  border: none !important;
  top: 0px;
  justify-content: space-between;
  display: flex;
  flex-direction: inherit;
  padding: 0px;
  width: 50%;
}
a.review-blue.case-blue {
  width: 100%;
  position: relative;
  /*left: -15%;
    left: -10%;*/
  display: flex;
}

img.arrowrrs-img.bulider-arrw {
  width: 8%;
  filter: brightness(0) invert(1);
}

img.arrowrrs-img {
  width: 8%;
  float: right;
  display: flex;
  margin: 7px 0px 0px 30px;
  filter: brightness(0) invert(1);
}

img.arrowrr-img {
  /*width: 7%;*/
  width: 15px;
  float: right;
  display: flex;
  position: relative;
  top: 4px;
}

.arrowrrs-rotate {
  transform: rotate(180deg) !important;
  filter: brightness(0) invert(1);
}

td.firstTab.arrow-btwn {
  /*display: flex;*/
  justify-content: space-between;
}

.mytem-algment {
  display: flex;
  justify-content: space-between;
}
.arrowrr-rotate {
  transform: rotate(180deg) !important;
}

.dates-pickess {
  border: var(--bs-border-width) solid red;
  padding: 10px;
}
.dates-pickessi {
  border: var(--bs-border-width) solid var(--light-gray-outline, #dfdfdf);
  padding: 10px;
}

.dates-pickessi:focus {
  border-color: #86b7fe !important;
  outline: 0;
}

.react-datepicker-wrapper input {
  /* min-width: 523px; */
  height: 63px !important;
  /* border: var(--bs-border-width) solid #ccc; */
  border-radius: 5px !important;
  width: 100%;
}

.react-datepicker-wrapper {
  display: inline-block;
  padding: 0;
  border: 0;
  width: 100% !important;
}
img.arrow-img {
  width: 10%;
  margin: 0px 15px 0px 15px;
}

p.text-danger.in-com {
  width: 70%;
  font-size: 12px;
  margin-left: 5px;
}
.form-select.select-height.select-widths {
  /*width: 60%;
    min-width: 640px;
    display: flex;
    float: left;*/
}
.onb-actions.fontSty.edits-fil {
  /* padding-left: 22.3%; */
  float: right;
  padding-right: 15px;
}
.col-sm-3.col-lg-3.edit-filtess {
  width: 22.5%;
}

.form-floating.wraper.minH.mb-3 {
  /* margin-left: 25px; */
  /* margin-right: 20px;
      width: 90%; */
}
.input.form-control.text-inputsz {
  border: 1px solid grey;
  position: relative;
  margin: 0 auto;
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
}

button.dropbtn.btnArw {
  background: #fff;
  background: var(--White, #fff);
  border: 1px solid #dfdfdf;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  border-radius: 10px;
  font-size: 15px;
  padding: 10px;
  width: 205px !important;
  color: black;
}
.firstTab.paddleft-sub-heading.ml-2 {
  padding-left: 35px !important;
}
.img-wraper img {
  max-width: 100%;
  /* height: 200px;
    max-height: inherit; */
  height: auto;
}
.alignImg-inpts .inptFiles_up input[type="file"] {
  margin: 0px 0px 0px 5px;
}

.alignImg-inpts .inptFiles_up .upBtn {
  margin: 0;
}

.alignImg-inpts .inptFiles_up.d-flex > p {
  margin-top: 0;
}

img.eye-img {
  width: 20px;
}

input.form-control.pass-inpt:focus {
  border: var(--bs-border-width) solid var(--bs-border-color);
}

.input-group-append {
  margin-left: -1px;
}
.input-group-append,
.input-group-prepend {
  display: flex;
}

.login_container .loginForm .input-group.password .input-group-append .btn {
  border-radius: 0 10px 10px 0;
}

.input-group.password .input-group-append .btn {
  border: 1px solid #ced4da;
  border-left: 0;
  color: #777;
}
.save-temp {
  color: var(--light-gray-outline, #dfdfdf) !important;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.dropbtn .drop-imaege {
  width: 18px;
  margin: 0px 8px 0px 0;
  height: auto;
}

.detail-tab-edit {
  margin: -35px 0px 0px 22px !important;
}

.phone-icon {
  margin: 0px 0px;
  width: 16px;
}

.email-icon {
  margin: 0px 0px;
  width: 15px;
}
.choosefrom {
  font-size: 14px;
}

.commt-text {
  color: #000;
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 147%;
}

.commt-date {
  color: #666;
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 147%;
}
.deatails-tap-text {
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 12.133px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 3px 13px 0px 0px;
}

.inptFiles_up.d-flex > p {
  margin: 0;
  font-size: 13px; /* margin: -20px 0px 0px 15px;*/
  margin: -35px 0px 0px 65px;
  word-break: break-all;
}

.inptFiles_up.d-flex {
  align-items: center;
}

.inptFiles_up {
  position: relative;
}
.inptFiles_up .upBtn {
  position: absolute;
  left: 0;
  pointer-events: none;
  width: 93px;
  height: 37px;
  border: 1px solid #949494;
  background: #fff;
  border-radius: 8px;
  margin: -25px 0 0 0;
  font-size: 15px;
  font-weight: 500;
  color: #302b3a;
}
.form-check-input:checked {
  box-shadow: inherit !important;
}

.RightCont .topSect .form-check-input:checked {
  background-color: #949494;
  border-color: #949494;
}

.serchField.serSpc {
  margin: 0px 15px;
}

.form-check.mx-3.ml-0 {
  margin-left: 0 !important;
}

.inpTxt.textArea.pl-0.rdw-editor-main {
  height: auto;
  min-height: 50px;
}

.aligChx {
  align-items: center;
}

.aligEsig.aligChx {
  align-items: flex-start;
}

.aligEsig.aligChx .form-check-input {
  margin: 5px 8px 0 0;
}

.aligChx .form-check-input {
  margin: 0 8px 0 0;
}

.RightCont .public-DraftStyleDefault-block.public-DraftStyleDefault-ltr {
  /*margin-bottom: 0; min-width: 250px;*/
}

.aligChx.aligEsig .inpTxt.textArea {
  resize: none !important;
  overflow: auto !important;
}
/* 20-10-23 css start */
.bxborder.wraper.newPads_editform .inpSpace {
  flex: 1 1;
}
.formAlg-new .inpAlig .main-title {
  width: 100%;
}
/*.table-text-body  td {
    width: calc(100% / 4) !important;
}*/
th.firstTab {
  min-width: inherit !important;
}
.footer.footer-bottom {
  display: none;
}

/*start edits-scroll-important*/
.ht-box div#main {
  height: 100vh;
}
.ht-box.height-box {
  height: 100%;
}
.content-sc.edits-height-box {
  height: 100% !important;
}
/*end  edits-scroll-important*/

ul.dropdown-menu.mt-1.profile-width.show {
  inset: 0px 0px 0px 0px !important;
}
.userarea ul.dropdown-menu.mt-1.profile-width.show {
  inset: 0px 0 -8px 0px !important;
}
.detail-tabs .table tbody.table-text-body td {
  word-break: break-all;
  vertical-align: middle;
}
.e-pv-sidebar-toolbar .e-pv-tbar-btn {
  color: rgba(0, 0, 0, 0.54);
  display: flex;
  align-items: center;
  justify-content: center;
}
/*pppp*/
.e-toolbar-items.e-tbar-pos {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center;
  padding: 10px 0px;
}

.e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-right {
  position: inherit;
}
.e-toolbar-item .e-tbar-btn.e-tbtn-txt.e-control#download {
  margin-top: 0px !important;
  min-height: 40px !important;
  min-width: 120px;
  margin-right: 10px !important;
}
.custIcons button#file_Open,
.custIcons button#chooseTemplates {
  padding: 10px;
}
ul.status-ind li a {
  word-break: break-all;
}
.inpAlig .subHead_inp {
  width: 100%;
}
.e-control.e-toolbar.e-lib.e-keyboard {
  margin-top: 0px;
}
.e-pdf-toolbar.custIcons.bottom-space {
  margin-bottom: 0px;
  border-bottom: 1px solid #dfdfdf;
}
.e-toolbar .e-toolbar-items.e-tbar-pos {
  /*border-bottom: 1px solid #dfdfdf;*/
  border-radius: 0;
  background: transparent;
}
.e-pv-sidebar-toolbar {
  background-color: transparent;
  margin: 0;
  border-top: 0;
  border-left: 0;
}
.res-p-10 {
  padding-top: 10px;
}
a.av-res {
  background: #f7f9fb;
  border: 1px solid #cccccc7d;
  display: flex;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 16px;
  height: 87%;
}
.company-wrp {
  display: flex;
  align-items: center;
}
.res-grid ul {
  list-style: none;
  margin-left: 0px;
  padding-left: 0px;
  display: flex;
  margin-top: 25px;
  flex-wrap: wrap;
}
.company-wrp img {
  padding: 6px;
  background: #fff;
  border-radius: 100px;
  box-shadow: 1px 1px 10px #3a68d826;
  width: 60px;
}
.res-grid h3 {
  font-size: 16px;
  color: #313338;
  margin: 10px 0px;
  font-weight: 700;
  /* min-height: 20px; */
  margin-left: 10px;
}
.res-grid ul li {
  margin-right: 10px;
  /* padding: 10px; */
  color: #0000008c;
  font-size: 13px;
}
span.steps {
  padding: 5px 12px;
  background: #00968826;
  border-radius: 4px;
  font-size: 15px;
}

/* 20-10-23 css End */

@media screen and (max-width: 1300px) {
  .container_main.containerSpace.mainWrap .componentScroll .sub-acc {
    width: 23.333333%;
  }
  .switch.togSw {
    position: relative;
    display: inline-block;
    /*width: 32px;*/
    width: 35%;
    height: 17px;
  }
}

/*@media (min-width: 992px) {
    .modal-width {
        max-width: 800px;
    }
}*/

@media screen and (max-width: 992px) {
  .inptFiles_up .upBtn {
    width: 93px;
    height: 37px;
  }

  .switch.togSw .slider:before {
    position: absolute;
    content: "";
    height: 9px;
    width: 9px;
    left: 3px;
    bottom: 3px;
    background-color: #949494;
    transition: 0.4s;
  }

  .create-process {
    min-height: 45vh;
  }

  .build-choose {
    color: var(--Avenu-Black, #302b3a);
    font-family: Manrope;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: contents;
  }
}

.inptFiles_up .upload_files_issue input[type="file"] {
  font-size: 13px;
  width: 95px;
  height: 34px;
  padding: 0;
  opacity: 0;
  position: absolute;
  left: 2px;
  top: 0px;
  /*font-size: 13px;
    width: 107px;
    height: 34px;
    padding: 0;
    opacity: 0;
    */
}

.inptFiles_up input[type="file"] {
  font-size: 13px;
  width: 85px;
  height: 34px;
  padding: 0;
  opacity: 0;
  margin: -5px 0px 0px 5px;
  /* position: absolute; */
  left: 2px;
  top: 0px;
  border: none;

  /*  font-size: 13px;
    width: 95px;
    height: 34px;
    padding: 0;
    opacity: 0;
    margin: -15px 0px 0px 5px;
   position: absolute;
    left: 2px;
    top: 0px;
    /*font-size: 13px;
    width: 107px;
    height: 34px;
    padding: 0;
    opacity: 0;
    position: absolute;*/
}
.scrolDiv {
  max-height: 700px;
  overflow-y: auto;
}
.grp-listing {
  height: 135px;
  overflow-y: auto;
}
/* width */
.grp-listing::-webkit-scrollbar {
  width: 10px;
}
span.count-t {
  background: red;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 40px;
  color: #fff;
  align-items: center;
  display: flex;
  justify-content: center;
}
.container-fluid.row.align-items-xxl-stretch {
  height: calc(100% - 84px) !important;
}
button.head-close.border-0.d-flex.ms-5 img {
  width: 20px;
}

button.head-close.border-0.d-flex.ms-5 {
  background: none;
}
img.hd_icon-e {
  width: 20px;
  margin-right: 10px;
}
h6.form-hd {
  font-weight: 500;
}
a.in-Hd-link-itm {
  color: #302b3a;
}
.whiteBg {
  background-color: #fff;
}

a.create-comp:hover > h6 {
  color: #fff;
}
.sub-acc.blueborder {
  border: 2px dashed #3a68d8;
}
/* .sub-acc.blueborder {
    background-image: url("data:image/svg+xml,%3csvg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23316AF7FF' stroke-width='1' stroke-dasharray='6%2c 14' stroke-dashoffset='13' stroke-linecap='round'/%3e%3c/svg%3e") !important;
    border-radius: 10px;
    border: 0;
} */
.modal-title {
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.ReactModal__Content.ReactModal__Content--after-open {
  padding: 0 !important;
}
.modal-header {
  padding: 15px 20px !important;
}

.modal-body {
  padding: 20px 20px !important;
}
.row.common-r.mt-4.scroll-y {
  height: 300px;
  overflow-y: auto;
}
.row.common-r.mt-3.scroll-y {
  height: 500px;
  overflow-y: auto;

  padding: 30px;
}
.sidebar_open.main-content.edit.hight-av {
  height: 100vh !important;
}
.avatar {
  background: #fff !important;
  border: 1px solid #e8e8e8;
}
.avatar p {
  color: #302b3a !important;
  font-weight: 700 !important;
  text-align: center;
  line-height: 48px;

  font-weight: 700 !important;
  font-size: 17px;
}
.d-flex.align-items-center.justify-content-between.w-100.main-de select {
  width: 30%;
  padding: 10px 55px;
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
li.breadcrumb-item a {
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
li.breadcrumb-item.active {
  color: #302b3a;
  font-weight: 600;
}
.f-btns.doc button {
  border: 0;
  background: none;
  /* margin-left: 100px; */
}
span.yllowstatus {
  background: #ffb900;
  padding: 3px 15px;
  border-radius: 40px;
}
.candidate.newDes .us-lists-itm {
  float: left;
  width: 100%;
  /* white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;  */
}
.candidate.newDes .d-flex.wrp {
  width: 90%;
}
.candidate.newDes .text-success,
.candidate .text-warning,
.candidate .text-danger {
  min-width: 10%;
  text-align: end;
  font-weight: 500;
  font-size: 15px;
}

.bxShw {
  border: 1px solid #dfdfdf;
  background-color: #fff;
  border-radius: 10px;
}

.formInner {
  border: 1px solid #dfdfdf;
  background-color: #fff;
  border-radius: 20px;
}
.formInner .form-features {
  background: transparent;
}

button.clsBt {
  background: transparent;
  /*padding: 0;
  float: right;*/
}
button.clsBt img {
  width: 20px;
  margin: 0;
  padding: 0;
}

.inpSpace {
  display: flex;
  align-items: center;
}
.inpSpace > p {
  margin: 0;
}

.widthInp {
  width: 250px !important;
  max-width: 100%;
}
.fileupload.fileSPace {
  border: 2px dashed #3a68d870;
  border-radius: 0 0 18px 18px;
  padding: 40px;
}
.formWarp .form-hd.formAlg-new {
  padding: 10px 20px;
  margin: 0;
  align-items: center;
}
/*.subHead_inp {
    background: transparent;
    border: 0 !important;
    padding: 5px 0;
    outline: 0 !important;
    box-shadow: inherit !important;
    display: flex;
    color: #302B3A;
    font-family: 'Manrope', sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}*/
/*input.subHead_inp.main-title {
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    
}*/
.subHead_inp,
.subHead_inp-text {
  background: transparent;
  border: 0 !important;
  box-shadow: inherit !important;
  display: flex;
  font-size: 15px;
  font-style: normal;
  line-height: normal;
  outline: 0 !important;
  padding: 5px 0;
}

.subHead_inp {
  color: #302b3a;
  font-family: "Manrope", sans-serif, sans-serif;
  font-weight: 600;
}

/*.subHead_inp-text{ 
    background: transparent;
    border: 0 !important;
    padding: 5px 0;
    outline: 0 !important;
    box-shadow: inherit !important;
    display: flex;
    color: #666;
    font-family: 'Manrope', sans-serif !important;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}*/

.inpAlig {
  display: block;
  width: 100%;
  padding: 0 0 0 15px;
}
.inpAlig .mainTitle {
  font-size: 15px;
  font-weight: 600;
  margin: 5px 0 3px;
  padding: 0;
  font-family: "Manrope", sans-serif !important;
}
.formWarp .form-hd {
  padding: 20px 20px;
  margin: 0;
}

.wraper {
  float: left;
  width: 100%;
}
.txtAlgn {
  display: flex;
  justify-content: space-between;
}
.wrapAlign {
  flex-direction: column;
  display: flex;
  width: 100% !important;
  margin-left: 0 !important;
}
.wrapAlign.full-drp {
  padding: 10px 10px;
}
.wrapAlign .hd-can.create-form-wrp h4.mainHead {
  color: var(--Avenu-Black, #302b3a);
  padding: 0;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: normal;
  margin: 0px 0px 10px;
}
.wrapAlign .hd-can.create-form-wrp p.subHead {
  padding: 0;
  margin: 0;
}

.wrapAlign .hd-can {
  height: auto;
}
.wrapAlign .txtAlgn {
  margin: 0;
  padding: 10px 15px;
  align-items: center;
}
.scrlHe {
  height: 350px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.scrlHe::-webkit-scrollbar {
  display: block !important;
}

.inserifiled {
  border-left: 1px solid #ccc;
}

.scrlHe-tab {
  /* height: 250px;*/
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 25px 0px 0px 0px;
}
.scrlHe-tab::-webkit-scrollbar {
  display: block !important;
}

.action-itms.scrlHe {
  margin-bottom: 5px;
  padding-bottom: 5px;
  overflow-y: auto;
}

/* ::-webkit-scrollbar{
    -webkit-appearance: none;
    width: 5px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
} */

.RightCont form video {
  width: 100% !important;
}

.wrapAlign .txtAlgn .accordion-button {
  border-bottom: 1px solid #dfdfdf57;
  margin: 0 0 15px;
  padding: 0 0 15px;
  width: 100% !important;
  display: flex;
  justify-content: space-between;
}
.accordion-button.tag.collapsed {
  border-bottom: 1px solid transparent;
  margin: 0;
  padding: 0;
}
.listTmplt .create-comp {
  margin: 0;
  border-radius: 0;
  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf) !important;
  border: 0;
  padding: 15px 20px;
}

.listTmplt .create-comp-not-found {
  margin: 0;
  padding: 15px 5px;
  border-radius: 0;
  /* border-bottom: 1px solid var(--light-gray-outline, #DFDFDF) !important;*/
  border: 0;
  padding: 20px;
}

.listTmplt .create-comp .create-comp-text {
  margin: 0;
  padding: 0;
  width: 100%;
  text-align: left;
}

.listTmplt {
  /*margin: 0 0 15px;*/
  margin: 0 0 5px;
}

.common.scroll-y.spc {
  overflow-y: auto;
  max-height: 300px;
}

.listTmplt a.create-comp:hover {
  color: #000;
  background-color: #fff;
}
.userarea .dropdown-item {
  font-size: 15px;
}

.userarea .profile-width li img.rightarrow {
  width: 7px;
  margin-right: 10px;
}
.userarea .profile-width li .header-user-icon {
  width: 26px !important;
  padding: 0px 10px 0px 0px;
}
.userarea .dropdown-item:hover {
  background-color: transparent;
  color: var(--bs-dropdown-link-color);
}

.sub-acc.blueborder.newBorder {
  border-radius: 10px;
  padding: 0.7rem;
}
.padd-ajust .MuiList-padding {
  padding-top: 0px;
}

.f-itm.newOne {
  border: 1px solid #add8e6;
  border-radius: 10px;
  background-color: #eff6ff;
}
.dropbtn.btnArw {
  position: relative;
  text-align: left;
}
.detail-user .dropdown .dropbtn.btnArw {
  font-weight: 500;
}

.dropbtn.btnArw:after {
  content: "";
  border-top: 0.3em solid #000;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  position: absolute;
  right: 8px;
  top: 20px;
}
button.download-icon {
  background: none;
  border: none !important;
  top: -5px;

  width: 100%;
}
.dropbtn.btnArw.send-on-bttn:after {
  content: "";
  border-top: 0 solid #000;
  border-right: 0 solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  position: absolute;
  right: 8px;
  top: 20px;
}

.blkCl {
  color: var(--avenu-black, #302b3a);
}

.blkCl::placeholder {
  color: #949494 !important;
}

.tempList .form-control::placeholder {
  color: #949494;
}

.tempList .form-control {
  font-size: 15px;
}

.secTag {
  margin: -15px 0 10px;
}

.secTag .menu-title {
  font-size: 15px;
  font-weight: 500;
}

.secTag .add-submenuz {
  padding: 0;
  margin-left: 10px;
}

.secTag .add-submenuz .add_icon {
  width: 20px;
}

.topnav a.tage-menu {
  padding: 4px 24px 4px 10px;
  display: inline-flex;
  align-items: center;
}
.topnav a.tage-menu .tage-text {
  margin: 0;
}

.topnav a.tage-menu .close-image {
  width: 12px;
  top: 8px;
  right: 6px;
}
.form_subTitles {
  padding: 0 0 10px;
  margin: 10px 0;
}
.sub-acc select.form-select {
  font-size: 15px;
  font-weight: 500;
  border-radius: 10px;
  min-height: 45px;
}
.tempList {
  margin: 0 0 10px;
}

.tempList .create-G {
  padding: 15px 0;
}
.grp-hd .tempList .create-G img {
  margin: 0 15px 0 0 !important;
  width: 20px;
}

.mr-0 {
  margin-right: 0 !important;
}

.detail-tabs .table tbody.table-text-body td {
  padding: 1rem 0.5rem 1rem;
}
.detail-tabs th.lastTab,
.detail-tabs td.lastTab {
  width: 20%;
  /* text-align: end;*/
  padding-right: 0 !important;
}
.detail-tabs th.dateTab,
.detail-tabs td.dateTab {
  max-width: 155px;
}
.detail-tabs th.firstTab,
.detail-tabs td.firstTab .onboard-widthz {
  max-width: 650px !important;
}

.detail-tabs th.firstTab,
.detail-tabs td.firstTab .app-history {
  min-width: 160px;
}

.detail-tabs th.firstTab,
.detail-tabs td.firstTab {
  min-width: 160px;
  padding-left: 0 !important;
}

.actSpace {
  padding-left: 1.5rem !important;
  width: 100px;
}

.secBox .form-floating {
  width: 100%;
}

.form-floating.doc_form {
  max-width: 100%;
  /*z-index: 1;*/
  position: relative;
  /* margin-bottom: -40px;*/
  margin-bottom: 20px;
  width: 350px;
}

.e-pv-sidebar-toolbar-splitter {
  background: #e0e0e0;
  bottom: 0;
  height: calc(100% - 56px);
  position: absolute;
  width: 1px;
  z-index: 0 !important;
}
.form-floating.doc_form .form-control {
  font-size: 14px;
  width: 100%;
  padding: 5px 0.75rem;
  height: 40px;
  min-height: auto;
}
.form-floating.doc_form > label {
  padding: 0.5rem 0.75rem;
  font-size: 14px;
}
.pdfHeight_limit {
  height: 45vh;
  min-height: auto !important;
  overflow-y: auto;
}

.e-pdfviewer:not(.e-pv-mobile-view) .e-pv-main-container {
  min-height: auto;
}

.width-flex {
  padding: 0 1em;
}
.width-flex .task-count {
  padding: 0;
}

.rightCont .width-flex .hd-can-review.newPad,
.rightCont .algSing_head .hd-can-review.newPad {
  padding-left: 0;
}

.alignHead_review .task-count {
  margin: 0;
}

.algSing_head {
  display: block !important;
  justify-content: inherit !important;
  flex-direction: column;
  padding: 0 1em !important;
}
.alignHead_review {
  justify-content: space-between;
  display: flex;
  width: 100%;
  align-items: center;
}

.form-floating.doc_form > .form-control:focus ~ label,
.form-floating.doc_form > .form-control:not(:placeholder-shown) ~ label {
  transform: scale(0.85) translateY(-1.23rem) translateX(0.15rem);
  font-size: 13px;
  padding-bottom: 0;
  min-height: inherit;
  height: auto;
}
.form-floating.doc_form > .form-control:not(:placeholder-shown) {
  padding: 0.5rem 0.75rem;
}

.e-toolbar-item .e-tbar-btn.e-tbtn-txt.e-control#download {
  background: var(--color1) !important;
  color: #fff;
  border-radius: 5px;
  padding: 6px 25px;
  border: 1px solid var(--color1);
  margin-top: -3px;
  min-height: 39px;
  outline: 0;
  box-shadow: inherit;
  margin-right: -4px;
}
.e-toolbar-item .e-tbar-btn.e-tbtn-txt.e-control#download .e-tbar-btn-text {
  color: #fff !important;
  padding: 0;
  margin: 0;
}

.txtfComp .public-DraftStyleDefault-block.public-DraftStyleDefault-ltr {
  margin: 0 0 10px;
  width: auto;
  /* min-width: 300px; */
  padding: 0;
}
.txtfComp .public-DraftEditorPlaceholder-root {
  margin: 0;
}

.txtfComp .inpTxt.textArea.pl-0.rdw-editor-main,
.newHeight-edit {
  min-height: auto !important;
  padding-bottom: 0 !important;
  padding-right: 0;
  height: inherit !important;
}
.newHeight-edit .public-DraftEditorPlaceholder-root {
  margin-top: 0;
}

.tooltip.cent .tooltiptext {
  left: -100px;
  right: inherit;
}
.tooltip.cent .tooltiptext::after {
  bottom: -8px;
  left: 45%;
  right: inherit;
}

.tooltiptext::after {
  content: " ";
  width: 0;
  height: 0;
  /*border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 8px solid #ddd;*/
  position: absolute;
  bottom: -8px;
  right: 5px;
}
.outer-tool.tooltip {
  z-index: 0 !important;
}
.tooltip {
  position: relative;
  display: inline-block;
  opacity: 1 !important;
  border: 0;
  z-index: 0 !important;
}

.tooltip .tooltiptext {
  /* visibility: hidden;
    min-width: 280px;
    font-family: 'Manrope', sans-serif !important;
    background-color: #FFF;
    border: 1px solid #ddd;
    color: var(--color2);
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    line-height: 18px;
    text-align: center;
    font-size: 13px;
    position: absolute;
    z-index: 1;
    right: 10px;
    bottom: 30px;
    width: 100%;*/
  visibility: hidden;
  width: 100%;
  font-family: "Manrope", sans-serif !important;
  background-color: #fff;
  border: 1px solid #ddd;
  color: var(--color2);
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  line-height: 18px;
  right: 10px;
  top: -60px;
  min-width: 250px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}

.tempList .form-floating > label,
.form-floating.doc_form {
  color: #a4a4a4;
  font-size: 14px;
}

/* .e-toolbar .e-toolbar-item .e-tbar-btn#chooseTemplates {
    background: #ffffff !important;
    color: #fff;
    border-radius: 5px;
    padding: 6px 15px !important;
    border: 1px solid var(--color1) !important;
    margin-top: -3px;
    min-height: 39px;
    outline: 0;
    box-shadow: inherit;
} */
/* .e-toolbar .e-toolbar-item .e-tbar-btn#chooseTemplates .e-tbar-btn-text{  color: var(--color1) ; } */

.e-toolbar-items.e-tbar-pos .e-toolbar-center {
  margin: 0 0 0 371px !important;
  float: left;
  display: inline-block !important;
}

.hd-can-review.neSp.create-form-wrp .task-count {
  margin: 0;
}

.task-itms {
  font-size: 15px;
  width: 190px;
}

.btnAlg_same {
  /*margin-bottom: -38px !important;*/
  float: left;
}
.btnAlg_same .confirm-btn {
  min-height: 40px;
  margin-bottom: 0 !important;
  border-radius: 7px !important;
}

.task-count.mr-0 {
  margin: 0;
}

.listTmplt.alignDiv .icon-dele {
  margin: 0;
  float: right;
  width: 35px;
  cursor: pointer;
  padding-left: 5px;
}
.listTmplt.alignDiv .create-comp {
  border: 0 !important;
}

.listTmplt.alignDiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf) !important;
}
.btnAlg_same {
  /*margin-bottom: -42px !important;*/
  float: left;
  margin-top: -20px;
  margin: -15px 0px 10px 0px;
}
.alertField {
  position: relative;
}

.alertField .alertRight {
  color: red;
  position: absolute;
  right: 0;
  bottom: -17px;
  line-height: 13px;
  font-size: 12px;
  margin: 0;
  letter-spacing: -0.1px;
  min-width: 237px;
  text-align: left;
  /*min-width: 260px;
    text-align: end;*/
}
.input-group-append.pass-div-width.secure-field {
  width: 60% !important;
}
.form-floating.wraper.minH.mb-3.over-ride {
  width: 90%;
  margin: 0 auto;
  position: relative;
  left: 20px;
}
.alertField .alertLeft {
  color: red;
  position: absolute;
  left: 0;
  bottom: -19px;
  line-height: 13px;
  font-size: 12px;
  margin: 0;
  letter-spacing: -0.1px;
  min-width: 260px;
  text-align: left;
}
.lastChld {
  text-align: center;
  padding: 5px 0;
  width: calc(100% - 10px);
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif !important;
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
}

.savePopus .modal-title img.create-icon {
  width: 23px;
}

.savePopus .modal-footer.footer-marg-pdf {
  margin: 0px;
}

.savePopus .modal-close {
  top: 14px;
}

.rdw-editor-toolbar a.rdw-dropdown-selectedtext {
  color: #949494;
}

.rdw-editor-toolbar .rdw-dropdown-carettoopen {
  border-top: 6px solid #949494;
}

.rdw-editor-toolbar .rdw-dropdown-wrapper:hover {
  box-shadow: inherit;
}

.rdw-editor-toolbar .rdw-option-wrapper {
  position: relative;
}

.formSect .alinBx hr {
  margin: 0.6rem 0 1rem;
  opacity: 0.08;
}

.rdw-editor-wrapper .rdw-editor-toolbar {
  padding: 0;
  border-radius: 0;
  border: 0;
}
.rdw-editor-toolbar .rdw-option-wrapper {
  border: 1px solid transparent;
  padding: 2px;
  min-width: 25px;
  height: 25px;
  box-shadow: inherit;
  outline: 0;
  border-radius: 0;
  margin: 0 10px 0 0;
}
.rdw-editor-toolbar .rdw-option-wrapper:hover,
.rdw-text-align-wrapper .rdw-option-wrapper:hover,
.rdw-link-wrapper .rdw-option-wrapper:hover,
.rdw-list-wrapper .rdw-option-wrapper:hover,
.rdw-history-wrapper .rdw-option-wrapper:hover {
  box-shadow: inherit;
  border: 1px solid transparent;
}

.rdw-editor-toolbar .rdw-option-wrapper.rdw-option-active,
.rdw-text-align-wrapper .rdw-option-wrapper.rdw-option-active,
.rdw-link-wrapper .rdw-option-wrapper.rdw-option-active,
.rdw-list-wrapper .rdw-option-wrapper.rdw-option-active,
.rdw-history-wrapper .rdw-option-wrapper.rdw-option-active {
  box-shadow: inherit;
  border: 1px solid #dadada;
}
.rdw-inline-wrapper .rdw-option-wrapper:nth-child(1) img,
.rdw-inline-wrapper .rdw-option-wrapper:nth-child(2) img,
.rdw-inline-wrapper .rdw-option-wrapper:nth-child(3) img,
.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(1) img,
.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(2) img,
.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(3) img,
.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(4) img,
.rdw-link-wrapper .rdw-option-wrapper img,
.rdw-list-wrapper .rdw-option-wrapper img,
.rdw-history-wrapper .rdw-option-wrapper:nth-child(1) img,
.rdw-history-wrapper .rdw-option-wrapper:nth-child(2) img {
  opacity: 0;
}

.rdw-inline-wrapper .rdw-option-wrapper:nth-child(1) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.rdw-inline-wrapper .rdw-option-wrapper:nth-child(2) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.rdw-inline-wrapper .rdw-option-wrapper:nth-child(3) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}

.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(1) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(2) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(3) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(4) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.rdw-link-wrapper .rdw-option-wrapper {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.rdw-list-wrapper .rdw-option-wrapper {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.rdw-history-wrapper .rdw-option-wrapper:nth-child(1) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.rdw-history-wrapper .rdw-option-wrapper:nth-child(2) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-position: center center !important;
  background-repeat: no-repeat !important;
}

.public-DraftStyleDefault-ltr {
  text-align: justify !important;
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.rdw-editor-wrapper {
  width: 100% !important;
}

header ul.dropdown-menu.mt-1.profile-width.show {
  transform: translate3d(0px, 48px, 0px) !important;
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
  left: inherit !important;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: 3px !important;
  scrollbar-color: transparent !important;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 3px !important;
}

*::-webkit-scrollbar-track {
  background: transparent !important;
}

*::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 60px;
  border: 3px solid #a3a3a3 !important;
}
/* ===== Scrollbar CSS End ===== */

.wrapAlign.full-drp.padNew {
  padding: 15px !important;
}
.cer-temps.mt-2 {
  height: auto;
}

.create-form-wrp.hegNew {
  min-height: auto;
}

.bor_drag {
  position: relative;
}

.bor_drag .leftDivs::before {
  content: " ";
  position: absolute;
  left: 0px;
  top: 35%;
  width: 3px;
  min-height: 22px;
  background-color: transparent;
  border-radius: 20px;
  z-index: 0;
}

.bor_drag:focus,
.bor_drag:hover {
  border: 1px solid #3a68d8 !important;
}

.bor_drag:focus .leftDivs::before,
.bor_drag:hover .leftDivs::before {
  background-color: #3a68d8;
}

button.btn.dragBtn {
  border: 0;
  box-shadow: inherit;
}

.ediBtns .Actbtn,
.ediBtns:hover .bfBtn {
  display: none;
}
.ediBtns:hover .Actbtn {
  display: inline-block;
}

.ReactModal__Overlay.ReactModal__Overlay--after-open:has(.dltPops) {
  /*z-index: 1600;*/
}

.ReactModal__Content.ReactModal__Content--after-open:has(.dltPops) {
  max-width: 470px;
}

button.upBtn.aligBtn-view {
  top: 0;
  position: relative;
  left: inherit;
  margin: 0 0 0 15px;
}

.inptFiles_up.aligDivs_rev. {
  position: relative;
  display: flex;
  align-items: center;
}

.inptFiles_up.aligDivs_rev p {
  /*margin: 0;*/
  margin: 0px 0px 0px 110px;
}

.aligDivs_rev .upBtn.aligBtn-view {
  top: 0;
  position: relative;
  left: inherit;
  margin: 0 0 0 15px !important;
}
.cardSpace {
  padding: 0 25px;
}
button.download-icon.case-left-down-icon1.visible-dw-btn {
  left: inherit !important;
}

@media screen and (max-width: 767px) {
  /*today*/
  .sidebar_open.main-content.edit.hight-av {
    height: 75vh !important;
  }

  .trash-edit {
    float: right;
    /* right: 5%; */
    position: relative;
    display: flex;
    height: 0px;
    margin-top: 0px;
    width: 100%;
    color: #000;
    min-width: 200px;
  }
  button.dropbtn.btnArw {
    background: #fff;
    background: var(--White, #fff);
    border: 1px solid #dfdfdf;
    border: 1px solid var(--light-gray-outline, #dfdfdf);
    border-radius: 10px;
    font-size: 15px;
    padding: 10px;
    width: 100% !important;
    color: black;
  }
  .icons-ed {
    float: right;
    display: flex;
    width: 100%;
    justify-content: space-between;
    min-width: 100px;
  }
  .componentScroll .sub-acc {
    background-color: #fff;
    top: 10px;
    right: 0px;
    flex: 0 0 auto;
    width: 100% !important;
    z-index: 100;
    display: inline-block;
    justify-content: flex-end;
    flex-direction: row-reverse;
    position: relative;
  }
  .create-process {
    min-height: 60vh;
  }
  button.Save.top-save-bbtn {
    display: flex;
    float: left;
    margin-top: 50px;
    width: 50%;
  }

  .trash-icon-popups {
    float: right;
    width: 100%;
    display: flex;
  }

  .e-toolbar-items.e-tbar-pos {
    display: contents !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px;
  }
  .e-pdfviewer .e-pv-viewer-main-container {
    width: 100% !important;
    /*position: relative;*/
  }

  /*today*/

  nav.sidebar {
    position: fixed;
    left: -290px;
  }

  Header nav {
    display: none;
  }

  .userarea {
    display: none;
  }

  .onb-actions a,
  .onb-actions select {
    width: 100%;
    background: #fff;
    margin-bottom: 5px;
    padding: 2px 12px;
    border-radius: 5px;
    border: 1px solid #ccc;
    justify-content: flex-start;
    margin-right: 0px;
  }

  .f-itm {
    flex-direction: column;
    align-items: flex-start;
  }

  .sidebar_open {
    margin: 7px !important;
    /* border: 0; */
    /* background: #fbfbfb; */
    padding: 10px !important;
  }

  .onb-actions {
    flex-direction: column;
    width: 100%;
  }

  .action-itms-forms h6 {
    margin-bottom: 10px !important;
    text-align: left !important;
  }

  .action-itms-forms {
    flex-direction: column;
    align-items: flex-start;
  }

  .form-features {
    padding: 5px !important;
  }

  .create-sec.onb-actions a {
    font-size: 13px;
    display: flex;
    align-items: center;
  }

  .create-sec.onb-actions {
    flex-direction: row-reverse;
  }
  button.up-btn.btn {
    width: 100%;
  }
  .upload-btns button {
    margin-right: 0px !important;
  }
  .upload-btns span {
    margin-right: 0px !important;
  }
  .upload-btns {
    flex-direction: column !important;
    display: flex;
    align-items: center;
    width: 100%;
  }
  .ReactModal__Content.ReactModal__Content--after-open {
    position: inherit;
    width: 100%;
    inset: 0px !important;
  }

  .action-itms.d-flex.align-items-center.justifycontent-between {
    flex-direction: column;
  }
  .tm-buttons .men-btn {
    flex-direction: column !important;
  }
  .tm-buttons {
    width: 100%;
  }
  .men-btn.d-flex.align-items-center button {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 5px;
  }
  .search {
    width: 100% !important;
  }
  .searchere img {
    width: 20px !important;
  }
}

@media (min-width: 992px) {
  .col-lg-5.padd-ajust {
    width: 46.66666667%;
  }
  .col-lg-3.padd-ajL {
    width: 20%;
  }
  .container_main.containerSpace.mainWrap .componentScroll .sub-acc {
    max-width: 24.3%;
  }
  .create-process {
    min-height: 60vh;
  }
}

/* @media only screen and (max-width: 2880px) and (min-width: 1920px)  {

    .sidebar .nav span.menu-title, button.status-btn, .user-itm .ca-details h3, .ca-details h3, .react-tabs__tab, .table-text, .table-text-body, span.username, .detail-user .dropdown .dropbtn.btnArw 
    { font-size: 16px !important; }
    .sidebar .nav a.nav-link .menuIcon_bx img {  width: 24px; }
    .userlist .hd-can h4.allTxt, .candidate.newDes .text-success, .candidate .text-warning, .candidate .text-danger{ font-size: 20px; }
    .detail-user .candidate .text-warning, .detail-user .candidate .text-danger, .detail-user .candidate.newDes .text-success{ font-size: 19px; }

} */
@media screen and (min-device-height: 630px) and (max-device-height: 700px) {
  .create-process {
    min-height: 60vh;
  }
  .alignBox.fn-main ul li .component {
    min-height: 90px;
  }
}
@media screen and (min-device-height: 580px) and (max-device-height: 629px) {
  .alignBox.fn-main ul li .component {
    min-height: 80px;
  }
  .component h6 {
    font-size: 13px;
  }
  .create-process {
    min-height: 60vh;
  }
}
@media screen and (min-device-height: 430px) and (max-device-height: 579px) {
  .temp-top-section {
    display: inline-block;
    justify-content: space-between;
  }
  .componentScroll .sub-acc {
    background-color: #fff;

    top: 10px;
    right: 0px;
    flex: 0 0 auto;
    width: 100% !important;
    z-index: 100;
    display: inline-block;
    justify-content: flex-end;
    flex-direction: row-reverse;
    position: relative;
  }
  .create-process {
    min-height: 60vh;
  }
  .action-itms.full-drp {
    flex-direction: row !important;
    align-items: flex-start !important;
    display: flex !important;
    justify-content: flex-end !important;
  }
  .alignBox.fn-main ul li .component {
    min-height: 65px;
  }
  .component img.create-icon {
    width: auto;
    max-width: 27px;
    margin-bottom: 13px;
    max-height: 20px;
  }
}
@media (min-device-height: 680px) and (max-device-height: 720px) {
  .container_main.containerSpace.mainWrap .componentScroll .sub-acc {
    max-width: 30.3%;
    width: 24.38% !important;
  }
  .create-process {
    min-height: 60vh;
  }
}
@media (min-device-height: 720px) and (max-device-height: 800px) {
  .create-process {
    min-height: 60vh;
  }
  .container_main.containerSpace.mainWrap .componentScroll .sub-acc {
    max-width: 30.3%;
    width: 25.38% !important;
  }
}
@media (min-device-height: 720px) and (max-device-height: 991px) {
  .container_main.containerSpace.mainWrap .componentScroll .sub-acc {
    /* max-width: 30.3%; */
    /*width: 25.38% !important;*/
    /* width: 24.38% !important; */
  }
  .create-process {
    min-height: 35vh;
  }

  .wraper.scrlHe-tab.scroll.scroll1.temppos-height {
    height: 68vh;
  }
}

@media (min-device-height: 800px) and (max-device-height: 991px) {
  .create-process {
    min-height: 55vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,kCAAkC;EAClC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;;EAEtB;;;;;iBAKe;AACjB;;AAEA;EACE,cAAc;;EAEd,gBAAgB;EAChB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;GAEG;AACH;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;EAgBE,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;;;;;;EAME,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE;;;mBAGiB;EACjB,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA;;;GAGG;AACH;EACE,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,0EAA0E;EAC1E,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gFAAgF;AAClF;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,sDAAsD;EACtD,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;;GAEG;AACH;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE;;;;kBAIgB;EAChB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;AACA;;AAEA;EACE,gBAAgB;;EAEhB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;;;;;GAKG;AACH;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;EACd,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,6CAA6C;EAC7C,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;;AAEA,uBAAuB;;AAEvB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;;;;;;GAUG;;AAEH;;EAEE;;AAEF;EACE,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,mDAAmD;EACnD,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE;;;;;;eAMa;EACb,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,wEAAwE;EACxE,iBAAiB;EACjB,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;;EAEf,YAAY;EACZ,kBAAkB;AACpB;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mDAAmD;EACnD,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;;;;gBAIc;EACd,wDAAwD;EACxD,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,MAAM,EAAE,mDAAmD;EAC3D,6CAA6C;AAC/C;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;;EAEhB;qDACmD;AACrD;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;;GAEG;AACH;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,kCAAkC;EAClC,SAAS;AACX;AACA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;;EAElB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EAEzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;;EAE3B,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kCAAkC;;EAElC,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;;EAElB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;AAClB;AACA;EACE,+DAA+D;EAC/D,gEAAgE;AAClE;AACA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C;oCACkC;AACpC;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;;AAEA,KAAK;;AAEL;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;6BAC2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;;EAEtC,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;;;;;;;GAOG;;AAEH;;;GAGG;AACH;IACI,aAAa;IACb,SAAS;AACb;AACA;OACO,iBAAiB;IACpB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,WAAW;AACf;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;IAEI,sCAAsC;IACtC,6BAA6B;IAC7B,0BAA0B;IAC1B,SAAS;AACb;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,0BAA0B;IAC1B,WAAW;AACf;AACA;IACI,4BAA4B;AAChC;AACA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,0BAA0B;AAC9B;AACA;QACQ,yBAAyB;IAC7B;IACA;IACA,2BAA2B;AAC/B;;AAEA;CACC;IACG,uBAAuB;EACzB;MACI;QACE,yBAAyB;IAC7B;AACJ;AACA;EACE;IACE,uBAAuB;EACzB;MACI;QACE,yBAAyB;IAC7B;AACJ;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;MACI;QACE,yBAAyB;IAC7B;AACJ;;;;;AAKA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,2BAA2B,EAAE,kCAAkC;EACjE;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,gCAAgC;EAChC;kBACgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,wBAAwB;IACxB,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB;;;;GAIC;EACD;kCACgC;AAClC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;;EAEpB,kBAAkB;;EAElB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;;;;;;;EAOE;;AAEF;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,aAAa;AACf;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;;EAEV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE;;;;;;;;;;cAUY;;EAEZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,WAAW;AACb;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,UAAU;AACZ;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;;EAEnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb;yBACuB;AACzB;AACA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,SAAS;EACT,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,sEAAsE;AACxE;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE;oBACkB;EAClB,oCAAoC;EACpC;sBACoB;;EAEpB,wBAAwB;EACxB,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;EACV,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;EAiBE;AACF;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2DAA2D;AAC7D;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,mDAAmD;EACnD,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,wEAAwE;EACxE,iBAAiB;EACjB,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mDAAmD;EACnD,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,wBAAwB;EACxB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B,EAAE,sCAAsC;AACvE;AACA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,gDAAgD;EAChD,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;;EAEvB,uBAAuB;;EAEvB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX;oBACkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,gBAAgB;EAChB,YAAY;AACd;AACA;EACE;;IAEE;;EAEF,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kDAAkD;EAClD,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB;IACE,kBAAkB;IAClB,0CAA0C;EAC5C;EACA;IACE,aAAa;IACb,WAAW;IACX,sDAAsD;EACxD;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;IACX;MACE,UAAU;IACZ;EACF;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,eAAe;IACf;MACE,SAAS;IACX;EACF;AACF;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;AACA;;;;;;;;GAQG;;AAEH;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;kDAGkD;;AAElD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB;gBACc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf;gBACc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE;AACF;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,sCAAsC;EACtC,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;AACA;;;EAGE,gCAAgC;AAClC;;AAEA;;;;;;EAME,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mDAAoD;EACpD,WAAW;EACX,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kCAAkC;;EAElC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,oDAAoD;EACpD,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE;;AAEF;EACE,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE;;yBAEuB;;EAEvB,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,oDAAoD;EACpD,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;;EAEjB,mBAAmB;EACnB,mBAAmB;EACnB,oDAAoD;EACpD,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,2DAA2D;EAC3D,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oEAAgE;EAChE,uCAAuC;EACvC,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;GAEG;AACH;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB;yBACuB;AACzB;AACA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,8CAA8C;EAC9C,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,wCAAwC;EACxC,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;EAEnB,cAAc;EACd,mBAAmB;EACnB,wDAAwD;EACxD,kCAAkC;EAClC,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;EAGE;;AAEF;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mEAAmE;EACnE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;EAChC,+CAA+C;AACjD;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;;;;;;;;;;CAUC;;AAED;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wDAAwD;EACxD,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,wDAAwD;EACxD,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EAEV,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA,QAAQ;;AAER;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,2DAA2D;EAC3D,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA,kDAAkD;;AAElD;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE;;;;;0CAKwC;EACxC,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,wDAAwD;EACxD,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;;;;;;;EAOE;;AAEF;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,wDAAwD;EACxD,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;EAC9C,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE;;;iDAG+C;EAC/C,gBAAgB;EAChB,+CAA+C;EAC/C,gDAAgD;EAChD,gDAAgD;EAChD,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;;AAEA;EACE;;wBAEsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B;8BAC4B;EAC5B,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;;EAEf,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB;;kCAEgC;EAChC,YAAY;EACZ,gBAAgB;;EAEhB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;;;IAOI;AACJ;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;CAEC;EACC;;EAEA;AACF;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;;;;;GAMG;;AAEH;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;;;;CAIC;;AAED;;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,mDAAmD;EACnD,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB;sCACoC;EACpC,SAAS;AACX;AACA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oDAAoD;EACpD,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB;0BACwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,SAAW;EACX,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,wDAAwD;EACxD,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wDAAwD;EACxD,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,kCAAkC;EAClC,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;;;;;CAQC;AACD;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;;;EAGE;AACF;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,kCAAkC;EAClC,0DAA0D;EAC1D,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB;yBACuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,wCAAwC;EACxC,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA,KAAK;AACL;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE;;4BAE0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW,EAAE,sCAAsC;EACnD,YAAY;EACZ,iBAAiB,EAAE,uCAAuC;AAC5D;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;oBACkB;EAClB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE;;;;kBAIgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB;gBACc;EACd,aAAa;AACf;;AAEA;EACE,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,aAAa;AACf;AACA;EACE,uEAAuE;EACvE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+CAA+C;EAC/C,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;;;iBAGe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB;mBACiB;AACnB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,oDAAoD;EACpD,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf;0BACwB;EACxB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;AACA;EACE,oDAAoD;EACpD,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe,EAAE,+BAA+B;EAChD,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA,uBAAuB;AACvB;EACE,SAAO;AACT;AACA;EACE,WAAW;AACb;AACA;;EAEE;AACF;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA,8BAA8B;;AAE9B;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,OAAO;AACP;EACE,wBAAwB;EACxB,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;;EAEE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,aAAa;EACb,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qBAAqB;;AAErB;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,YAAY;EACd;AACF;;AAEA;;;;EAIE;;AAEF;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,UAAU;IACV,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;IAClC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR;;;;;KAKG;AACL;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,wBAAwB;EACxB,wBAAwB;EACxB,SAAS;EACT,QAAQ;EACR,YAAY;;EAEZ;;;;;;;;;;;;;;wBAcsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA,UAAU;AACV;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;;;;GAIG;AACH;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;;EAEhB,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;;EAEjB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX;;+BAE6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB;gBACc;AAChB;AACA;EACE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;AACA;;;;;;;;;;;;;EAaE;AACF;;;;;EAKE;AACF;;EAEE,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;EAaE;;AAEF;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,UAAU;EACV,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,SAAS;EACT,UAAU;AACZ;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,sEAAsE;EACtE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,2EAA2E;EAC3E,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;;EAET,WAAW;AACb;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;AACA;;EAEE,UAAU;EACV,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,+DAA+D;EAC/D,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,SAAS;AACX;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,SAAS;EACT;;gCAE8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE;;;;;;;;;;;;;;;;iBAgBe;EACf,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,gBAAgB;;EAEhB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;;;;GAUG;AACH,uGAAuG;;AAEvG;EACE,8BAA8B;EAC9B,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sEAAsE;AACxE;AACA;EACE,mCAAmC;EACnC,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB;qBACmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,wCAAwC;EACxC,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;EAKE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;;;;EAKE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;;;;;;;;;;EAWE,UAAU;AACZ;;AAEA;EACE,mDAAwC;EACxC,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,mDAA0C;EAC1C,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,mDAA6C;EAC7C,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,mDAAyC;EACzC,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,mDAA2C;EAC3C,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,mDAA0C;EAC1C,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,mDAA4C;EAC5C,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,mDAAmC;EACnC,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,oDAAyC;EACzC,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,oDAAmC;EACnC,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,oDAAmC;EACnC,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;EACjD,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B,YAAY;AACZ;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oCAAoC;AACtC;AACA,kCAAkC;;AAElC;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,MAAM;EACN,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;IACf,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB;IACzB,oDAAoD;IACpD,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,yCAAyC;IACzC,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA,QAAQ;;EAER;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,WAAW;EACb;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;;;;;GAQG;AACH;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,8BAA8B;EAChC;EACA;IACE,sBAAsB;;IAEtB,SAAS;IACT,UAAU;IACV,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,kCAAkC;IAClC,wBAAwB;IACxB,oCAAoC;EACtC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700&display=swap\");\n\nbody {\n  /* background: #FBFBFB; */\n  margin: 0 !important;\n  padding: 0px !important;\n  font-family: \"Manrope\", sans-serif;\n  height: 100vh;\n}\n.rdw-link-decorator-wrapper {\n  margin-bottom: 10px !important;\n}\n\n.rdw-link-decorator-icon {\n  position: absolute !important;\n  left: 100% !important;\n  top: 10px !important;\n  cursor: pointer !important;\n  background-color: white !important;\n  width: 30% !important;\n  margin-bottom: 20px;\n}\n\n.componentScroll {\n  position: relative;\n}\n\n.componentScroll .sub-acc {\n  background-color: #fff;\n\n  /* position: fixed;\n  top: 112px;\n  right: 20px;\n  flex: 0 0 auto;\n  width: 25.333333%;\n  z-index: 100; */\n}\n\n.buildLeftDiv .left-fixed {\n  flex: 0 0 auto;\n\n  position: sticky;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 100;\n}\n\n.form-features.bxShw.wraper.outer_bord.scrollling-editzz {\n  /* padding: 2rem; */\n  overflow-y: auto;\n  /*height: 100%;*/\n}\n\n.edit-right-fixes {\n  /*background-color: #FFF;*/\n  position: sticky;\n  right: 20px;\n  flex: 0 0 auto;\n  width: 100%;\n  /* z-index: 100;*/\n  top: 100px;\n}\n.setupRightDiv {\n  position: relative;\n}\n\n.buildLeftDiv {\n  position: relative;\n}\n.container_main.containerSpace.mainWrap .componentScroll .sub-acc {\n  width: 25.2%;\n}\n.container_main.collapseView .componentScroll .sub-acc {\n  width: 28.35% !important;\n}\n\n.sidebar_open.main-content.edit.hight-av .scrollling-editzz {\n  /*height: 1000px !important;*/\n  position: relative;\n}\n\n/* body::-webkit-scrollbar {\n    display: none;\n} */\na,\nbutton {\n  transition: all ease 0.5s;\n}\n\nhtml,\nbody,\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nimg,\nform,\ninput,\nselect,\ntextarea,\nul,\nli {\n  margin: 0;\n  padding: 0;\n  color: #000;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Manrope\", sans-serif;\n  color: #302b3a !important;\n}\n\nul li {\n  list-style: none;\n}\n\nimg {\n  border: none;\n  width: 100%;\n}\n\np {\n  font-size: 15px;\n  color: var(--color3);\n  font-size: 15px;\n}\n\na {\n  transition: all ease 0.5s;\n  text-decoration: none !important;\n  color: var(--color2);\n}\n\n.clear {\n  height: 0;\n  margin: 0;\n  padding: 0;\n  clear: both;\n  font-size: 0;\n  line-height: 0;\n}\n\n:root {\n  --color1: #3a68d8;\n  --color2: #252628;\n  --color3: #302b3a;\n  --colorGrey: #666666;\n}\n\n.rightCont.top-id-fixes {\n  margin-top: 95px;\n}\nlabel.w4form-l.sounth {\n  margin: -35px 0px 0px 33px;\n  font-size: 15px;\n}\n.logoContainer img {\n  /*width: 130px;\n     width: 100%;\n    height: 72px;\n      width: 50px;*/\n  width: 130px;\n  height: 50px;\n  margin: 0px 0px 0px 3px;\n}\n.hd-can.create-form-wrp p {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: px 0px 0px 40px;\n}\n.nav-link {\n  display: flex;\n  align-items: center;\n}\n\nul {\n  list-style: none;\n  padding-left: 0px !important;\n}\nbutton.send-req-btn.rounded.p-2 {\n  color: #fff;\n  border: 0;\n  width: auto;\n  justify-content: space-between;\n  background: #3a68d8;\n  text-align: center;\n  max-width: 140px;\n  font-size: 15px;\n  padding: 10px 10px 10px 10px !important;\n}\nspan.act-ever {\n  float: right;\n  cursor: auto;\n}\n\na.text-primary.cont-admin {\n  cursor: pointer;\n}\n/* ul.nav {\n    display: flex;\n    flex-direction: column;\n} */\nul#accordionFlushExample {\n  /*max-height: calc(100vh - 9rem);*/\n  overflow-y: auto;\n  width: 100%;\n}\n.sidebar ul#accordionFlushExample {\n  overflow: unset;\n}\n.logoContainer h1 {\n  margin-bottom: 0px;\n  font-size: 30px;\n}\n\nnav.sidebar {\n  /* padding: 0px 25px;*/\n  padding: 0px 0px;\n}\n\n.searchere input {\n  padding: 8px 0px 3px 30px;\n  border: 0;\n  box-shadow: none;\n}\n\n.searchere {\n  position: relative;\n  display: flex;\n  width: 100%;\n  padding-bottom: 0px;\n  align-items: center;\n  /* gap: 17px; */\n  border-bottom: 1px solid var(--graphic-objects-components-wcagaa, #949494);\n  margin: 0px;\n}\n\n.searchere-sidebar {\n  position: relative;\n  display: flex;\n  width: 100%;\n  padding: 0px;\n  align-items: center;\n  /* gap: 17px; */\n  /* border-bottom: 1px solid var(--graphic-objects-components-wcagaa, #949494); */\n}\n.searchere-sidebar img {\n  width: 12px;\n}\n.form-contro .side-input {\n  padding: 6px 4px 10px 50px;\n}\n\n.serach-width-div img.menu_icon.search {\n  position: absolute;\n  left: 8px;\n  top: 21px;\n  width: 15px;\n}\n.q-btns.my-3.d-flex.justify-content-end.modal-bttn.footer-bttn {\n  margin: 0 0 20px !important;\n}\n\n.form-name-edit {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.form-name {\n  /*color: var(--Avenu-Black, #302B3A);*/\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--Active-State, #3a68d8);\n}\nimg.menu_icon.search-sidebar {\n  position: absolute;\n  left: 25px;\n  top: 17px;\n  text-decoration: none;\n}\n\n.righTitles {\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  color: var(--Avenu-Black, #302b3a);\n}\n\nform.form {\n  margin: 0px 0px 0px 105px;\n}\n.container-upload {\n  background-color: #fff;\n  padding: 40px 80px;\n  border-radius: 8px;\n  box-shadow: 0px 0px 24.08px 3.92px rgba(0, 0, 0, 0.25);\n  margin: 70px 0px 0px 20px;\n  width: 95%;\n}\n.detail-tabs .tabSpace .react-tabs__tab:nth-child(1) {\n  margin-left: 1rem;\n}\n.detail-tabs ul.tabSpace {\n  margin: 0 0 0.6rem;\n}\nbutton.accordion-button {\n  padding: 0px 0px;\n}\n\n/* .sidebar.active a.nav-link.active {\n    border-radius: 10px;\n} */\n.accordion-button:focus {\n  border-color: none;\n  box-shadow: none;\n}\n\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: #fff !important;\n  box-shadow: none !important;\n}\n\n.form-control:focus {\n  box-shadow: none;\n}\n\n.accordion-body {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n  margin-bottom: 5px;\n}\n\nul.nav.submenu li a span {\n  color: #949494;\n}\n\n.searchere img {\n  width: 12px;\n}\n\n.layoutmain {\n  display: flex;\n}\n\nmain {\n  flex: 1;\n}\n\nheader {\n  /*display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 20px;\n    height: 75px;*/\n  display: flex;\n  width: 100%;\n  height: 92px;\n  padding: 0px 20px;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  border-bottom: 1px solid #ccc;\n  background: #fff;\n  padding-left: 10px;\n}\n\n.hd-left {\n  display: flex;\n  align-items: center;\n}\n\nol.breadcrumb {\n  margin-bottom: 0px;\n}\n\nHeader select.form-select {\n  border-radius: 0px !important;\n  margin-left: 15px;\n  border: 0;\n}\n\nbutton.menu-btn img {\n  width: 22px;\n  height: 24px;\n}\n\nbutton.menu-btn {\n  border: 0;\n  background: none;\n}\n\n.txt-black {\n  color: #000;\n}\n\n.txt-blue {\n  /* color: blue;*/\n  color: #083ab5;\n  text-decoration: underline;\n  text-decoration-color: blue;\n}\n\n.userarea img {\n  width: 40px;\n}\n\n.userarea button {\n  background: none !important;\n  border: 0;\n  padding: 0 0 0 10px;\n}\n\nspan.username {\n  margin-left: 10px;\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.form-select:focus {\n  border-color: #fff;\n  outline: 0 !important;\n  box-shadow: none !important;\n}\n\n.logoContainer::after {\n  content: \"\";\n  position: absolute;\n  background: #ccccccad;\n  bottom: -1px;\n  /* left: -50px;*/\n  width: 320px;\n  height: 1px;\n}\n\n.logoContainer {\n  position: relative;\n}\n\nnav.sidebar.active .logoContainer h1,\nnav.sidebar.active span.menu-title,\nnav.sidebar.active .accordion-button::after {\n  font-size: 0;\n}\nnav.sidebar.active .res-icon {\n  display: none;\n}\nnav.sidebar.active .logo-bttn {\n  display: none;\n}\n\nnav.sidebar.active .give-us {\n  display: flex;\n  justify-content: center;\n  display: none;\n}\n\nnav.sidebar.active .advan-text {\n  display: flex;\n  justify-content: center;\n  display: none;\n}\n\nnav.sidebar .menu_icon .sub-iicons.active {\n}\n\nnav.sidebar.active {\n  /* width: 35%; */\n\n  width: 85px;\n  padding: 0px 10px;\n}\n\nspan.username img {\n  width: 10px;\n}\n\n/* edit forms css start */\n\n.onb-actions {\n  display: flex;\n  align-items: center;\n}\n\n.onb-actions a img {\n  width: 23px;\n}\n\n.onb-actions select {\n  width: 40%;\n  margin-right: 20px;\n}\n\n.onb-actions a {\n  display: flex;\n  min-width: 140px;\n  justify-content: center;\n  color: #302b3a;\n}\n.onb-actions.fontSty .btn-primary {\n  color: var(--color3);\n  font-size: 15px;\n  font-family: \"Manrope\", sans-serif !important;\n  font-weight: 400;\n  cursor: pointer;\n}\n.action-itms-forms {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.onb-actions a img {\n  margin-right: 12px;\n}\n\n.info img {\n  width: 15px;\n}\n\n.create-sec.onb-actions a {\n  width: inherit;\n}\n\n.create-sec.onb-actions a {\n  width: inherit;\n}\n\n.create-sec.onb-actions {\n  justify-content: flex-end;\n}\n\n.f-btns .btn img {\n  width: 20px;\n}\n.formInner .f-btns .btn {\n  background: transparent;\n}\n.hight-av .upload-btns a {\n  color: #666 !important;\n}\n\n.formInner .upload-btns .up-btn.btn {\n  margin: 0;\n  color: #302b3a;\n  font-weight: 500;\n  font-size: 15px;\n  font-family: \"Manrope\", sans-serif !important;\n}\n.inpAlig .subtits {\n  color: #666;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.wraper {\n  float: left;\n  width: 100%;\n}\n/* .formInner .form-hd .left_titlSpc{\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: left;\n} */\n.left_titlSpc p {\n  font-size: 14px;\n  color: #666666;\n  margin: 5px 0;\n  padding: 0 0 0 15px;\n}\n.b-0 {\n  border: 0 !important;\n}\n\n.inpAlig .subHead_inp.main-title {\n  color: #302b3a;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  padding: 5px 0 !important;\n}\n.inpAlig .subHead_inp {\n  font-size: 13px;\n  font-weight: 500;\n  font-family: \"Manrope\", sans-serif !important;\n  color: #666666;\n  padding: 0;\n}\n.formAlg-new .inpAlig .subHead_inp {\n  font-size: 13px;\n  font-weight: 500;\n  font-family: \"Manrope\", sans-serif !important;\n}\n.formAlg-new .inpAlig .main-title {\n  font-size: 15px !important;\n  font-weight: 500 !important;\n  margin: 5px 0 0px;\n  font-family: \"Manrope\", sans-serif !important;\n  padding: 0;\n  color: var(--color3);\n}\n.formAlg-new .inpAlig .main-title::placeholder {\n  color: var(--color3);\n}\n\n.formInner .form-features.newone {\n  padding: 0px;\n}\n.f-itm.newOne .f-btns .btn {\n  height: 30px;\n  margin: 0px 5px;\n  padding: 0;\n}\n.form-features.outer_bord {\n  padding: 2rem;\n}\n.formInner .bxborder.newPads_editform {\n  padding: 15px 15px;\n}\n.formInner .bxborder {\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n  padding: 39px 40px;\n}\n\n.titDrag {\n  color: #302b3a;\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\ninput.form-control.widthInp.input-edit-text1.my-0 {\n  color: #666;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\ninput.form-control.widthInp.input-edit-text.my-0 {\n  color: #302b3a;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.sub-head-color {\n  font-size: 14px;\n  color: #666666;\n  font-weight: 500;\n  font-family: \"Manrope\", sans-serif !important;\n}\n.titDrag-sub {\n  color: #666;\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 13px;\n  font-weight: 500;\n}\n.f-btns .btn {\n  width: 44px;\n  height: 44px;\n  background: #fbfbfb;\n  margin: 5px 5px;\n  text-align: center;\n  border: none;\n}\n.dragBtn {\n  width: 30px;\n  height: 44px;\n  background: #fbfbfb;\n  margin-right: 10px;\n  text-align: center;\n  padding: 3px !important;\n}\n.dragBtn img {\n  width: 6px !important;\n  margin: 0 !important;\n}\n\n/* .f-btns .btn:last-child img {\n    width: 5px;\n} */\n\n.f-btns .btn:last-child {\n  margin-right: 0px;\n}\n\n.f-itm {\n  display: flex;\n  justify-content: space-between;\n  background: #fff;\n  padding: 10px;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.form-features {\n  width: 100%;\n  background: #fbfbfb;\n  padding: 20px;\n  margin-bottom: 12px;\n  display: flex;\n  flex-direction: column;\n}\n\n.f-itm span img {\n  width: 18px;\n  margin-right: 20px;\n}\n\nh6.form-hd img {\n  width: 5px;\n  margin-left: 10px;\n}\nh6.form-hd img.mrR {\n  margin: 0 10px 0 0;\n}\n\n.upload {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.upload img {\n  width: 40px;\n  margin-bottom: 12px;\n}\n\n.fileupload {\n  border: 1px dashed #3a68d8;\n  border-radius: 30px;\n  padding: 40px;\n}\n\n.fileuploadExceed {\n  border: 1px dashed red;\n  border-radius: 30px;\n  padding: 40px;\n}\n\n.file-view {\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.upload h3 {\n  font-size: 22px;\n}\n\nbutton.up-btn.btn {\n  border: 1px solid #949494;\n  border-radius: 10px;\n  background: #fff;\n  margin-right: 20px;\n  padding: 10px 25px;\n}\n\n.upload-btns a {\n  color: #949494;\n  text-decoration: underline !important;\n}\n\nbuton.up-btn.btn:hover {\n  background: var(--color1);\n  border-color: var(--color1);\n  color: #fff;\n}\n\n/* edit forms css end */\n\n.ReactModal__Content.ReactModal__Content--after-open {\n  position: inherit;\n  max-width: 550px;\n  width: 100%;\n  margin: auto;\n  height: 390px;\n}\n\n/*\n.ReactModal__Overlay.ReactModal__Overlay--after-open {\n    background-color: rgb(0 0 0 / 33%);\n}.ReactModal__Overlay.ReactModal__Overlay--after-open {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n} .modal-body {\n    overflow: scroll;\n    height: 55vh;\n} */\n\n/*select {\n    -webkit-appearance: listbox !important;\n}*/\n\n.modal-footer .btn-primary {\n  background: #ecf1ff;\n  border: 0;\n  color: var(--color1);\n  padding: 8px 35px;\n}\n.modal-footer .Cancel-pop {\n  background: transparent;\n  border: 0;\n  color: #666;\n  padding: 8px 30px;\n  border-radius: 5px;\n  min-height: 39px;\n}\n.modal-footer .Cancel-pop:hover {\n  background: #666666;\n  border: 0;\n  color: #fff;\n  padding: 8px 30px;\n}\n.vdo.mt-4.mb-3 {\n  position: relative;\n  display: flex;\n  justify-content: space-around;\n}\n\nimg.send_icon {\n  position: absolute;\n  right: 20px;\n  top: 0px !important;\n  /* left: 10px; */\n  /* bottom: 50%; */\n}\nimg.play-btn {\n  width: 30px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.filter-divs {\n  display: contents;\n}\n.chathead {\n  position: absolute;\n  top: 84%;\n  left: 16px;\n  right: 16px;\n}\n.w4form-l {\n  margin: 3px 0px 0px 10px;\n  font-size: 15px;\n}\nselect#your-message {\n  height: 63px;\n}\n.head-l {\n  font-size: 16px;\n  text-align: center;\n}\n.mul-txt {\n  color: #000;\n  background-color: rgb(255, 255, 255);\n  font-size: 15px;\n  font-family: Manrope, sans-serif;\n}\n.text-class {\n  max-height: 65px;\n}\n.radio-sizee {\n  font-size: 20px;\n}\n.para-fonts {\n  font-size: 15px;\n}\n\ninput.form-control.mesg-cht {\n  min-height: 65px;\n  padding-right: 10%;\n}\n.msgScroll {\n  min-height: 100% !important;\n}\n\n.container {\n  max-width: 1170px;\n  margin: auto;\n}\nimg {\n  max-width: 100%;\n}\n.inbox_people {\n  background: #f8f8f8 none repeat scroll 0 0;\n  float: left;\n  /*overflow: hidden;*/\n  width: 40%;\n  border-right: 1px solid #c4c4c4;\n}\n.inbox_msg {\n  border: 1px solid #c4c4c4;\n  clear: both;\n  overflow: hidden;\n}\n.top_spac {\n  margin: 20px 0 0;\n}\n\n.recent_heading {\n  float: left;\n  width: 40%;\n}\n.srch_bar {\n  display: inline-block;\n  text-align: right;\n  width: 60%;\n}\n.headind_srch {\n  padding: 10px 29px 10px 20px;\n  overflow: hidden;\n  border-bottom: 1px solid #c4c4c4;\n}\n\n.recent_heading h4 {\n  color: #05728f;\n  font-size: 21px;\n  margin: auto;\n}\n.srch_bar input {\n  border: 1px solid #cdcdcd;\n  border-width: 0 0 1px 0;\n  width: 80%;\n  padding: 2px 0 4px 6px;\n  background: none;\n}\n.srch_bar .input-group-addon button {\n  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;\n  border: medium none;\n  padding: 0;\n  color: #707070;\n  font-size: 18px;\n}\n.srch_bar .input-group-addon {\n  margin: 0 0 0 -27px;\n}\n\n.chat_ib h5 {\n  font-size: 15px;\n  color: #464646;\n  margin: 0 0 8px 0;\n}\n.chat_ib h5 span {\n  font-size: 13px;\n  float: right;\n}\n.chat_ib p {\n  font-size: 14px;\n  color: #989898;\n  margin: auto;\n}\n.chat_img {\n  float: left;\n  width: 11%;\n}\n.chat_ib {\n  float: left;\n  padding: 0 0 0 15px;\n  width: 88%;\n}\n\n.chat_people {\n  overflow: hidden;\n  clear: both;\n}\n.chat_list {\n  border-bottom: 1px solid #c4c4c4;\n  margin: 0;\n  padding: 18px 16px 10px;\n}\n.inbox_chat {\n  height: 550px;\n  overflow-y: scroll;\n}\n\n.active_chat {\n  background: #ebebeb;\n}\n\n.incoming_msg_img {\n  display: inline-block;\n  width: 30px;\n}\n.received_msg {\n  display: inline-block;\n  padding: 0 0 0 10px;\n  vertical-align: top;\n  width: 92%;\n}\n.received_withd_msg p {\n  /*background: #ebebeb none repeat scroll 0 0;\n  border-radius: 3px;\n  color: #646464;\n  font-size: 14px;\n  margin: 0;\n  padding: 5px 10px 5px 12px;\n  width: 100%;*/\n  background-color: #e9ecef85;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.5rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  padding: 5px 10px;\n  word-break: break-all;\n  width: fit-content;\n}\n\n.time_date-left {\n  color: #666666;\n  display: block;\n  font-size: 12px;\n  /*padding: 0px 0px 0px 75px; */\n  margin-bottom: 5px;\n  float: left;\n  position: relative;\n  left: 80px;\n  top: -10px;\n}\n.time_date-right {\n  color: #666666;\n  display: block;\n  font-size: 12px;\n  padding: 0px;\n  margin-bottom: 9px;\n  float: right;\n  position: relative;\n  left: -65px;\n  top: -5px;\n}\n.time_date {\n  color: #666666;\n  display: block;\n  font-size: 12px;\n\n  padding: 0px;\n  margin-bottom: 9px;\n}\n/*.received_withd_msg { width: 57%;}*/\n.mesgs {\n  float: left;\n  padding: 30px 15px 0 25px;\n  width: 60%;\n}\n\n.sent_msg p {\n  border-radius: 3px;\n  font-size: 14px;\n  margin: 0;\n  padding: 5px 10px 5px 12px;\n  /* width: 100%;  */\n  text-align: end;\n}\n.outgoing_msg {\n  overflow: hidden;\n  margin: 26px 0 26px;\n}\n.sent_msg {\n  float: right;\n  /* width: 46%; */\n}\n.input_msg_write input {\n  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;\n  border: medium none;\n  color: #4c4c4c;\n  font-size: 15px;\n  min-height: 48px;\n  width: 100%;\n}\n\n.type_msg {\n  border-top: 1px solid #c4c4c4;\n  position: relative;\n}\n.msg_send_btn {\n  background: #05728f none repeat scroll 0 0;\n  border: medium none;\n  border-radius: 50%;\n  color: #fff;\n  cursor: pointer;\n  font-size: 17px;\n  height: 33px;\n  position: absolute;\n  right: 0;\n  top: 11px;\n  width: 33px;\n}\n.messaging {\n  padding: 0 0 50px 0;\n}\n.msg_history {\n  /*height: 516px;*/\n  overflow-y: auto;\n}\n\n.msg_send_btn {\n  background: transparent;\n  border: 0;\n  outline: 0;\n  border-radius: 0;\n  color: #fff;\n  cursor: pointer;\n  font-size: 0;\n  width: 36px;\n  height: 36px;\n  margin: 0;\n  padding: 0;\n  float: right;\n}\n.input_msg_write input {\n  background: #fff;\n  border: 0;\n  color: #302b3a;\n  font-size: 16px;\n  font-weight: 500;\n  min-height: 58px;\n  width: calc(100% - 38px);\n  border-radius: 0px;\n}\n.input_msg_write {\n  background: #fff;\n  border: 1px solid #dfdfdf;\n  padding: 0 15px;\n  border-radius: 10px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.d-flex.detail-user {\n  position: relative !important;\n}\n\n.video-thumb {\n  height: 476px;\n  width: 100%;\n  border-radius: 15px;\n}\n\n.secBox {\n  border: 1px solid #dfdfdf;\n  border-radius: 10px;\n  color: #302b3a;\n  background-color: #fff;\n}\n.sidebar_open.noBg {\n  background-color: transparent;\n  border: 0;\n  padding: 5px;\n  border-radius: 0;\n  height: 80vh;\n}\n.serchField {\n  border-bottom: 1px solid #a4a4a4;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  padding: 10px;\n  margin: 0;\n}\n.serchField .serc_icon {\n  width: 15px;\n  float: left;\n  margin-right: 8px;\n}\n.serchField .sercInp {\n  /* border: 0;\n    width: 100%;\n    box-shadow: inherit;\n    font-size: 14px;\n    outline: 0;*/\n  color: var(--graphic-objects-components-wcagaa, #949494);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  width: 100%;\n  box-shadow: inherit;\n  border: 0;\n  outline: 0;\n}\n.inpCheckbx {\n  font-size: 15px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n.inpCheckbx input[type=\"checkbox\"] {\n  margin-right: 5px;\n}\n.inpCheckbx .DltBtn {\n  margin: 0 10px;\n  padding: 0;\n  line-height: 12px;\n}\n.inpCheckbx .DltBtn img.menu_icon {\n  width: 16px;\n}\n\n.fileTable .arrow_icon {\n  width: 10px;\n}\ntable.fileTable {\n  color: #302b3a;\n  position: relative;\n  border-collapse: collapse;\n}\n.tableFixHead .fileTable th {\n  background: white;\n  position: sticky;\n  top: 0; /* Don't forget this, required for the stickiness */\n  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);\n}\n.fileTable th {\n  font-weight: 600;\n  font-size: 18px;\n  color: #302b3a;\n  vertical-align: middle;\n  padding: 0.7rem 0.8rem !important;\n}\n.fileTable td {\n  font-weight: 400;\n  font-size: 14px;\n  color: #302b3a;\n  border: 0;\n  vertical-align: middle;\n  padding: 0.7rem 0.8rem !important;\n}\n.fileTable select {\n  background: #ffb900;\n  color: #000;\n  border: 1px solid #ffb900;\n  border-radius: 60px;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 0px 5px;\n  outline: 0;\n  box-shadow: inherit;\n}\n\n.fileTable .actionBtn {\n  background: transparent;\n  border: 0;\n  outline: 0;\n  box-shadow: inherit;\n  padding: 5px;\n  margin: 0 5px 0 0;\n}\n.fileTable .actionBtn img {\n  width: 16px;\n}\n.fileTable tr {\n  border-bottom: 1px solid #e8e8e8;\n}\n.fileTable .frntTxt {\n  display: flex;\n  flex-direction: row;\n  float: left;\n  margin: 2px 7px 0 0;\n}\n.fileTable .frntTxt .folder_icon {\n  width: 16px;\n  margin: 0 5px 0 8px;\n}\n\n.tableFixHead {\n  overflow-y: auto;\n\n  /*\n  max-height: 945px;max-height: 450px; height: 100%;*/\n}\n\ntbody.table-text-body.on-docs-dive {\n  height: 100%;\n  /* display: contents; */\n}\n.pagination {\n  margin: 10px 0 5px;\n  text-align: center;\n  width: 100%;\n}\n.pagination.centPag {\n  display: flex;\n  justify-content: center;\n}\n.pagination > a {\n  background: transparent;\n  color: #302b3a;\n  width: 30px;\n  height: 30px;\n  border-radius: 60px;\n  text-align: center;\n  line-height: 28px;\n  margin-right: 5px;\n  font-size: 14px;\n}\n.pagination > a.active {\n  background: #3a68d8;\n  color: #fff;\n}\n\n.alignBox ul {\n  width: 100%;\n}\n\n.alignBox.fn-main ul li {\n  width: 100%;\n  padding: 5px;\n}\n\n.alignBox.fn-main ul .boxDiv {\n  width: 50%;\n  float: left;\n  margin: 0px;\n}\n.alignBox.fn-main ul li .component {\n  padding: 10px 5px !important;\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background-color: white;\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.leftCont {\n  width: 100%;\n}\n/* .BuilderWrap{\n\n} */\n.formSect {\n  background: #fff;\n  padding: 5px 10px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  width: 100%;\n}\n.inp_titles {\n  /* font-size: 24px;*/\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0px !important;\n}\n.textArea {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  resize: none;\n}\n.formSect .inpTxt {\n  border: 0;\n  width: 100%;\n  padding: 10px;\n  box-shadow: inherit;\n  outline: 0;\n  /* color: #949494; */\n  color: var(--avenu-black, #302b3a);\n  margin: 0;\n}\n.formSect .inpTxt::placeholder,\n.public-DraftEditorPlaceholder-root {\n  color: #949494 !important;\n  margin-top: 10px;\n}\n\n.algLabel .public-DraftEditorPlaceholder-root {\n  margin: 0;\n  font-size: 14px !important;\n  font-weight: 400;\n}\n.padd-titles {\n  padding-left: 5px !important;\n}\n\n.form_titles {\n  padding: 0 0 10px;\n  margin: 5px 0 15px;\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.iconGrp .inp-icon {\n  width: 19px;\n  margin: 0 5px 0 15px;\n  cursor: pointer;\n}\n.formSect .topSect {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.formSect .iconGrp {\n  border-left: 1px solid #dfdfdf;\n  padding: 5px 0;\n  margin: 0 0 0 10px;\n\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.formSect .topSect h6 {\n  margin: 5px 0;\n  padding: 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.formSect .align-icon {\n  max-width: 19px;\n  margin-right: 10px;\n  height: auto;\n  max-height: 19px;\n}\n\n.formSect hr {\n  opacity: 0.1;\n}\n\n.formSect .close-icon {\n  width: 23px;\n}\n\n.sub-acc.padSpace {\n  padding: 15px 25px;\n}\n\n.formSect .inpWid {\n  width: calc(100% - 50px);\n  float: left;\n}\n\n.formSect .btnWid {\n  width: 50px;\n  /* float: right; */\n}\n.alginBtn {\n  justify-content: end;\n  display: flex;\n  align-items: center;\n}\n.alginBtn img.close-icon {\n  margin: 0;\n  cursor: default;\n}\n\n.alinBx {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.alinBx .LeftCont {\n  width: 35px;\n}\n.alinBx .RightCont {\n  width: calc(100% - 35px);\n}\n\n.alinBx .btn {\n  padding: 5px;\n  border: 0;\n  outline: 0;\n}\n.alinBx .btn img {\n  width: 7px;\n}\n\nlabel.switch.togSw.create-toogle {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 17px;\n  max-width: 42px;\n  margin-left: 0px;\n}\n.switch.togSw {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 17px;\n  max-width: 42px;\n  margin-left: 15px;\n}\n\n.switch.togSw input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.switch.togSw .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #fff;\n  border: 2px solid #949494;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.switch.togSw .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 9px;\n  width: 9px;\n  left: 3px !important;\n  bottom: 2px;\n  background-color: #949494;\n  transition: 0.4s;\n  top: 3px;\n}\n\n.switch.togSw input:checked + .slider {\n  background-color: #fff;\n  border: 2px solid #3a68d8;\n}\n\n.switch.togSw input:focus + .slider {\n  box-shadow: 0 0 1px #3a68d8;\n}\n\n.switch.togSw input:checked + .slider:before {\n  -webkit-transform: translateX(24px);\n  -ms-transform: translateX(24px);\n  transform: translateX(24px);\n\n  background-color: #3a68d8;\n  left: 0px;\n}\n\n.switch.togSw .slider.round {\n  border-radius: 34px;\n}\n\n.switch.togSw .slider.round:before {\n  border-radius: 50%;\n}\n\n.reqDiv {\n  display: flex;\n  align-items: center;\n}\n\n.reqDiv .labTog {\n  margin-right: 20px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.topSect label.form-check-label {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n\n  font-style: normal;\n\n  line-height: normal;\n}\n\n.btnTxts .btn.txtBtn {\n  background: #3a68d8;\n  color: #fff;\n  border-radius: 0;\n  border: 0;\n  width: 30px;\n  height: 25px;\n  padding: 2px;\n  line-height: 10px;\n  border-right: 1px solid #ffffff70;\n}\n.btnTxts .btn.txtBtn img {\n  width: 13px;\n}\n\n.btnTxts .btn.txtBtn:hover,\n.btnTxts .btn.txtBtn:focus {\n  background: #204dbd;\n  box-shadow: inherit;\n  outline: 0;\n}\n.pl-0 {\n  padding-left: 0 !important;\n}\n.pr-0 {\n  padding-right: 0 !important;\n}\n\n.adBtn_mr img.add-more {\n  width: 18px;\n  margin-right: 5px;\n}\n\n.formSect .adBtn_mr {\n  display: flex;\n  align-items: center;\n  padding: 5px 0;\n  font-size: 14px;\n  color: #949494;\n  margin: 10px 0;\n}\n.email-table {\n  color: #302b3a;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.sub-text-link {\n  font-size: 13px;\n  margin: 0px 5px 0px 0px;\n}\n.sub-text {\n  font-size: 12px;\n  color: #666;\n  margin: 0px 0px 0px 0px;\n}\n.form-select .drop-select:focus {\n  border: 1px solid transparent;\n  border-bottom: 1px solid #dee2e6 !important;\n  box-shadow: inherit !important;\n}\n.close-bttn {\n  border: none;\n  background: none;\n  /* margin-left: 260px; */\n  margin-top: 14px;\n  float: right;\n}\n\n.topnav {\n  overflow: hidden;\n}\n.topnav a {\n  float: left;\n  text-align: center;\n  padding: 4px 30px;\n  text-decoration: none;\n  font-size: 15px;\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 12.133px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  position: relative;\n  margin-bottom: 15px;\n}\n\n/* Create a right-aligned (split) link inside the navigation bar */\n.topnav a.split {\n  float: right;\n  background-color: #04aa6d;\n  color: white;\n}\n\n.tage-menu {\n  background: #9be7ff;\n  color: #000000;\n  padding: 2px 36px 8px 20px;\n  border-radius: 30px;\n  justify-content: center;\n  position: relative;\n  display: inline-block;\n  margin-right: 15px;\n\n  height: 25px;\n}\n\n.tag-img {\n  width: 20px;\n  margin: 0px 0px 0px -25px;\n  /* z-index: 1000 !important; */\n}\n\n.accordion-flush .accordion-item .accordion-button,\n.accordion-flush .accordion-item .accordion-button.collapsed {\n  border-radius: 0;\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0\n    var(--bs-accordion-border-color);\n}\n[type=\"button\"]:not(:disabled),\n[type=\"reset\"]:not(:disabled),\n[type=\"submit\"]:not(:disabled),\nbutton:not(:disabled) {\n  cursor: pointer !important;\n}\n.accordion-button.tag {\n  width: 100% !important;\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: #fff !important;\n  box-shadow: none !important;\n}\n.accordion-button {\n  width: 100% !important;\n}\n\n/*pv*/\n\nbutton.update-btn.rounded.p-2.appro-btton-gray {\n  float: right;\n  background: gray;\n}\n\nbutton.update-btn.rounded.p-2.appro-btton {\n  float: right;\n  background: #3a68d8;\n}\n\n.Copy-Process-mod-inner {\n  padding: 20px 25px 0px 25px;\n}\n\nbutton.submits-btn.rounded.p-2.sub-bttn-right-sides.temp-creat-bttn.on-temp.mx-2 {\n  min-width: 118px;\n  width: 100%;\n  height: 35px;\n}\n\nbutton.submits-btn.rounded.p-2.sub-bttn-right-sides.e-vef-bttn-sub.on-temp.mx-2 {\n  min-width: 118px;\n  width: 100%;\n  height: 35px;\n}\n\nbutton.btn.btn-primary.doct-upload {\n  height: 30px;\n  padding: 0px 7px 0px 7px;\n  font-size: 12px;\n}\n\n/* Container for Toggle */\n.toggle-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /*height: 100vh;\n  background-color: #f0f0f0;*/\n}\n\n/* Hide the checkbox */\n.toggle-input {\n  display: none;\n}\n\n/* Toggle Background */\n.toggle-label {\n  width: 55px;\n  height: 23px;\n  /* background-color: #ccc; */\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n\n  border: 2px solid #3a68d8;\n}\n\n/* Circle inside the Toggle */\n.toggle-circle {\n  width: 20px;\n  height: 20px;\n  background-color: #3a68d8;\n  border-radius: 50%;\n  position: absolute;\n  top: 1px;\n  left: 0px;\n  transition: transform 0.3s ease;\n}\n\n/* When Checkbox is Checked */\n.toggle-input:checked + .toggle-label {\n  /*background-color: #4caf50;*/\n  border: 2px solid #3a68d8;\n}\n\n.toggle-input:checked + .toggle-label .toggle-circle {\n  transform: translateX(30px);\n}\n\n.form-features-xy-wrapper {\n    display: flex;\n    gap: 1.5rem;\n}\n\n.form-features-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n/* .container_main.containerSpace.mainWrap .componentScroll .sub-acc {\n    width: 100% !important;\n    max-width: 100% !important;\n    position: sticky !important;\n    right: 0;\n    z-index: 1;\n    top: 110px !important;\n} */\n\n/* .sub-acc.h-100.padSpace {\n    position: sticky !important;\n    right: 0 !important;\n} */\n.onb-actions.fontSty.edits-fil {\n    display: flex;\n    gap: 10px;\n}\n.onb-actions.fontSty.edits-fil .btn-primary {\n       padding: 5px 10px;\n    border-radius: 5px;\n    border: 0;\n    background: #979797;\n    color: #fff;\n}\n.onb-actions.fontSty.edits-fil .btn-primary img {\n    filter: brightness(0) invert(1);\n    width: 16px;\n}\n.onb-actions.fontSty.edits-fil button, .onb-actions.fontSty.edits-fil a {\n  font-size: 16px;\n  font-weight: 400;\n}\n.form-features-xy-wrapper .sub-acc\n {\n    /* width: calc(100% / 2) !important; */\n    position: relative !important;\n    max-width: 100% !important;\n    flex: 1 1;\n}\n.sub-acc.padSpace.sticky-right {\n    position: inherit;\n    top: 100px;\n}\n.componentScroll .sub-acc.padSpace.sticky-right {\n    position: fixed;\n    width: 27% !important;\n    max-width: 100% !important;\n    right: 20px;\n}\n.f-btns doc .document-image {\n    margin-right: 5px !important;\n}\n.col-md-5.d-flex.justify-content-between.up-down-btn {\n    justify-content: flex-end !important;\n    align-items: center;\n    gap: 20px;\n}\n.form-features-xy-wrapper select {\n    font-size: 14px !important;\n}\n.detail-user .iner-sc {\n        height: 62.8vh !important;\n    }\n    .search.serach-width-div.col-md-6 a, .search.serach-width-div.col-md-6 button {\n    min-width: 120px !important;\n}\n\n@media (max-width: 1745px) {\n .componentScroll .sub-acc.padSpace.sticky-right {\n    width: 26.3% !important;\n  }\n      .detail-user .iner-sc {\n        height: 60.5vh !important;\n    }\n}\n@media (max-width: 1536px) {\n  .componentScroll .sub-acc.padSpace.sticky-right {\n    width: 25.3% !important;\n  }\n      .detail-user .iner-sc {\n        height: 54.7vh !important;\n    }\n}\n@media screen and (max-width: 1440px) {\n  .componentScroll .sub-acc.padSpace.sticky-right {\n    width: 24.5% !important;\n  }\n}\n@media screen and (max-width: 1366px) {\n  .componentScroll .sub-acc.padSpace.sticky-right {\n    width: 23.8% !important;\n  }\n}\n@media (max-width: 1280px) {\n  .componentScroll .sub-acc.padSpace.sticky-right {\n    width: 23.8% !important;\n  }\n      .detail-user .iner-sc {\n        height: 46.5vh !important;\n    }\n}\n\n\n\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .searchere.mb-0.serach-div.resours-div {\n    margin-right: 10px;\n  }\n\n  .temp-top-section {\n    display: inline-block !important;\n    justify-content: space-between;\n  }\n  .toggle-label {\n    width: 50px;\n    height: 25px;\n  }\n  a.av-res {\n    padding: 5px !important;\n  }\n\n  .toggle-circle {\n    width: 22px;\n    height: 22px;\n    transform: translateX(23px); /* Adjusted for the smaller size */\n  }\n\n  .toggle-input:checked + .toggle-label .toggle-circle {\n    transform: translateX(25px);\n  }\n}\n\n.tableFixHead.first-tble-mytem {\n  display: flex;\n  flex-direction: column;\n  /*height: 100vh;*/\n}\n\n.modal-width.dltPops:focus-visible {\n  outline: none;\n}\n\n.para-fonts-match {\n  font-size: 15px;\n  margin-bottom: 20px;\n}\n.right-side-lable-match.mt-2 {\n  display: flex;\n  float: right;\n}\n.right-side-lable-match {\n  display: flex;\n  float: right;\n}\n.right-side-lable-match.mt-2x {\n  display: flex;\n  float: right;\n}\n.butts-div-photo-match {\n  margin-top: 25px;\n  margin-bottom: -10%;\n}\nsection.formSect.txtfComp.mb-4:focus-visible {\n  outline: none;\n}\n.ReactModal__Content.ReactModal__Content--after-open.tem-hide-dives:focus-visible {\n  outline: none;\n}\ninput.on-details-edits:focus-visible {\n  outline: none;\n}\nbutton.download-icon.case-left-down-icon2 {\n  display: flex;\n  /* / justify-content: start; / */\n  /* flex-direction: column; \n     left: -30px;*/\n  position: relative;\n  left: -25px;\n  /* / right: 20px; / */\n  top: 0px;\n}\n\ninput.input-temp-edts:focus-visible {\n  outline: none;\n}\n@media screen and (max-height: 713px) {\n  .new-temp-onbord-main.my-3.py-5.px-4 {\n    padding: 25px !important;\n    min-height: 75vh;\n  }\n}\n\n.createBg {\n  min-height: 80vh;\n  display: flex;\n  align-items: center;\n}\n\n.create-process .tmpRadio input[type=\"radio\"] {\n  margin: 0 7px 0 0 !important;\n  width: 20px !important;\n}\nbutton.btn.btn-primary.btn_wid.btn-check-and-submit {\n  /* width: 100%; */\n  padding: 5px 10px;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 700;\n  min-height: 50px;\n  width: 100%;\n  border: 1px solid #003aca;\n  background: linear-gradient(\n    265deg,\n    #316af7 13.26%,\n    rgba(0, 58, 202, 0.55) 96.34%\n  );\n  box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.25) inset,\n    0px -2px 0px 0px #003aca inset;\n}\n.create-process.tmpRadio label {\n  float: left;\n  margin-right: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #666666;\n  font-family: Manrope;\n\n  font-style: normal;\n\n  line-height: normal;\n}\n.create-process .form-control {\n  border: 1px solid #dfdfdf;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 500;\n  min-height: 45px;\n  padding: 5px 15px;\n}\n\nh3.card-title-cp {\n  color: #302b3a;\n  font-size: 24px;\n  font-weight: 600;\n  margin: 5px 0 15px;\n}\n\n.create-process .subTitle {\n  color: #666666;\n  font-size: 15px;\n  font-weight: 500;\n  margin: 5px 0;\n}\n\n.new-temp-onbord-main.my-3.py-5.px-4 {\n  border: 1px solid #dfdfdf;\n}\n.create-process {\n  border-radius: 20px;\n  border: 1px solid #dfdfdf;\n  background: #fff;\n  max-width: 100%;\n  width: 707px;\n  margin: 0 auto;\n  padding: 2.5rem;\n  min-height: 60vh;\n}\n\n.create-process {\n  min-height: 60vh;\n}\nselect.procc-selet {\n  border: 1px solid #dfdfdf;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 500;\n  min-height: 45px;\n  padding: 5px 15px;\n  width: 100%;\n}\nselect.procc-selet:focus-visible {\n  outline: none;\n}\n\nlabel.pro-title {\n  color: #666666;\n  font-size: 15px;\n  font-weight: 500 !important;\n  margin-right: 20px;\n}\n/*.new-temp-onbord-main {\n  border: 1px solid #DFDFDF;\n  border-radius: 10px;\n  background-color: #FFF;\n  overflow: hidden;\n  padding: 25px !important;\n  min-height: 75vh;\n}*/\n\na.create-comp-popup-text.box-left {\n  padding: 10px;\n  border-left: 5px solid transparent;\n  margin-bottom: 10px;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n}\n\na.create-comp-popup-text.box-left:active {\n  border-left-color: #007bff;\n  background-color: #f0f8ff;\n}\n.everify-column-temp-head {\n  float: left;\n  width: 50%;\n  padding: 13px;\n  display: flex;\n}\n.everify-column-temp-head-one {\n  float: left;\n  width: 23%;\n  padding-left: 30px;\n  display: flex;\n}\nspan.everify-head-temp-head {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.col-md-4.section {\n  padding: 8px;\n  background-color: #f8f9fa;\n  /* border: 1px solid #dee2e6; */\n  margin-bottom: 0px;\n  width: 48%;\n}\n\ntable.temp-head {\n  border-collapse: collapse;\n  width: 100%;\n  position: relative;\n  left: 25px;\n}\n\nimg.archive-icon {\n  width: 10%;\n  margin: 7px;\n}\n\nbutton.btn.btn-link.case-bttnss {\n  width: 15%;\n  font-weight: 600;\n  font-size: 14px;\n  margin-left: -15px;\n}\n\nbutton.primary-bttn.bros-bttn {\n  width: 15%;\n\n  position: relative;\n}\n\np.file-chose-img {\n  position: relative;\n  top: 8px;\n}\ninput.bros-input {\n  display: flex;\n  position: relative;\n  top: -35px;\n  left: 0%;\n  max-width: 195px;\n  font-size: 33px;\n  /* width: 100%; */\n  max-height: 36px;\n  padding: 2px;\n  opacity: 0;\n  right: 0;\n}\n\nbutton.primary-bttn.cont-gry-bttn {\n  width: 15%;\n  background: #ccc !important;\n  color: black;\n}\n\nbutton.btn.btn-outline-primary.primay-linr-bttn:hover {\n  color: white;\n  background-color: #3a68d8;\n}\nbutton.btn.btn-outline-primary.primay-linr-bttn {\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  min-width: 100px;\n  min-height: 35px;\n  border-radius: 7px !important;\n  line-height: inherit !important;\n  width: 15%;\n  color: #3a68d8;\n}\n\nbutton.primary-bttn {\n  color: #fff;\n  border: 0;\n  width: 100%;\n  justify-content: space-between;\n  background: #3a68d8 !important;\n  margin: 0px 12px 0px 0px;\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  min-width: 100px;\n  min-height: 35px;\n  border-radius: 7px !important;\n  line-height: inherit !important;\n  width: 20%;\n  /* float: right;*/\n}\n\n.dot-border {\n  display: flex;\n  border-bottom: dotted;\n  border-bottom-color: #ccc;\n  /* margin-bottom: 8px; */\n}\n.photo-text {\n  font-weight: 600;\n}\n.photo-heading {\n  color: #005288;\n  font-size: 26px;\n  font-weight: 600;\n}\n\n.form-floating.creat-form-inputss {\n  width: 50%;\n}\n.cer-temps {\n  padding: 4px 4px 4px 4px !important;\n}\n\n.hd-can.create-form-wrp.hegNew.formSect.mb-3.edits-divs {\n  height: 14vh;\n  position: relative;\n  top: -30px;\n  padding: 0px;\n  width: 100%;\n  border: none;\n  background: none !important;\n}\n.trash-edit {\n  /*float: right;\n    right: 27%;\n    position: absolute;\n    display: flex;\n  float: right;\n  right: 5%;\n  position: relative;\n  display: flex;\n  height: 20px;\n  margin-top: 0px;\n  width: 25%;*/\n\n  float: right;\n  /* right: 5%; */\n  position: relative;\n  display: flex;\n  /*height: 20px;*/\n  margin-top: 0px;\n  width: 40%;\n  color: #000;\n}\n.trash-edit:active,\n.trash-edit:hover {\n  color: var(--color1) !important;\n}\n.icons-ed {\n  float: right;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n\nth.last-handle-name {\n  /*padding-left: 52px !important;*/\n  padding: 0px 0px 8px 5px !important;\n  width: 10%;\n}\np.subHead.top-texts-create {\n  display: flex;\n  justify-content: space-between;\n  float: left;\n  margin-top: 10px !important;\n  margin-left: 4px;\n  margin-bottom: 0px;\n}\n\n.texts-save-bttn {\n  width: 100%;\n  margin: 0px 0px 0px 10px;\n}\n\ntextarea.inpTxt.textArea.blkCl.pt-0.red-border {\n  height: 5vh;\n  /* padding-top: 20px; */\n  /* border-radius: 50px !important; */\n  height: 50px;\n  padding-right: 22px;\n  padding-left: 10px;\n  padding-top: 15px !important;\n  width: 85%;\n  margin-bottom: 5px;\n}\n\nbutton.Save.top-save-bbtn {\n  display: flex;\n  float: right;\n  position: relative;\n  top: -45px;\n  min-height: 40px;\n}\n\n.form-floating > label.font-enter-color {\n  z-index: 0;\n}\n.form-control.text-class.delay-textarea-height.mt-2 {\n  padding: 15px 0px 15px 15px;\n  width: 100%;\n  height: 180px;\n  overflow: hidden;\n  line-height: 25px;\n}\n\n.form-select.select-height.delay-sele-height {\n  height: 50px !important;\n  /*padding: 15px 0px 15px 15px;*/\n  padding-top: 0px;\n  line-height: normal;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.form-floating.wraper.minH.mb-3.over-ride.delay-sele-height-div {\n  left: 20px;\n  margin: 0 auto;\n  position: relative;\n  width: 93%;\n}\n\n.full-box {\n  display: grid;\n  /*flex-wrap: wrap;\n    flex-direction: row;*/\n}\n.match-border {\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.top-match-align {\n  margin-top: -50px;\n}\n.box-two.mt-4 {\n  display: grid;\n}\n\n.active-boxs {\n  order: -1;\n  flex: 1 0 100%;\n  display: grid;\n}\n\n.close-final-bg {\n  color: #080808;\n  background-color: #f5f5f6;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  padding-left: 10px;\n  padding-right: 10px;\n  margin-left: 10px;\n  /* margin-bottom: 9px; */\n}\n\n.close-final-bg-list {\n  color: #3a68d8;\n  /* background-color: #d6e3ec; */\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  padding-left: 10px;\n  padding-right: 10px;\n  margin-left: 10px;\n  /* margin-bottom: 9px; */\n}\n\n.open-final-bg-list {\n  color: #3a68d8;\n  /* background-color: #d6e3ec; */\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  padding-left: 10px;\n  padding-right: 10px;\n  margin-left: 10px;\n  /* margin-bottom: 9px; */\n}\n.open-final-bg {\n  color: #080808;\n  background-color: #d6e3ec;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  padding-left: 10px;\n  padding-right: 10px;\n  margin-left: 10px;\n  /* margin-bottom: 9px; */\n}\n\n.employment-text-bg {\n  background: #477326;\n  color: white;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.Final-text-bg {\n  background: #c41230;\n  color: white;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.Resubmit-text-bg {\n  background: #080808;\n  color: white;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.case-incom {\n  background-color: #5a5b5d;\n  color: white;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\np.common-padding {\n  padding: 15px 0px 0px 0px;\n}\n.tent-non-bg {\n  background-color: #ffbe2e;\n  color: #080808;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.emp-dhs-bg {\n  background-color: #005288;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  padding-left: 10px;\n  padding-right: 10px;\n  color: white;\n}\n\n.display-gds {\n  display: grid;\n}\n\n.red-color-text {\n  color: red;\n}\nbutton.dfan-btn.close.rounded.p-2.mt-2 {\n  margin: 10px;\n  background: #666;\n  float: none;\n}\n\n.w4form-l.micmatch {\n  margin: 3px 0px 0px 10px;\n  font-size: 15px;\n  display: contents;\n}\n\ninput.form-check-input.radio-sizee.mis {\n  margin: 2px 15px 15px 0px;\n}\n.after-mathw-divs {\n  border: 1px solid #ccc;\n  padding: 20px;\n  border-radius: 10px;\n}\n\nul.if-mathew li {\n  list-style: disc;\n  margin-left: 20px;\n}\n\nbutton.dfan-btn {\n  color: #fff;\n  border: 0;\n  /* width: 100% !important; */\n  justify-content: space-between;\n  background: #3a68d8;\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  /* min-width: 260px; */\n  min-height: 42px;\n  border-radius: 7px !important;\n  line-height: inherit !important;\n  background: #3a68d8;\n  margin: 0 12px 0 0;\n  width: 100%;\n  width: 25%;\n}\n\nbutton.dfan-btn.rounded.Download-Notice.p-2 {\n  color: #fff;\n  border: 0;\n  /* width: 100% !important; */\n  justify-content: space-between;\n  background: #3a68d8;\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  min-width: 260px;\n  min-height: 42px;\n  border-radius: 7px !important;\n  line-height: inherit !important;\n  width: 30%;\n}\n\n.col-6.on-everify {\n  float: right;\n  margin-right: 10px;\n}\n.everify-column {\n  float: left;\n  width: 25%;\n  padding: 5px;\n}\nspan.everify-head {\n  font-size: 15px;\n  font-weight: 600;\n}\n\np.everify-head-para {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.heading-everify {\n  font-size: 15px;\n}\n.heading-para-everify {\n  font-size: 12px;\n}\n\ntable.table.everify-mains {\n  border-collapse: separate;\n}\n.tble-everify {\n  padding: 15px;\n}\n\n.alignTops.e-verify.mb-0.p-3 {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf) !important;\n}\n\nimg.caselogoi9-are-top {\n  width: 10%;\n  float: left;\n}\n\nbutton.submits-btn.rounded.p-2.sub-bttn-right-sides-ev {\n  color: #fff;\n  border: 0;\n  width: 100%;\n  justify-content: space-between;\n  background: #3a68d8;\n  min-width: 140px;\n  min-height: 35px;\n}\n\nbutton.submits-btn.rounded.p-2.sub-bttn-right-sides-ev.Contine-Case {\n  width: 92% !important;\n}\n\n.col-3.on-everify {\n  float: right;\n}\n.mx-auto.main-padds {\n  padding: 0px 5px 5px 5px;\n}\n\n.all-caselogo {\n  /*  width: 100%;\n    display: flex; */\n  /* justify-content: space-between; */\n  /* float: left; \n     max-width: 80px;*/\n\n  /* position: relative; */\n  top: 18px;\n  height: 17px;\n}\nbutton.submits-btn.rounded.p-2.sub-bttn-right-sides-download-ev {\n  color: #fff;\n  border: 0;\n  width: 100%;\n  margin: 0px 15px 0px 0px;\n  justify-content: space-between;\n  background: #666666;\n  min-width: 140px;\n  min-height: 35px;\n}\n\nbutton.submits-btn.rounded.p-2.sub-bttn-right-sides-download {\n  color: #fff;\n  border: 0;\n  width: 100%;\n  justify-content: space-between;\n  background: #666666;\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  min-width: 100px;\n  min-height: 35px;\n  border-radius: 7px !important;\n  line-height: inherit !important;\n  width: 10%;\n  float: right;\n}\n\nbutton.submits-btn.rounded.p-2.sub-bttn-right-sides {\n  color: #fff;\n  border: 0;\n  width: 100%;\n  justify-content: space-between;\n  background: #3a68d8;\n  /* margin: 0px 12px 0px 0px;*/\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  min-width: 100px;\n  min-height: 35px;\n  border-radius: 7px !important;\n  line-height: inherit !important;\n  width: 15%;\n  float: right;\n}\n\n/*button.submits-btn.rounded.p-2.sub-bttn-right-sides.e-vef-bttn-sub {\n    color: #fff;\n    border: 0;\n    width: 100%;\n    justify-content: space-between;\n    background: #3A68D8;\n    margin: 0px 12px 0px 0px;\n    text-align: center;\n    font-size: 14px;\n    letter-spacing: 0.2px;\n    font-family: 'Manrope', sans-serif;\n    min-width: 100px;\n    min-height: 42px;\n    border-radius: 7px !important;\n    line-height: inherit !important;\n    width: 20%;\n    float: right;\n}*/\n.fonts-styless {\n  font-weight: 700;\n  font-family: serif;\n}\n\ninput:focus-visible {\n  /*outline: red;*/\n  border: var(--bs-border-width) solid var(--bs-border-color);\n}\n.form-select.drop-filter.customFilt.select-box {\n  height: 40px;\n  overflow-y: auto;\n  width: 150px;\n}\n.form-select.drop-filter.customFilt.option {\n  overflow-y: scroll;\n}\n\n.input-group-append.pass-div-width {\n  width: 100% !important;\n  height: 60px !important;\n}\n.eye-img {\n  width: 20px;\n}\nspan.count-t-details {\n  background: red;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 40px;\n  color: #fff;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin: 0px 7px 0px 0px;\n  padding: 10px;\n  font-size: 12px;\n}\n\n.mesg-cht {\n  color: #302b3a;\n  font-size: 16px;\n  font-weight: 500;\n  padding: 20px 4px 3px 20px;\n}\nspan.count-t-mesg {\n  background: red;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 40px;\n  color: #fff;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  float: right;\n  font-size: 12px;\n}\n.bold-name {\n  color: var(--avenu-black, #302b3a);\n  font-family: Manrope, sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: capitalize;\n}\n.pop-app {\n  margin-bottom: 0px !important;\n  color: var(--avenu-black, #302b3a);\n  font-family: Manrope, sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-transform: capitalize;\n}\n\n.inbox_people {\n  background: #f8f8f8 none repeat scroll 0 0;\n  float: left;\n  overflow: hidden;\n  width: 40%;\n  border-right: 1px solid #c4c4c4;\n}\n.inbox_msg {\n  border: 1px solid #c4c4c4;\n  clear: both;\n  overflow: hidden;\n}\n.top_spac {\n  margin: 20px 0 0;\n}\n\n.recent_heading {\n  float: left;\n  width: 40%;\n}\n.srch_bar {\n  display: inline-block;\n  text-align: right;\n  width: 60%;\n}\n.headind_srch {\n  padding: 10px 29px 10px 20px;\n  overflow: hidden;\n  border-bottom: 1px solid #c4c4c4;\n}\n\n.recent_heading h4 {\n  color: #05728f;\n  font-size: 21px;\n  margin: auto;\n}\n.srch_bar input {\n  border: 1px solid #cdcdcd;\n  border-width: 0 0 1px 0;\n  width: 80%;\n  padding: 2px 0 4px 6px;\n  background: none;\n}\n.srch_bar .input-group-addon button {\n  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;\n  border: medium none;\n  padding: 0;\n  color: #707070;\n  font-size: 18px;\n}\n.srch_bar .input-group-addon {\n  margin: 0 0 0 -27px;\n}\n\n.chat_ib h5 {\n  font-size: 15px;\n  color: #464646;\n  margin: 0 0 8px 0;\n}\n.chat_ib h5 span {\n  font-size: 13px;\n  float: right;\n}\n.chat_ib p {\n  font-size: 14px;\n  color: #989898;\n  margin: auto;\n}\n.chat_img {\n  float: left;\n  width: 11%;\n}\n.chat_ib {\n  float: left;\n  padding: 0 0 0 15px;\n  width: 88%;\n}\n\n.chat_people {\n  overflow: hidden;\n  clear: both;\n}\n.chat_list {\n  border-bottom: 1px solid #c4c4c4;\n  margin: 0;\n  padding: 18px 16px 10px;\n}\n.inbox_chat {\n  height: 550px;\n  overflow-y: scroll;\n}\n\n.active_chat {\n  background: #ebebeb;\n}\n\n.received_msg {\n  display: inline-block;\n  padding: 0 0 0 10px;\n  vertical-align: top;\n  width: 92%;\n}\n\nbutton.btn.btn-info.btn-lg.mesg-bttn {\n  background: none;\n  border: none;\n}\n\n.borders-part {\n  border: 1px solid #ddd !important;\n  padding: 10px 0px 10px 15px;\n}\n.modal-text-blue {\n  /* padding: 15px 0px 0; */\n  margin: 0;\n  /* font-size: 18px; */\n  /* font-weight: 600; */\n  color: #316af7 !important;\n}\n\n.user_registration_details ul {\n  list-style-type: none;\n  border: 1px solid #ddd;\n  padding: 5px 20px;\n}\n.question-text {\n  background-color: #e9ecef85;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.5rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  padding: 5px 10px;\n  word-break: break-all;\n  width: fit-content;\n}\n\n.user_registration_details ul li {\n  margin-bottom: 2px;\n}\n\n.mesgs {\n  float: left;\n  padding: 10px 15px 0 0px;\n  width: 100%;\n}\n\n.sent_msg p {\n  background-color: #316af7;\n  border-color: #316af7;\n  padding: 5px 10px;\n  display: inline-block;\n  border-radius: 0.5rem;\n  color: #fff;\n}\n\n.outgoing_msg {\n  overflow: hidden;\n  margin: 26px 0 26px;\n}\n.sent_msg {\n  float: right;\n  /* width: 46%; */\n}\n.input_msg_write input {\n  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;\n  border: medium none;\n  color: #4c4c4c;\n  font-size: 15px;\n  min-height: 48px;\n  width: 100%;\n}\n\n.type_msg {\n  border-top: 1px solid #c4c4c4;\n  position: relative;\n}\n.msg_send_btn {\n  /* background: #05728f none repeat scroll 0 0;*/\n  border: medium none;\n  border-radius: 50%;\n  color: #fff;\n  cursor: pointer;\n  font-size: 17px;\n  height: 33px;\n  position: absolute;\n  right: 0;\n  top: 11px;\n  width: 33px;\n}\n.messaging {\n  padding: 0 0 50px 0;\n}\n.scrol-app {\n  width: 100%;\n}\n\n.modal-text-textarea.borders-part {\n  border: 1px solid #626262;\n  margin-left: 25px;\n  /* margin-right: 20px; */\n  width: 90%;\n  margin-top: 15px;\n}\n\n.modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  padding: 20px;\n  border: 1px solid #888;\n  width: 80%;\n  max-width: 400px;\n}\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n}\n.mesg-icon {\n  width: 22px;\n  height: 22px;\n}\n\n.accordion-toggle {\n  display: none;\n}\n\n.accordion-button {\n  background-color: #f4f4f4;\n  border: none;\n  cursor: pointer;\n  padding: 10px;\n  width: 100%;\n  text-align: left;\n}\n\n.accordion-content {\n  background-color: #f9f9f9;\n  padding: 10px;\n  display: none;\n}\n\n.accordion-toggle:checked + .accordion-button + .accordion-content {\n  display: block;\n}\n\ntr:not(:last-child) .accordion-content {\n  border-bottom: 1px solid #ddd; /* Optional: Add border between rows */\n}\nspan.usernamelogout-arrow {\n  color: var(--avenu-black, #302b3a);\n  font-family: Manrope, sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-left: 10px;\n}\n\n.usernamelogout-arrow .dropdown .dropdown-toggle:after {\n  border-bottom: 0;\n  border-left: 0.3em solid transparent !important;\n  border-right: 0.3em solid transparent !important;\n  color: red;\n  margin: 0 0 0 6px;\n}\n.mobile-over-divz {\n  display: none;\n}\n\n.over-divz {\n  display: flex;\n}\n.i9-text {\n  color: #d15d49;\n  font-family: Manrope;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 7px 0px 0px 10px;\n}\nbutton.btn.btn-success.Overrided-bttn {\n  border-radius: 300px !important;\n  background: #d15d49 !important;\n  color: white !important;\n\n  border: none !important;\n\n  height: 35px !important;\n  /* padding: 6px; */\n  margin: 0px 0px 0px 15px !important;\n}\n\n.dropbtn {\n  background-color: #04aa6d;\n  color: white;\n  padding: 16px;\n  font-size: 16px;\n  border: none;\n}\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-contentside.form-menus a {\n  color: white;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n  font-family: Manrope !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin: 0px 0px 0px 15px;\n}\n.dropdown-contentside.form-menus {\n  display: block;\n  background: none !important;\n  position: relative;\n  width: 100%;\n  /* height: 300px;\n     color: white; */\n  border: none;\n  margin-top: 15px;\n}\n\n.tempops-border {\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: #fff;\n  height: 83vh;\n}\nh6.create-comp-popup-text-heading.pops-text-width {\n  /*width: 100%;\n   display: flex;\n   */\n\n  float: right;\n}\n.create-comp-popup-text-heading-not-found.temple-edits-cen {\n  text-align: center;\n}\n.wraper.scrlHe-tab.scroll.scroll1.temppos-height {\n  height: 63vh;\n}\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #f1f1f1;\n  min-width: 135px;\n  /* box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2); */\n  z-index: 1;\n  font-size: 12px;\n  border: 1px solid #cccc;\n  border-radius: 15px;\n  height: 40px;\n}\n\n.dropdown-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.dropdown:hover .dropdown-content {\n  display: block;\n}\n\n.alignHead_review.right-side-align {\n  justify-content: flex-end;\n}\n\n.popup {\n  margin: 75px auto;\n  padding: 20px;\n  background: #fff;\n  border: 1px solid #666;\n  width: 300px;\n  box-shadow: 0 0 50px rgba(0, 0, 0, 0.5);\n  position: relative;\n  .light & {\n    border-color: #aaa;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);\n  }\n  h2 {\n    margin-top: 0;\n    color: #666;\n    font-family: \"Trebuchet MS\", Tahoma, Arial, sans-serif;\n  }\n  .close {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    top: 20px;\n    right: 20px;\n    opacity: 0.8;\n    transition: all 200ms;\n    font-size: 24px;\n    font-weight: bold;\n    text-decoration: none;\n    color: #666;\n    &:hover {\n      opacity: 1;\n    }\n  }\n  .content {\n    max-height: 400px;\n    overflow: auto;\n  }\n  p {\n    margin: 0 0 1em;\n    &:last-child {\n      margin: 0;\n    }\n  }\n}\nbutton.btn.btn-success.comp-bttn {\n  color: white !important;\n  background: #2ebf2e !important;\n  border: none !important;\n  border-radius: 20px !important;\n  height: 35px !important;\n  /* padding: 6px; */\n  margin: 0px 0px 0px 15px !important;\n}\n\nbutton.dropbtn {\n  width: 100%;\n  background: none;\n  border: none;\n}\n\n.three-dots-img {\n  width: 25px;\n}\n.name-alin {\n  display: contents;\n}\n.edit_icon.ml-2 {\n  background: none !important;\n  border: none;\n  width: 30px;\n}\n/* .new-spans{\n    background-color: red;\n    /* width: 10%; \n    border-radius: 20px;\n    display: flex;\n    /* text-align: center; \n    padding: 10px;\n    height: 18px;\n }*/\n\n.list-group-item:first-child {\n  border-top-left-radius: 10px !important;\n  border-top-right-radius: 10px !important;\n}\n\n.list-group-item:last-child {\n  border-bottom-left-radius: 10px !important;\n  border-bottom-right-radius: 10px !important;\n}\n.profie-width {\n  width: 85%;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  margin: 0px 0px 0px 0px;\n}\n.new-letter {\n  background-color: red;\n  border-radius: 30px;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n  margin-right: 5px;\n  padding: 1px 7px;\n  margin-bottom: 0px;\n}\n.tableFixHead {\n  overflow-y: scroll;\n  /*height: 280px; */\n}\n.tableFixHead thead th {\n  position: sticky;\n  border-bottom: 1px solid #f0f0f0;\n  top: 0px;\n}\n\n.sub-fonts-stylez {\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\nbutton.aligmt-icon {\n  border: none;\n  background: none;\n}\n\n/*.btn-group .aligmt-icon-divx:hover ,.btn-group .aligmt-icon-divx:active{    \n    border: 1px solid red;\n}\n.img-div-actives :active{ border: 1px solid red;}*/\n\n.img-alignWraper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.btn-group.aligmt-icon-divx {\n  width: auto;\n}\n\n.icon-trash {\n  cursor: pointer;\n}\n\n.btn-group.aligmt-icon-divx .aligmt-icon.active {\n  border: 1px solid #ccc;\n  width: 40px;\n  border-radius: 5px;\n  padding: 5px 5px;\n  height: 35px;\n  line-height: 20px;\n}\n.btn-group.aligmt-icon-divx .aligmt-icon {\n  margin: 0;\n  width: 40px;\n  border-radius: 5px;\n  padding: 5px 5px;\n  height: 35px;\n  line-height: 20px;\n  border: 1px solid transparent;\n}\n\n.btn-group.aligmt-icon-divx .aligmt-icon img {\n  margin: 0;\n  width: 21px;\n  height: auto;\n}\n\n.image-sizes-small {\n  max-width: 30%;\n  max-height: 200px;\n  /* height: auto;\n  width: auto; */\n}\n.image-sizes-medm {\n  max-width: 50%;\n  /* height: auto; */\n  /* width: auto; */\n  max-height: 400px;\n}\n.image-sizes-large {\n  max-width: 100%;\n  /* height: auto;\n  width: auto; */\n  max-height: 600px;\n}\n\n.imgs-right-algment {\n  float: right;\n}\n.imgs-center-algment {\n  float: center;\n}\n.imgs-left-algment {\n  float: left;\n}\n\n.divs-left-algment {\n  text-align: left;\n}\n.divs-center-algment {\n  text-align: center;\n}\n\n.divs-right-algment {\n  text-align: right;\n}\n\n/*.rightCont.top-id-fixes {\n    margin-top: 95px;\n}*/\n.image-size {\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf) !important;\n  background: var(--White, #fff);\n  /* display: flex; */\n  padding: 5px 10px;\n  margin-left: 10px;\n  /* font-size: 15px; */\n  /* font-weight: 400; */\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.image-name {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  display: contents;\n}\n\n.aligmt-icon {\n  width: 100%;\n  margin-bottom: 10px;\n}\n.review-pre-cand-link:hover {\n  color: blue;\n  cursor: pointer;\n}\n.rdw-colorpicker-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 175px;\n  height: 175px;\n  border: 1px solid #f1f1f1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 10000000000 !important;\n  background: white;\n  box-shadow: 3px 3px 5px #bfbdbd;\n}\n\n.rdw-link-modal {\n  background: #fff;\n  border: 1px solid #f1f1f1;\n  border-radius: 2px;\n  box-shadow: 3px 3px 5px #bfbdbd;\n  display: flex;\n  flex-direction: column;\n  height: 205px;\n  left: 5px;\n  padding: 15px;\n  position: absolute;\n  top: 35px;\n  width: 235px;\n  z-index: 100000000000000 !important;\n}\n\n.deletBtns .Actsbtn,\n.deletBtns:hover .bfsBtn {\n  display: none;\n}\n\n.deletBtns:hover .Actsbtn {\n  display: inline-block;\n}\n\n.leftDivs {\n  width: 75%;\n}\n.pass-inpt {\n  border: 1px solid #dfdfdf;\n  /* background: unset; */\n  border-right: none;\n}\n.input-group-append.pass-div-width {\n  width: 60%;\n}\nimg.top-drp {\n  width: 100%;\n  /* height: 15px; */\n  min-width: 15px;\n}\n.align-div-edits {\n  position: absolute;\n  left: 10%;\n  right: 0%;\n  /* transform: translate(-50%, -50%); */\n  /* width: 100%; */\n  top: 55%;\n}\n\n.border-divs-edits {\n  border: 2px dashed #3a68d8;\n  height: 100vh;\n}\n\n.two-bttnn-pdf .e-scroll-left-nav,\n.two-bttnn-pdf .e-scroll-right-nav {\n  display: none;\n}\n.two-bttnn-pdf .e-control,\n.two-bttnn-pdf .e-toolbar-items,\n.two-bttnn-pdf .e-lib .two-bttnn-pdf .e-hscroll {\n  display: inline-block !important;\n}\n\n.e-toolbar\n  .e-toolbar-items\n  .e-hscroll-bar\n  .e-hscroll-content\n  .e-toolbar-right\n  .e-toolbar-item {\n  margin: 0;\n  display: grid !important;\n}\n.two-bttnn-pdf {\n  margin-top: 40px;\n  display: flex;\n  flex-direction: inherit;\n}\n\n.background-img {\n  background: url(/src/assets/images/MagicPattern.png);\n  width: 100%;\n  height: 100vh;\n}\n.sign-padd-preview {\n  margin-top: 45px;\n}\n\n.iner-sc.candScroll.scrlHe-tab.top-space-tag.scroll1.top-spaceing {\n  margin: 0px 0px 0px 0px !important;\n}\n\n.action-itms .padd-review-inner {\n  padding: 15px 0px;\n}\n\n.action-itms .padd-review-page {\n  padding: 0px 0px 0px 0px !important;\n}\n\n.task-count.rev-marg-lft {\n  margin: 0px 20px 0px 0px !important;\n}\n\n.buildsubHead {\n  color: var(--gray-accessible-text, #666);\n  font-family: Manrope;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.buildHead {\n  color: var(--Avenu-Black, #302b3a);\n\n  font-family: Manrope;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.filter-main-div {\n  display: flex;\n}\n\n#page-no-border {\n  border: 1px solid #ccc;\n}\n\nul.MuiList-root.MuiList-padding {\n  /* height: 100vh;*/\n  padding-bottom: 0;\n}\n\n.trag-list-build {\n  min-height: 900px;\n  width: 100%;\n  /* overflow: auto; */\n}\n\ndiv#container_sideBarToolbarSplitter {\n  height: 100% !important;\n}\n.line-under {\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  margin-bottom: 20px;\n}\n.check-tetxz {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.review-texts {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-bottom: 20px;\n}\n\n/*.container_main.containerSpace.mainWrap {\n    background: #FBFBFB;\n}*/\n\n.padd-ajust {\n  padding: 0px !important;\n}\n.build-choose {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  display: contents;\n}\n\n.e-pv-viewer-main-container {\n  background-color: white !important;\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  /* border: none; */\n}\n.modal-text1.text-marg {\n  margin: 0;\n}\n\n.ReactModal__Content.ReactModal__Content--after-open .modal-width hr {\n  margin-bottom: 0;\n  margin-top: 0.7rem;\n}\n\n.trash-icon-popups {\n  float: right;\n  width: 100%;\n  min-width: 20px;\n}\n\n.form-select .drop-filter {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.ReactModal__Overlay.ReactModal__Overlay--after-open .scrlHe-tab {\n  margin-top: 0;\n}\n\n.main-filter {\n  /*display: flex;\n    margin: 0px 15px 0px 0px;\n    align-items: center;*/\n\n  display: flex;\n  margin: 0px 23px 0px 0px;\n  align-items: center;\n  display: flex;\n  width: 100%;\n  padding: 10px;\n  align-items: center;\n  /* gap: 10px; */\n  /* align-self: stretch; */\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: #fff;\n}\nselect.form-select.drop-filter {\n  /* width: 150px;*/\n  height: 35px;\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-overflow: ellipsis;\n}\n\n.filter-name {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0;\n}\nli.list-group-item.same-line {\n  display: flex;\n  /*justify-content: space-between;*/\n  border: none;\n}\nli.list-group-item.same-line.rigt-alginn {\n  justify-content: space-between;\n}\n.filterAlign {\n  width: 100%;\n}\n.searchere.mb-0.serach-div {\n  /* width: 387px;*/\n\n  align-items: center;\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: #fff;\n  height: 55px;\n  justify-content: flex-end;\n  display: flex;\n}\n.underline {\n  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf);\n  width: 100%;\n  display: flex;\n  padding: 15px 20px;\n}\n\nspan.e-tbar-btn-text {\n  color: #666 !important;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.doct-name-save-bttn {\n  width: 100%;\n  display: flex;\n}\n.hd-can.create-form-wrp.box-height {\n  min-height: 40px !important;\n}\ninput#currentPage {\n  border-radius: 5px;\n  border: 1px solid #dfdfdf;\n  display: flex;\n  width: 39px;\n  height: 39px;\n  padding: 8px 10px;\n  justify-content: center;\n}\n\nbutton#form_designer {\n  background-image: url(/src/assets/images/form-43.svg) !important;\n  background-repeat: no-repeat !important;\n  border-left: 1px solid #ccc;\n  padding: 0px 0px 0px 30px;\n  height: 30px;\n}\n\nbutton#next_page {\n  border-right: 1px solid #ccc;\n}\nbutton#file_Open {\n  border-right: 1px solid #ccc;\n}\nbutton#chooseTemplates {\n  border-right: 1px solid #ccc;\n}\n.e-control.e-toolbar.e-lib.e-keyboard {\n  margin-top: 12px;\n}\n.e-pdf-toolbar.custIcons.bottom-space {\n  margin-bottom: 12px;\n}\n\n.e-toolbar .e-toolbar-item .e-tbar-btn {\n  background: none !important;\n  box-shadow: none;\n  color: rgba(0, 0, 0, 0.87);\n  border: none;\n}\n.e-toolbar {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  background: none !important;\n  border: 1px none rgba(0, 0, 0, 0.12);\n  box-shadow: none;\n}\n.doct-divz {\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  padding: 0px;\n  background: none;\n}\n\n.doct-upload-div .control-section.doct-divz {\n  border-radius: 10px 10px 0 0;\n}\n\n.doct-upload-div {\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n  /* display: flex; */\n  padding: 20px;\n  /* flex-direction: column; */\n  align-items: center;\n}\n\nspan.tooltiptext.lock-tip {\n  right: 40px;\n  bottom: -70px !important;\n  top: -20px;\n  height: 65px;\n  min-width: 260px;\n}\n\nbutton.resetform-btn {\n  color: #3a68d8;\n  border: 0;\n  width: auto;\n  min-width: 100px;\n  justify-content: space-between;\n  /* background: #3A68D8; */\n  text-align: center;\n  font-size: 15px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  margin-left: 10px;\n  background: none !important;\n  text-decoration-line: underline;\n  font-weight: 600;\n}\n\n/* .ReactModal__Content.ReactModal__Content--after-open {\n    width: 35% !important;\n} */\n.notes-title {\n  font-size: 15px;\n  font-weight: 500;\n}\n\nimg.dragBtn-fist.mrR {\n  width: 6px !important;\n  margin: 0 !important;\n}\n\nspan.tooltiptext.edit-tip {\n  min-width: 100px;\n}\n\n.filetext-img {\n  width: 18px;\n  margin-left: 10px;\n  margin-left: 10px;\n  width: 100%;\n  max-width: 13px;\n}\n\n.rdw-link-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  min-height: 230px !important;\n  border: 1px solid #f1f1f1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 10000000000000;\n  background: white;\n  box-shadow: 3px 3px 5px #bfbdbd;\n}\n.modal-check-bttn {\n  margin: -20px 0px 0px -5px;\n  padding: 20px;\n}\n.check-space {\n  margin: 5px;\n}\n.onboard-text-popup {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-bottom: 10px;\n}\n\n.tempList.create-comp-temp {\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n  display: flex;\n  padding: 15px 20px;\n  /* flex-direction: column;\n    align-items: center;*/\n}\n.adds-sub-text {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\nbutton.thank-close-button {\n  /* max-width: 61%; */\n  min-width: 85px;\n  width: auto;\n  min-height: 40px;\n  border: 1px solid var(--Active-State, #3a68d8);\n  color: var(--White, #fff);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin: 0;\n  /* padding: 11.761px 25.234px; */\n  border-radius: 10px;\n  background: var(--Active-State, #3a68d8);\n  outline: 0;\n  box-shadow: inherit;\n}\n.card-1 {\n  text-align: center;\n  padding: 70px;\n}\n.thanku-sub-heading {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-align: justify;\n  margin: 10px;\n}\n.thanku-text {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  text-align: left;\n  margin-bottom: 10px;\n}\n\n.thanku-cards {\n  min-height: 260px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  flex-shrink: 0;\n  border-radius: 10px;\n  border: 0.776px solid var(--light-gray-outline, #dfdfdf);\n  /*background: var(--White, #FFF);*/\n  width: 40%;\n  margin: 12rem auto;\n  text-align: center;\n}\n\n.form-floating.doc_form input {\n  padding: 0.5rem 0.75rem !important;\n}\n\n/*.img-divs{\n    width: 70%;\n    margin: auto;\n}*/\n\n.modal-footer.footer-marg-pdf {\n  margin: -25px 10px 0px 0px;\n  padding: 10px;\n}\n\n.modal-footer.footer-marg {\n  margin: 0;\n  padding: 1rem 20px 20px;\n}\n\n.pad-20 {\n  padding: 20px;\n}\n\n.all-candidate-list {\n  text-align: center;\n}\n\n.or-text {\n  color: var(--gray-accessible-text, #666) !important;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0px 0px 0px 0px;\n}\n\n.choose-text {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  border-radius: 10px;\n  border: 1px solid var(--graphic-objects-components-wcagaa, #949494);\n  background: var(--White, #fff);\n}\n\na.createa.form {\n  cursor: pointer;\n  color: #666;\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  border-bottom: 1px solid #dfdfdf !important;\n  text-decoration: none !important;\n  /*border-bottom: 1px solid #DFDFDF !important;*/\n}\n.modal-dialog.modal-dialog-centered.boz-width {\n  max-width: 50%;\n}\n\n.font-enter-color {\n  color: #a4a4a4;\n  font-family: \"Manrope\", sans-serif !important;\n}\n\n/*button.btn.btn-primary.mx-2 {\n    background: var(--Active-State, #3A68D8);\n    padding: 5.761px 25.234px;\n    justify-content: space-between;\n    align-items: center;\n    flex: 1 0 0;\n    border-radius: 10.093px;\n    width: 50%;\n    height: 40px;\n}\n*/\n\n.text-ends {\n  text-align: left;\n  padding-left: 20px !important;\n  /*display: flex;*/\n}\n\n.col-lg-6.text-ends {\n  margin-top: -29px;\n}\n\n.form-control .inputs-text-size {\n  font-size: 15px;\n  margin: -20px 0px 0px 0px;\n  color: #a4a4a4;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\nlabel.form-label.name-size {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 9px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 12px;\n}\n.addCand select.form-select {\n  min-height: 53px;\n  border-radius: 8px;\n  border: 0.899px solid var(--light-gray-outline, #dfdfdf);\n  font-size: 15px;\n  font-weight: 500;\n  font-family: \"Manrope\", sans-serif;\n}\n.form-group-default {\n  display: flex;\n  width: 100%;\n  padding: 6.989px 13.967px;\n  align-items: flex-start;\n  align-content: flex-start;\n  gap: 7.473px;\n  align-self: stretch;\n  flex-wrap: wrap;\n  border-radius: 8px;\n  border: 0.899px solid var(--light-gray-outline, #dfdfdf);\n  background: #fff;\n}\n.archi-labels {\n  margin-left: 20px;\n}\n.archi-text {\n  color: var(--gray-accessible-text, #666);\n  font-family: Manrope;\n  margin-left: 20px;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\nbutton.update-btn-archive {\n  color: #fff;\n  border: 0;\n  width: auto;\n  justify-content: space-between;\n  border-radius: 10.093px;\n  background: #3a68d8;\n  margin: -8px 25px 0px 70px;\n  text-align: center;\n  min-width: 80px;\n  font-size: 15px;\n}\n\n.Cancel-pop {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-decoration-line: underline;\n  border: none;\n  background: none;\n}\n\n.form-group-default.focused {\n  background-color: #f0f0f0;\n}\n\n.form-group-default.required:after {\n  color: #f55753;\n  content: \"*\";\n  font-family: \"Manrope\", sans-serif;\n  font-size: 20px;\n  position: absolute;\n  right: 12px;\n  top: 6px;\n}\n\n.form-group-default .form-control {\n  border: 0;\n  padding: 0;\n  margin-top: -24px;\n  background: 0 0;\n  border-radius: 0;\n  resize: vertical;\n  font-size: 15px;\n  font-weight: 500;\n  font-family: \"Manrope\", sans-serif;\n}\n\n.form-group-default .form-control:not(textarea) {\n  height: 25px;\n  min-height: 25px;\n}\n\n.form-group-default .form-control:focus {\n  outline: 0 !important;\n  box-shadow: none;\n}\n\n.form-group-default .control-label {\n  margin: 0;\n  display: block;\n  line-height: 20px;\n  margin-bottom: 2px;\n  opacity: 1;\n  -webkit-transition: opacity 0.2s ease;\n  transition: opacity 0.2s ease;\n}\n\n.form-group .control-label {\n  font-size: 10.5px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.form-group-default .custom-select.is-invalid,\n.form-group-default .form-control.is-invalid,\n.was-validated .form-group-default .custom-select:invalid,\n.was-validated .form-group-default .form-control:invalid {\n  box-shadow: none;\n  border-bottom: 1px solid #dc3545;\n}\n\n.form-group-default .custom-select.is-valid,\n.form-group-default .form-control.is-valid,\n.was-validated .form-group-default .custom-select:valid,\n.was-validated .form-group-default .form-control:valid {\n  box-shadow: none;\n}\n\n/* imp */\n\nlabel.form-label.job-text {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.under-line-add {\n  width: 100%;\n  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n  margin: 50px 0px 0px -20px;\n  display: flex;\n  position: absolute;\n}\n\n.preview-bck-icon {\n  width: 25px;\n  top: 0;\n  left: 0;\n  position: absolute;\n  margin: 20px 0px 0px 35px;\n  z-index: 9999;\n  cursor: pointer;\n}\n\n.text-choose-margn {\n  margin: 0px 0px 0px 10px;\n}\n\n.per-align {\n  margin-left: 45px;\n  text-align: center;\n  font-weight: 600;\n  font-size: 15px;\n}\ntextarea#floatingTextarea {\n  height: 20px !important;\n  width: 60%;\n}\n\n.sub-head-color {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.pdf-scrolls {\n  max-height: 80vh;\n  overflow-y: scroll;\n}\n\n.Spinnerbackground {\n  background-color: #fff;\n}\n\n.userarea.new.review-div {\n  position: absolute;\n  right: 25px;\n  top: 17px;\n  z-index: 0;\n}\n.dele-icon {\n  width: 17px;\n}\n\n.scroll {\n  width: 20px;\n  height: 200px;\n  overflow: auto;\n  float: left;\n  margin: 0 10px;\n}\n\n.scroll1::-webkit-scrollbar {\n  width: 5px;\n}\n\n.scroll1::-webkit-scrollbar-track {\n  background: #ddd;\n}\n\n.scroll1::-webkit-scrollbar-thumb {\n  background: #666;\n}\n\n.move-div {\n  padding-top: 10px;\n  max-height: 225px !important;\n  width: 100%;\n  overflow-y: scroll !important;\n  margin-top: 20px;\n}\n\n.icon-dele {\n  margin-top: -35px;\n  float: right;\n  width: 2%;\n}\n.main-verif {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.main-verif .algOtps {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.main-verif img.verifi-code-imgs {\n  width: 19px;\n  margin: 0 7px;\n}\n.verifi-code-no p {\n  margin: 0;\n}\n/*.chk-text{margin: 52px 0px 0px 0px !important;}*/\n\n.modal-delect-text.txtFonts {\n  /* font-size: 18px;*/\n  letter-spacing: 0.2px;\n  font-size: 15px;\n}\n\n.modal-delect-text {\n  padding: 15px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  text-align: center;\n  justify-content: center;\n}\n\n.add-btn {\n  cursor: pointer;\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.footer_collapse.mt-2 p {\n  transform: translate(6%, 0);\n  font-size: 13px;\n}\n.Powered-by-text {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0px 10px -5px 0px;\n}\n\n.verifi-code-text {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  float: left;\n  margin: 0px;\n}\n.outerWidth .spaceWidth {\n  display: flex;\n  align-items: center;\n  width: 500px;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0 10px 15px;\n}\n.verifi-code-no {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.rating {\n  margin: 0px 0px 0px 0px;\n}\n\n.resend-text {\n  color: var(--Active-State, #3a68d8);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  float: right;\n  margin: 0;\n}\n\n.otp-field {\n  flex-direction: row;\n  column-gap: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.otp-enter {\n  width: 100%;\n  justify-content: center;\n}\n\n.otp-field input {\n  height: 62px;\n  width: 12%;\n  border-radius: 6px;\n  outline: none;\n  font-size: 1.125rem;\n  text-align: center;\n  border: 1px solid #ddd;\n}\n.otp-field input:focus {\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);\n}\n.otp-field input::-webkit-inner-spin-button,\n.otp-field input::-webkit-outer-spin-button {\n  display: none;\n}\n\n.input-size {\n  width: 50px;\n  height: 50px;\n}\n\n.line-border {\n  width: 100%;\n  border-top: 2px solid #f6f6f6;\n  margin: 35px 0 0;\n}\n.text-padd {\n  padding: 30px;\n}\n.action-itms.full-drp.inner-scrll {\n  /*overflow: scroll;\n    height: auto;\n    display: flex;\n    margin-bottom: 25px !important;\n    position: relative;\n    padding: 25px 0px 0px 0px !important;*/\n  max-height: 345px;\n  display: block;\n  margin-bottom: 25px !important;\n  position: relative;\n}\n.cards.has-text-centered {\n  position: relative;\n  margin: -30px auto;\n  width: 800px;\n  max-width: 100%;\n  min-height: 520px;\n  border-radius: 10px;\n  border: 0.776px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n  transform: translate(0%, 30%);\n}\n\n/* .cards-otp.has-text-centered {\n    position: absolute;\n    margin: 23vh auto;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 35%;\n    height: 445px !important;\n    border-radius: 10px;\n    border: 0.776px solid var(--light-gray-outline, #DFDFDF);\n    background: var(--White, #FFF);\n    top: 0%;\n    \n} */\n\n/*.otp-page {\n \n    padding: 10% 0 0;\n  \n    margin: auto;\n    display: flex;\n    justify-content: center;\n}*/\n\n.otp-body {\n  position: relative;\n  z-index: 1;\n  background: #ffffff;\n  max-width: 100%;\n  margin: 0 auto 100px;\n  padding: 0px;\n  text-align: center;\n  border-radius: 10px;\n  border: 0.776px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n}\n\n.otp-enter input[type=\"tel\"] {\n  width: 65px !important;\n  height: 70px !important;\n  flex-shrink: 0;\n  border-radius: 15px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n  margin: 0 10px !important;\n  font-style: italic;\n  max-width: 100%;\n}\n\n.register-form {\n  margin-bottom: 0px;\n  padding: 40px;\n}\n.need-text {\n  display: flex;\n  width: 100%;\n  min-height: 72px;\n  flex-direction: column;\n  /* justify-content: center; */\n  align-items: center;\n  padding: 25px 0;\n}\n\nbutton.otp-button {\n  max-width: 100%;\n  width: 500px;\n  min-height: 40px;\n  border: 1px solid var(--Active-State, #3a68d8);\n  color: var(--White, #fff);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin: 0;\n  padding: 10px 25px;\n  border-radius: 10px;\n  background: var(--Active-State, #3a68d8);\n  outline: 0;\n  box-shadow: inherit;\n}\n\n.need-text .message {\n  color: var(--Active-State, #3a68d8);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0;\n}\n\n.otp-text {\n  color: var(--gray-accessible-text, #666);\n  text-align: center;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.otp-no {\n  color: var(--Active-State, #3a68d8);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.wel-text-one {\n  align-self: stretch;\n  color: var(--gray-accessible-text, #666);\n  text-align: center;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.welcome-text {\n  color: var(--Avenu-Black, #302b3a);\n  margin: 20px 0;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 34px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  text-align: center;\n}\n.cardPost {\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n}\n\n.userarea .dropdown .dropdown-toggle:after {\n  /*border-bottom: 0;\n    border-left: 0.3em solid transparent !important;\n    border-right: 0.3em solid transparent !important;\n    border-top: 0.3em solid #949494 !important; */\n  border-bottom: 0;\n  border-left: 0.3em solid transparent !important;\n  border-right: 0.3em solid transparent !important;\n  /* border-top: 0.3em solid #949494 !important; */\n  color: #fff;\n  margin: 0px 0px 0px 6px;\n}\n.userarea .dropdown span.username img {\n  display: none;\n}\n\n.count-number {\n  /* font-size: 15px;\n    font-weight: 600;\n    text-align: center;*/\n  /* align-items: center; */\n  /* justify-content: center; */\n  /*color: #fff;\n    margin: 0px 0px 0px -2px;*/\n  /*font-size: 15px; */\n  /* font-weight: 600; */\n  /* text-align: center; */\n  /* align-items: center; */\n  /* justify-content: center; */\n  /* color: #fff; */\n  margin: 0px 0px 0px -2px;\n  /* background: #3A68D8; */\n  line-height: 31px;\n  /* min-width: 30px; */\n  /* height: 30px; */\n  /* border-radius: 60px; */\n  display: inline-block;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  text-align: center;\n  padding: 0 7px;\n  margin-left: 8px;\n}\n\n.toast-message {\n  background-color: #fff;\n  color: #000;\n  font-size: 20px;\n  padding: 1rem 0.5rem;\n  transform: translate(-50%, -50%);\n  top: 120px !important;\n  left: 50%;\n  z-index: 4;\n}\n\n.right-align {\n  display: flex;\n  align-items: center;\n}\n\n.doc-name {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.doc-img-review {\n  width: 100%;\n}\n\n.dropbtn {\n  padding: 10px;\n  font-size: 15px;\n\n  width: 205px;\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n}\n.dropdown {\n  position: relative;\n  display: inline-block;\n}\n.dropText {\n  display: none;\n  cursor: pointer;\n  position: absolute;\n  /* \n    \n      background-color: skyblue; */\n  z-index: 101;\n  min-width: 120px;\n\n  width: 100%;\n  border: 1px solid #dfdfdf;\n  margin-top: -7px;\n  border-radius: 0px 0px 10px 10px;\n  background: var(--White, #fff);\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  padding: 0 15px;\n}\n.detail-user .dropdown .dropText a {\n  border-bottom: 2px solid #f8f8f8;\n  box-shadow: inherit;\n  background: transparent;\n  border-radius: 0;\n}\n.disableditem-my {\n  background: transparent;\n  color: #ddd !important;\n  border-radius: 0;\n  box-shadow: inherit;\n}\n\n.dropText a {\n  padding: 10px 5px;\n  text-decoration: none;\n  display: block;\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n/* .dropText a:hover {\n    background-color:#f8f8f8;\n    color: #3A68D8 ;\n    border-bottom:1px solid #E8E8E8 ;\n    align-self: stretch;\n    border-radius: 30px;\n    background: #F8F8F8;\n } */\n.dropdown:hover .dropText {\n  display: block;\n}\n.dropdown:hover .dropbtn {\n  background-color: #f8f8f8;\n}\n\n {\n  /*button#zoom_in {\n    border-right: 1px solid #ccc;\n}*/\n}\n\n.textArea-form-build {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 2px 0px 0px 10px;\n}\n\n/* .topnav-tab a.active {\n    background-color: #3A68D8;\n    background-color: #3A68D8;\n    color: white;\n    height: 50px;\n    padding: 10px;\n} */\n\n.create-comp-popup-text:hover,\n.create-comp-popup-text.active {\n  /*background: #3a68d8; */\n  color: #060606 !important;\n  border-left: 4px solid blue;\n}\n/*.create-comp-popup-text:hover .icon-trash,\n.create-comp-popup-text.active .icon-trash {\n  filter: brightness(0) invert(1);\n}\n*/\n\ntr.temp-table-border:hover::after,\ntr.temp-table-border:hover::after {\n  color: var(--color1) !important;\n}\n\n.create-comp-popup-text.active .create-comp-popup-text-heading {\n  color: #000 !important;\n}\n\n.create-comp-popup-text.create-comp-popup-text-heading,\n.create-comp-popup-text-heading:hover {\n  color: var(--color1) !important;\n}\ntr.temp-table-border:hover {\n  color: var(--color1) !important;\n}\n.detail-tabs {\n  margin: -30px 0px 0px 0px !important;\n}\n\n.modal-body .detail-tabs {\n  margin: 0 !important;\n}\n\n.create-comp-modal-body {\n  height: inherit !important;\n  margin: 0;\n}\n.create-comp-under-line {\n  width: 100%;\n  border: 1px solid #dcdcdc;\n  margin: -10px 0px 0px 0px;\n}\n\n.create-comp-scroll {\n  margin: 15px 0px !important;\n  padding: 0;\n  /* background-color: green; */\n  width: 100%;\n  height: 30vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  text-align: left;\n}\n\n.create-comp-popup-text-heading {\n  /* color: var(--Avenu-Black, #302B3A) !important; */\n  font-family: Manrope, sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0;\n  width: 100%;\n}\n.create-comp-popup-text {\n  display: flex;\n  width: 100%;\n  padding: 15px 15px;\n  align-items: center;\n  /* gap: 97px; */\n  border-bottom: 1px solid #e8e8e8;\n  margin: 0;\n}\n\n.create-comp-popup-text-heading-not-found {\n  /* color: var(--Avenu-Black, #302B3A) !important; */\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0;\n  text-align: center;\n}\n.create-comp-popup-text-not-found {\n  /* display: flex;*/\n  width: 100%;\n  padding: 15px 15px;\n  align-items: center;\n  /* gap: 97px; \n    border-bottom: 1px solid #E8E8E8;*/\n  margin: 0;\n}\n.send-job-check {\n  padding: 10px;\n}\n\n.backgroud-check-image {\n  padding: 7px;\n  padding: 7px;\n  width: 20% !important;\n  margin: -2px 0px 0px 0px;\n}\n\n.backgroud-check {\n  display: flex;\n  /* width: 182.75px; */\n  padding: 3.761px 4.234px;\n  justify-content: space-between;\n  align-items: center;\n  float: right;\n  border-radius: 10.093px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n  margin: -75px 0px 0px 0px !important;\n}\n\n.pop-tab-text {\n  font-size: 14px !important;\n  font-weight: 600;\n}\n.expire-text {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 25px 0px 0px 7px;\n}\n\n.tage-text {\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.doct-name {\n  width: 46px;\n}\n.resetchk-text {\n  padding: 10px;\n}\n.resetpopup {\n  float: left;\n  position: relative;\n  margin: 0px 272px 0px 0px;\n}\n.doct-choose {\n  width: 45%;\n  height: 25px;\n  border: none;\n  font-size: 12px;\n  margin: 0px 0px 0px 0px;\n}\n.Documents-upload {\n  width: 70%;\n  /* border: 1px solid;  height: 50px; */\n  padding: 10px 0px;\n}\n\n.document-image {\n  cursor: pointer;\n  /* display: -webkit-box; */\n  margin: 0 auto;\n  /* float: right; */\n  /* margin-top: -30px; \n    margin-right: -175px;*/\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n}\n.select.drop-select.form-select {\n  display: flex;\n  width: 213px;\n  padding: 15px 25px;\n  align-items: center;\n  gap: 20px;\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n}\n.tag-design {\n  display: flex;\n  padding: 4.667px 9.333px;\n  align-items: flex-start;\n  gap: 28px;\n  border-radius: 30px;\n  background: #9be7ff;\n  width: 15% !important;\n  height: 25px;\n}\n.notes-box {\n  margin: 15px 0px 0px 0px;\n  height: 80px !important;\n  display: flex;\n  padding: 20px;\n  align-items: flex-start;\n  align-content: flex-start;\n  gap: 22.473px;\n  flex: 1 0 0;\n  align-self: stretch;\n  flex-wrap: wrap;\n  border-radius: 8.989px;\n  border: 0.899px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n  width: 100% !important;\n  font-size: 15px;\n}\n\n.textarea {\n  border-radius: 10px;\n  border: 1px solid #dfdfdf;\n  background: var(--White, #fff);\n  outline: none;\n}\n\n.textarea:focus {\n  border: 1px solid #dfdfdf;\n}\n\nlabel.nores-text {\n  color: var(--graphic-objects-components-wcagaa, #949494);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0px 0px 0px 30px;\n}\n\ntable {\n  border: none;\n}\n\n.text-danger {\n  font-weight: 600;\n}\n.padd-main {\n  padding: 20px;\n}\n\n.listTmplt .create-comp-not-found .create-comp-text-not-found {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  text-align: center !important;\n}\n\n.sub-acc.pLR-space {\n  padding-left: 10%;\n  padding-right: 10%;\n}\n.create-comp-text,\n.subtittle {\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.review-blue {\n  color: var(--active-state, #3a68d8);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-decoration-line: underline !important;\n  text-decoration-thickness: 1px !important;\n  cursor: pointer;\n}\n.table-text-body {\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n}\n.table-text {\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.modal-close {\n  float: right;\n  margin: 0;\n  border: none;\n  background-color: white;\n  padding: 0;\n  position: absolute;\n  right: 15px;\n  top: 13px;\n  z-index: 10;\n}\n\nimg.close-icon {\n  margin: 0;\n  width: 25px;\n}\n\n.hiddenRow {\n  padding: 0 !important;\n}\n.modal-width {\n  width: 100%;\n}\n\n.modal-text {\n  padding: 15px 18px 0;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  word-wrap: break-word;\n}\n\n/*.modal-footer{\n    padding: 10px !important;\n    margin-top: -30px !important;\n}\n\n.modal-footer {\n    margin: -15px 10px 10px 0px;\n}\n*/\n.modal-text-pdf {\n  padding: 0px 15px 0;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n.modal-padding {\n  padding: 30px;\n}\n/*.modal-padding-pause{\n    margin: -17px 0px 0px 0px;\n   height: 115px;\n}*/\n.modal-text1 {\n  display: flex;\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  font-size: 15px;\n  color: #666666;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 500;\n}\n.pause-txt {\n  padding: 20px;\n  background: #f1f3f4;\n  border: none;\n  width: 100%;\n  outline: none;\n  /*margin: -25px 0px 0px -20px;*/\n  display: flex;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  border-bottom: 2px solid var(--gray-accessible-text, #666);\n  background: #f1f3f4;\n  height: 140px;\n}\n\n.modal-text-textarea {\n  padding: 17px 0px 0px 45px;\n  display: flex;\n  /*height: 160px;*/\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  /*border-bottom: 2px solid var(--gray-accessible-text, #666);\n    background: #F1F3F4;*/\n  width: 100%;\n  border: none;\n  /*margin-left: 55px;*/\n}\n.modal-bttn {\n  padding: 0px 20px;\n}\n\n.pop-text {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 10px 0px 0px -20px;\n}\n\n.cancel-bttn {\n  min-width: 80px;\n  padding: 0.5rem;\n  text-align: center;\n  margin: 0;\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-decoration-line: underline;\n  cursor: pointer;\n}\n\n.cancel-bttn-onbord {\n  margin: 10px 30px 0px 0px;\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-decoration-line: underline;\n  cursor: pointer;\n}\n\n.label-text {\n  margin: 0px 0px 0px 10px;\n}\n\n.review-text {\n  margin: 0px 0px 0px 30px;\n  color: black;\n}\n.doc-img {\n  width: 100%;\n  margin: 0px 10px 2px 0px;\n}\n\n.board-main {\n  background-color: #fbfbfb;\n}\n\n.userarea img {\n  width: 30px;\n}\n.header-user-icon {\n  width: 30px !important;\n  padding: 0px 10px 5px 0px;\n}\n.profile-width {\n  width: 100%;\n}\n.align-items-center {\n  margin: 0px 0px 0px 0px;\n}\ninput.form-control.side-input {\n  padding: 10px 0px 10px 45px;\n  border: none;\n}\n\n/*pv*/\nbutton.Save.top-save-bbtn.eidt-temp-save-bttn {\n  top: -7px;\n}\n\nimg.inp-icon.copyicon {\n  margin: 0px 3px 0px 0px;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgb(58 104 216) !important;\n}\n.text-success.team-algmt.pr-2 {\n  padding-bottom: 6px;\n  padding-top: 6px;\n  padding-left: 10px;\n  padding-right: 10px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n}\n.text-primary.team-algmt.pr-2 {\n  padding-bottom: 6px;\n  padding-top: 6px;\n  padding-left: 10px;\n  padding-right: 0px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n}\n.text-danger.team-algmt.pr-2 {\n  padding-bottom: 6px;\n  padding-top: 6px;\n  /* padding-left: 14px; */\n  padding-right: 20px;\n  font-weight: 400;\n  font-size: 14px;\n  border-radius: 0.25rem;\n}\n\n.card-cprocess {\n  word-wrap: break-word;\n  background-clip: border-box;\n  background-color: transparent;\n  border: 0;\n  border-radius: 0;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  position: relative;\n}\n\n.temp-table-border {\n  border-collapse: collapse;\n  border-bottom: 1px solid #edebeb;\n}\n.btnAlg_same .review-btn {\n  color: #fff;\n  border: 0;\n  width: auto;\n  min-width: 100px;\n  justify-content: space-between;\n  background: #3a68d8;\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  background: #3a68d8;\n  /* margin: 0 15px 0 0; */\n  width: 100%;\n}\n\n.filter-divs-temp.col-lg-6 {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  padding: 10px;\n  margin: 0;\n  width: 100%;\n}\n\n.main-filter.temp-filters {\n  max-height: 38px;\n}\n\nimg.temp-edits-icon {\n  width: 12px;\n  margin-left: 10px;\n  width: 100%;\n  max-width: 13px;\n}\n\nimg.temp-edits-icon:hover {\n  /* filter: brightness(0) invert(1); */\n}\n\n.edit-in-width-divs {\n  width: 100%;\n}\n\ninput.input-temp-edts {\n  border: none;\n  /* padding: 2px; */\n  border-bottom: 1px solid #ccc;\n}\n\n.logout-icon-img {\n  border-radius: 50%;\n  width: 100% !important;\n  height: 100%;\n  object-fit: cover !important;\n  /* padding: 20px;*/\n}\n.circle {\n  /* width: 100%;\n    height: 50px;\n    /* border-radius: 50%; */\n  overflow: hidden;\n  display: contents;\n  justify-content: flex-start;\n  align-items: center;\n  /* border: 5px solid #000;*/\n}\n\n.circle img {\n  margin-top: -5px;\n  width: 100%; /* Make the image fill the container */\n  height: 100%;\n  object-fit: cover; /* Ensure the image covers the circle */\n}\n\n.tooltip-caseimg .tooltiptext-case {\n  visibility: hidden;\n  width: 120px;\n  background-color: #555;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -60px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.tooltip-caseimg .tooltiptext-case::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #555 transparent transparent transparent;\n}\n\n.tooltip-caseimg:hover .tooltiptext-case {\n  visibility: visible;\n  opacity: 1;\n}\n\n.text-danger.in-com.tooltip.caselogo-div {\n  /*left: -5%;\n    display: flex; */\n  height: 20px;\n  width: 100%;\n  justify-content: center;\n  flex-direction: inherit;\n  text-align: center;\n  border: 1px solid #ccc;\n  padding: 10px;\n  border-radius: 5px;\n  display: flex;\n}\nimg.caselogo {\n  width: 100%;\n  float: right;\n  position: relative;\n  /* left: -20%; */\n  min-height: 13px;\n  padding: 0px;\n  top: -6px;\n  /* text-align: center; */\n  /* align-items: center; */\n  display: flex;\n  margin-left: auto;\n  margin-right: auto;\n  justify-content: center;\n}\n\n.alert9-div {\n  padding-left: 35px !important;\n}\n\n.box-two.mt-2 {\n  display: grid;\n}\n\n.alert9 {\n  padding: 5px 9px 10px 2px;\n  width: 3%;\n}\n.para-fonts-new {\n  font-size: 15px;\n  margin-bottom: 5px !important;\n  margin-top: 10px !important;\n}\n\n.no-scroll {\n  overflow: hidden;\n}\n\nimg.caselogoi9 {\n  width: 100%;\n  float: right;\n  position: relative;\n  /* left: -20%; */\n  min-height: 13px;\n  padding: 0px;\n  top: 0px;\n  /* text-align: center; */\n  /* align-items: center; */\n  display: flex;\n  margin-left: auto;\n  margin-right: auto;\n  justify-content: center;\n}\nbutton.submits-btn.rounded.p-2.case-bttn {\n  background-color: white;\n  border: 1px solid #ccc;\n  /* margin: 10px 0px 0px 0px; */\n}\nimg.case {\n  /*width: 30%;\n    float: left;\n    position: relative;\n    left: 5%;\n    height: 20px;*/\n}\nbutton.download-icon.case-left-down-icon3 {\n  left: -5px;\n  position: relative;\n  background: none;\n  border: none !important;\n  top: 0px;\n  justify-content: space-between;\n  display: flex;\n  flex-direction: inherit;\n  padding: 0px;\n  width: 50%;\n}\na.review-blue.case-blue {\n  width: 100%;\n  position: relative;\n  /*left: -15%;\n    left: -10%;*/\n  display: flex;\n}\n\nimg.arrowrrs-img.bulider-arrw {\n  width: 8%;\n  filter: brightness(0) invert(1);\n}\n\nimg.arrowrrs-img {\n  width: 8%;\n  float: right;\n  display: flex;\n  margin: 7px 0px 0px 30px;\n  filter: brightness(0) invert(1);\n}\n\nimg.arrowrr-img {\n  /*width: 7%;*/\n  width: 15px;\n  float: right;\n  display: flex;\n  position: relative;\n  top: 4px;\n}\n\n.arrowrrs-rotate {\n  transform: rotate(180deg) !important;\n  filter: brightness(0) invert(1);\n}\n\ntd.firstTab.arrow-btwn {\n  /*display: flex;*/\n  justify-content: space-between;\n}\n\n.mytem-algment {\n  display: flex;\n  justify-content: space-between;\n}\n.arrowrr-rotate {\n  transform: rotate(180deg) !important;\n}\n\n.dates-pickess {\n  border: var(--bs-border-width) solid red;\n  padding: 10px;\n}\n.dates-pickessi {\n  border: var(--bs-border-width) solid var(--light-gray-outline, #dfdfdf);\n  padding: 10px;\n}\n\n.dates-pickessi:focus {\n  border-color: #86b7fe !important;\n  outline: 0;\n}\n\n.react-datepicker-wrapper input {\n  /* min-width: 523px; */\n  height: 63px !important;\n  /* border: var(--bs-border-width) solid #ccc; */\n  border-radius: 5px !important;\n  width: 100%;\n}\n\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n  width: 100% !important;\n}\nimg.arrow-img {\n  width: 10%;\n  margin: 0px 15px 0px 15px;\n}\n\np.text-danger.in-com {\n  width: 70%;\n  font-size: 12px;\n  margin-left: 5px;\n}\n.form-select.select-height.select-widths {\n  /*width: 60%;\n    min-width: 640px;\n    display: flex;\n    float: left;*/\n}\n.onb-actions.fontSty.edits-fil {\n  /* padding-left: 22.3%; */\n  float: right;\n  padding-right: 15px;\n}\n.col-sm-3.col-lg-3.edit-filtess {\n  width: 22.5%;\n}\n\n.form-floating.wraper.minH.mb-3 {\n  /* margin-left: 25px; */\n  /* margin-right: 20px;\n      width: 90%; */\n}\n.input.form-control.text-inputsz {\n  border: 1px solid grey;\n  position: relative;\n  margin: 0 auto;\n  display: flex;\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\nbutton.dropbtn.btnArw {\n  background: #fff;\n  background: var(--White, #fff);\n  border: 1px solid #dfdfdf;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  border-radius: 10px;\n  font-size: 15px;\n  padding: 10px;\n  width: 205px !important;\n  color: black;\n}\n.firstTab.paddleft-sub-heading.ml-2 {\n  padding-left: 35px !important;\n}\n.img-wraper img {\n  max-width: 100%;\n  /* height: 200px;\n    max-height: inherit; */\n  height: auto;\n}\n.alignImg-inpts .inptFiles_up input[type=\"file\"] {\n  margin: 0px 0px 0px 5px;\n}\n\n.alignImg-inpts .inptFiles_up .upBtn {\n  margin: 0;\n}\n\n.alignImg-inpts .inptFiles_up.d-flex > p {\n  margin-top: 0;\n}\n\nimg.eye-img {\n  width: 20px;\n}\n\ninput.form-control.pass-inpt:focus {\n  border: var(--bs-border-width) solid var(--bs-border-color);\n}\n\n.input-group-append {\n  margin-left: -1px;\n}\n.input-group-append,\n.input-group-prepend {\n  display: flex;\n}\n\n.login_container .loginForm .input-group.password .input-group-append .btn {\n  border-radius: 0 10px 10px 0;\n}\n\n.input-group.password .input-group-append .btn {\n  border: 1px solid #ced4da;\n  border-left: 0;\n  color: #777;\n}\n.save-temp {\n  color: var(--light-gray-outline, #dfdfdf) !important;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.dropbtn .drop-imaege {\n  width: 18px;\n  margin: 0px 8px 0px 0;\n  height: auto;\n}\n\n.detail-tab-edit {\n  margin: -35px 0px 0px 22px !important;\n}\n\n.phone-icon {\n  margin: 0px 0px;\n  width: 16px;\n}\n\n.email-icon {\n  margin: 0px 0px;\n  width: 15px;\n}\n.choosefrom {\n  font-size: 14px;\n}\n\n.commt-text {\n  color: #000;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 147%;\n}\n\n.commt-date {\n  color: #666;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 147%;\n}\n.deatails-tap-text {\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 12.133px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin: 3px 13px 0px 0px;\n}\n\n.inptFiles_up.d-flex > p {\n  margin: 0;\n  font-size: 13px; /* margin: -20px 0px 0px 15px;*/\n  margin: -35px 0px 0px 65px;\n  word-break: break-all;\n}\n\n.inptFiles_up.d-flex {\n  align-items: center;\n}\n\n.inptFiles_up {\n  position: relative;\n}\n.inptFiles_up .upBtn {\n  position: absolute;\n  left: 0;\n  pointer-events: none;\n  width: 93px;\n  height: 37px;\n  border: 1px solid #949494;\n  background: #fff;\n  border-radius: 8px;\n  margin: -25px 0 0 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: #302b3a;\n}\n.form-check-input:checked {\n  box-shadow: inherit !important;\n}\n\n.RightCont .topSect .form-check-input:checked {\n  background-color: #949494;\n  border-color: #949494;\n}\n\n.serchField.serSpc {\n  margin: 0px 15px;\n}\n\n.form-check.mx-3.ml-0 {\n  margin-left: 0 !important;\n}\n\n.inpTxt.textArea.pl-0.rdw-editor-main {\n  height: auto;\n  min-height: 50px;\n}\n\n.aligChx {\n  align-items: center;\n}\n\n.aligEsig.aligChx {\n  align-items: flex-start;\n}\n\n.aligEsig.aligChx .form-check-input {\n  margin: 5px 8px 0 0;\n}\n\n.aligChx .form-check-input {\n  margin: 0 8px 0 0;\n}\n\n.RightCont .public-DraftStyleDefault-block.public-DraftStyleDefault-ltr {\n  /*margin-bottom: 0; min-width: 250px;*/\n}\n\n.aligChx.aligEsig .inpTxt.textArea {\n  resize: none !important;\n  overflow: auto !important;\n}\n/* 20-10-23 css start */\n.bxborder.wraper.newPads_editform .inpSpace {\n  flex: 1;\n}\n.formAlg-new .inpAlig .main-title {\n  width: 100%;\n}\n/*.table-text-body  td {\n    width: calc(100% / 4) !important;\n}*/\nth.firstTab {\n  min-width: inherit !important;\n}\n.footer.footer-bottom {\n  display: none;\n}\n\n/*start edits-scroll-important*/\n.ht-box div#main {\n  height: 100vh;\n}\n.ht-box.height-box {\n  height: 100%;\n}\n.content-sc.edits-height-box {\n  height: 100% !important;\n}\n/*end  edits-scroll-important*/\n\nul.dropdown-menu.mt-1.profile-width.show {\n  inset: 0px 0px 0px 0px !important;\n}\n.userarea ul.dropdown-menu.mt-1.profile-width.show {\n  inset: 0px 0 -8px 0px !important;\n}\n.detail-tabs .table tbody.table-text-body td {\n  word-break: break-all;\n  vertical-align: middle;\n}\n.e-pv-sidebar-toolbar .e-pv-tbar-btn {\n  color: rgba(0, 0, 0, 0.54);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n/*pppp*/\n.e-toolbar-items.e-tbar-pos {\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center;\n  padding: 10px 0px;\n}\n\n.e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-right {\n  position: inherit;\n}\n.e-toolbar-item .e-tbar-btn.e-tbtn-txt.e-control#download {\n  margin-top: 0px !important;\n  min-height: 40px !important;\n  min-width: 120px;\n  margin-right: 10px !important;\n}\n.custIcons button#file_Open,\n.custIcons button#chooseTemplates {\n  padding: 10px;\n}\nul.status-ind li a {\n  word-break: break-all;\n}\n.inpAlig .subHead_inp {\n  width: 100%;\n}\n.e-control.e-toolbar.e-lib.e-keyboard {\n  margin-top: 0px;\n}\n.e-pdf-toolbar.custIcons.bottom-space {\n  margin-bottom: 0px;\n  border-bottom: 1px solid #dfdfdf;\n}\n.e-toolbar .e-toolbar-items.e-tbar-pos {\n  /*border-bottom: 1px solid #dfdfdf;*/\n  border-radius: 0;\n  background: transparent;\n}\n.e-pv-sidebar-toolbar {\n  background-color: transparent;\n  margin: 0;\n  border-top: 0;\n  border-left: 0;\n}\n.res-p-10 {\n  padding-top: 10px;\n}\na.av-res {\n  background: #f7f9fb;\n  border: 1px solid #cccccc7d;\n  display: flex;\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 16px;\n  height: 87%;\n}\n.company-wrp {\n  display: flex;\n  align-items: center;\n}\n.res-grid ul {\n  list-style: none;\n  margin-left: 0px;\n  padding-left: 0px;\n  display: flex;\n  margin-top: 25px;\n  flex-wrap: wrap;\n}\n.company-wrp img {\n  padding: 6px;\n  background: #fff;\n  border-radius: 100px;\n  box-shadow: 1px 1px 10px #3a68d826;\n  width: 60px;\n}\n.res-grid h3 {\n  font-size: 16px;\n  color: #313338;\n  margin: 10px 0px;\n  font-weight: 700;\n  /* min-height: 20px; */\n  margin-left: 10px;\n}\n.res-grid ul li {\n  margin-right: 10px;\n  /* padding: 10px; */\n  color: #0000008c;\n  font-size: 13px;\n}\nspan.steps {\n  padding: 5px 12px;\n  background: #00968826;\n  border-radius: 4px;\n  font-size: 15px;\n}\n\n/* 20-10-23 css End */\n\n@media screen and (max-width: 1300px) {\n  .container_main.containerSpace.mainWrap .componentScroll .sub-acc {\n    width: 23.333333%;\n  }\n  .switch.togSw {\n    position: relative;\n    display: inline-block;\n    /*width: 32px;*/\n    width: 35%;\n    height: 17px;\n  }\n}\n\n/*@media (min-width: 992px) {\n    .modal-width {\n        max-width: 800px;\n    }\n}*/\n\n@media screen and (max-width: 992px) {\n  .inptFiles_up .upBtn {\n    width: 93px;\n    height: 37px;\n  }\n\n  .switch.togSw .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 9px;\n    width: 9px;\n    left: 3px;\n    bottom: 3px;\n    background-color: #949494;\n    transition: 0.4s;\n  }\n\n  .create-process {\n    min-height: 45vh;\n  }\n\n  .build-choose {\n    color: var(--Avenu-Black, #302b3a);\n    font-family: Manrope;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    display: contents;\n  }\n}\n\n.inptFiles_up .upload_files_issue input[type=\"file\"] {\n  font-size: 13px;\n  width: 95px;\n  height: 34px;\n  padding: 0;\n  opacity: 0;\n  position: absolute;\n  left: 2px;\n  top: 0px;\n  /*font-size: 13px;\n    width: 107px;\n    height: 34px;\n    padding: 0;\n    opacity: 0;\n    */\n}\n\n.inptFiles_up input[type=\"file\"] {\n  font-size: 13px;\n  width: 85px;\n  height: 34px;\n  padding: 0;\n  opacity: 0;\n  margin: -5px 0px 0px 5px;\n  /* position: absolute; */\n  left: 2px;\n  top: 0px;\n  border: none;\n\n  /*  font-size: 13px;\n    width: 95px;\n    height: 34px;\n    padding: 0;\n    opacity: 0;\n    margin: -15px 0px 0px 5px;\n   position: absolute;\n    left: 2px;\n    top: 0px;\n    /*font-size: 13px;\n    width: 107px;\n    height: 34px;\n    padding: 0;\n    opacity: 0;\n    position: absolute;*/\n}\n.scrolDiv {\n  max-height: 700px;\n  overflow-y: auto;\n}\n.grp-listing {\n  height: 135px;\n  overflow-y: auto;\n}\n/* width */\n.grp-listing::-webkit-scrollbar {\n  width: 10px;\n}\nspan.count-t {\n  background: red;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 40px;\n  color: #fff;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.container-fluid.row.align-items-xxl-stretch {\n  height: calc(100% - 84px) !important;\n}\nbutton.head-close.border-0.d-flex.ms-5 img {\n  width: 20px;\n}\n\nbutton.head-close.border-0.d-flex.ms-5 {\n  background: none;\n}\nimg.hd_icon-e {\n  width: 20px;\n  margin-right: 10px;\n}\nh6.form-hd {\n  font-weight: 500;\n}\na.in-Hd-link-itm {\n  color: #302b3a;\n}\n.whiteBg {\n  background-color: #fff;\n}\n\na.create-comp:hover > h6 {\n  color: #fff;\n}\n.sub-acc.blueborder {\n  border: 2px dashed #3a68d8;\n}\n/* .sub-acc.blueborder {\n    background-image: url(\"data:image/svg+xml,%3csvg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23316AF7FF' stroke-width='1' stroke-dasharray='6%2c 14' stroke-dashoffset='13' stroke-linecap='round'/%3e%3c/svg%3e\") !important;\n    border-radius: 10px;\n    border: 0;\n} */\n.modal-title {\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.ReactModal__Content.ReactModal__Content--after-open {\n  padding: 0 !important;\n}\n.modal-header {\n  padding: 15px 20px !important;\n}\n\n.modal-body {\n  padding: 20px 20px !important;\n}\n.row.common-r.mt-4.scroll-y {\n  height: 300px;\n  overflow-y: auto;\n}\n.row.common-r.mt-3.scroll-y {\n  height: 500px;\n  overflow-y: auto;\n\n  padding: 30px;\n}\n.sidebar_open.main-content.edit.hight-av {\n  height: 100vh !important;\n}\n.avatar {\n  background: #fff !important;\n  border: 1px solid #e8e8e8;\n}\n.avatar p {\n  color: #302b3a !important;\n  font-weight: 700 !important;\n  text-align: center;\n  line-height: 48px;\n\n  font-weight: 700 !important;\n  font-size: 17px;\n}\n.d-flex.align-items-center.justify-content-between.w-100.main-de select {\n  width: 30%;\n  padding: 10px 55px;\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\nli.breadcrumb-item a {\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\nli.breadcrumb-item.active {\n  color: #302b3a;\n  font-weight: 600;\n}\n.f-btns.doc button {\n  border: 0;\n  background: none;\n  /* margin-left: 100px; */\n}\nspan.yllowstatus {\n  background: #ffb900;\n  padding: 3px 15px;\n  border-radius: 40px;\n}\n.candidate.newDes .us-lists-itm {\n  float: left;\n  width: 100%;\n  /* white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;  */\n}\n.candidate.newDes .d-flex.wrp {\n  width: 90%;\n}\n.candidate.newDes .text-success,\n.candidate .text-warning,\n.candidate .text-danger {\n  min-width: 10%;\n  text-align: end;\n  font-weight: 500;\n  font-size: 15px;\n}\n\n.bxShw {\n  border: 1px solid #dfdfdf;\n  background-color: #fff;\n  border-radius: 10px;\n}\n\n.formInner {\n  border: 1px solid #dfdfdf;\n  background-color: #fff;\n  border-radius: 20px;\n}\n.formInner .form-features {\n  background: transparent;\n}\n\nbutton.clsBt {\n  background: transparent;\n  /*padding: 0;\n  float: right;*/\n}\nbutton.clsBt img {\n  width: 20px;\n  margin: 0;\n  padding: 0;\n}\n\n.inpSpace {\n  display: flex;\n  align-items: center;\n}\n.inpSpace > p {\n  margin: 0;\n}\n\n.widthInp {\n  width: 250px !important;\n  max-width: 100%;\n}\n.fileupload.fileSPace {\n  border: 2px dashed #3a68d870;\n  border-radius: 0 0 18px 18px;\n  padding: 40px;\n}\n.formWarp .form-hd.formAlg-new {\n  padding: 10px 20px;\n  margin: 0;\n  align-items: center;\n}\n/*.subHead_inp {\n    background: transparent;\n    border: 0 !important;\n    padding: 5px 0;\n    outline: 0 !important;\n    box-shadow: inherit !important;\n    display: flex;\n    color: #302B3A;\n    font-family: 'Manrope', sans-serif;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n}*/\n/*input.subHead_inp.main-title {\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 500;\n    \n}*/\n.subHead_inp,\n.subHead_inp-text {\n  background: transparent;\n  border: 0 !important;\n  box-shadow: inherit !important;\n  display: flex;\n  font-size: 15px;\n  font-style: normal;\n  line-height: normal;\n  outline: 0 !important;\n  padding: 5px 0;\n}\n\n.subHead_inp {\n  color: #302b3a;\n  font-family: \"Manrope\", sans-serif, sans-serif;\n  font-weight: 600;\n}\n\n/*.subHead_inp-text{ \n    background: transparent;\n    border: 0 !important;\n    padding: 5px 0;\n    outline: 0 !important;\n    box-shadow: inherit !important;\n    display: flex;\n    color: #666;\n    font-family: 'Manrope', sans-serif !important;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}*/\n\n.inpAlig {\n  display: block;\n  width: 100%;\n  padding: 0 0 0 15px;\n}\n.inpAlig .mainTitle {\n  font-size: 15px;\n  font-weight: 600;\n  margin: 5px 0 3px;\n  padding: 0;\n  font-family: \"Manrope\", sans-serif !important;\n}\n.formWarp .form-hd {\n  padding: 20px 20px;\n  margin: 0;\n}\n\n.wraper {\n  float: left;\n  width: 100%;\n}\n.txtAlgn {\n  display: flex;\n  justify-content: space-between;\n}\n.wrapAlign {\n  flex-direction: column;\n  display: flex;\n  width: 100% !important;\n  margin-left: 0 !important;\n}\n.wrapAlign.full-drp {\n  padding: 10px 10px;\n}\n.wrapAlign .hd-can.create-form-wrp h4.mainHead {\n  color: var(--Avenu-Black, #302b3a);\n  padding: 0;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0px 0px 10px;\n}\n.wrapAlign .hd-can.create-form-wrp p.subHead {\n  padding: 0;\n  margin: 0;\n}\n\n.wrapAlign .hd-can {\n  height: auto;\n}\n.wrapAlign .txtAlgn {\n  margin: 0;\n  padding: 10px 15px;\n  align-items: center;\n}\n.scrlHe {\n  height: 350px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.scrlHe::-webkit-scrollbar {\n  display: block !important;\n}\n\n.inserifiled {\n  border-left: 1px solid #ccc;\n}\n\n.scrlHe-tab {\n  /* height: 250px;*/\n  width: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  margin: 25px 0px 0px 0px;\n}\n.scrlHe-tab::-webkit-scrollbar {\n  display: block !important;\n}\n\n.action-itms.scrlHe {\n  margin-bottom: 5px;\n  padding-bottom: 5px;\n  overflow-y: auto;\n}\n\n/* ::-webkit-scrollbar{\n    -webkit-appearance: none;\n    width: 5px;\n}\n\n::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background-color: rgba(0,0,0,.5);\n    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);\n} */\n\n.RightCont form video {\n  width: 100% !important;\n}\n\n.wrapAlign .txtAlgn .accordion-button {\n  border-bottom: 1px solid #dfdfdf57;\n  margin: 0 0 15px;\n  padding: 0 0 15px;\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n}\n.accordion-button.tag.collapsed {\n  border-bottom: 1px solid transparent;\n  margin: 0;\n  padding: 0;\n}\n.listTmplt .create-comp {\n  margin: 0;\n  border-radius: 0;\n  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf) !important;\n  border: 0;\n  padding: 15px 20px;\n}\n\n.listTmplt .create-comp-not-found {\n  margin: 0;\n  padding: 15px 5px;\n  border-radius: 0;\n  /* border-bottom: 1px solid var(--light-gray-outline, #DFDFDF) !important;*/\n  border: 0;\n  padding: 20px;\n}\n\n.listTmplt .create-comp .create-comp-text {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  text-align: left;\n}\n\n.listTmplt {\n  /*margin: 0 0 15px;*/\n  margin: 0 0 5px;\n}\n\n.common.scroll-y.spc {\n  overflow-y: auto;\n  max-height: 300px;\n}\n\n.listTmplt a.create-comp:hover {\n  color: #000;\n  background-color: #fff;\n}\n.userarea .dropdown-item {\n  font-size: 15px;\n}\n\n.userarea .profile-width li img.rightarrow {\n  width: 7px;\n  margin-right: 10px;\n}\n.userarea .profile-width li .header-user-icon {\n  width: 26px !important;\n  padding: 0px 10px 0px 0px;\n}\n.userarea .dropdown-item:hover {\n  background-color: transparent;\n  color: var(--bs-dropdown-link-color);\n}\n\n.sub-acc.blueborder.newBorder {\n  border-radius: 10px;\n  padding: 0.7rem;\n}\n.padd-ajust .MuiList-padding {\n  padding-top: 0px;\n}\n\n.f-itm.newOne {\n  border: 1px solid #add8e6;\n  border-radius: 10px;\n  background-color: #eff6ff;\n}\n.dropbtn.btnArw {\n  position: relative;\n  text-align: left;\n}\n.detail-user .dropdown .dropbtn.btnArw {\n  font-weight: 500;\n}\n\n.dropbtn.btnArw:after {\n  content: \"\";\n  border-top: 0.3em solid #000;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n  position: absolute;\n  right: 8px;\n  top: 20px;\n}\nbutton.download-icon {\n  background: none;\n  border: none !important;\n  top: -5px;\n\n  width: 100%;\n}\n.dropbtn.btnArw.send-on-bttn:after {\n  content: \"\";\n  border-top: 0 solid #000;\n  border-right: 0 solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n  position: absolute;\n  right: 8px;\n  top: 20px;\n}\n\n.blkCl {\n  color: var(--avenu-black, #302b3a);\n}\n\n.blkCl::placeholder {\n  color: #949494 !important;\n}\n\n.tempList .form-control::placeholder {\n  color: #949494;\n}\n\n.tempList .form-control {\n  font-size: 15px;\n}\n\n.secTag {\n  margin: -15px 0 10px;\n}\n\n.secTag .menu-title {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.secTag .add-submenuz {\n  padding: 0;\n  margin-left: 10px;\n}\n\n.secTag .add-submenuz .add_icon {\n  width: 20px;\n}\n\n.topnav a.tage-menu {\n  padding: 4px 24px 4px 10px;\n  display: inline-flex;\n  align-items: center;\n}\n.topnav a.tage-menu .tage-text {\n  margin: 0;\n}\n\n.topnav a.tage-menu .close-image {\n  width: 12px;\n  top: 8px;\n  right: 6px;\n}\n.form_subTitles {\n  padding: 0 0 10px;\n  margin: 10px 0;\n}\n.sub-acc select.form-select {\n  font-size: 15px;\n  font-weight: 500;\n  border-radius: 10px;\n  min-height: 45px;\n}\n.tempList {\n  margin: 0 0 10px;\n}\n\n.tempList .create-G {\n  padding: 15px 0;\n}\n.grp-hd .tempList .create-G img {\n  margin: 0 15px 0 0 !important;\n  width: 20px;\n}\n\n.mr-0 {\n  margin-right: 0 !important;\n}\n\n.detail-tabs .table tbody.table-text-body td {\n  padding: 1rem 0.5rem 1rem;\n}\n.detail-tabs th.lastTab,\n.detail-tabs td.lastTab {\n  width: 20%;\n  /* text-align: end;*/\n  padding-right: 0 !important;\n}\n.detail-tabs th.dateTab,\n.detail-tabs td.dateTab {\n  max-width: 155px;\n}\n.detail-tabs th.firstTab,\n.detail-tabs td.firstTab .onboard-widthz {\n  max-width: 650px !important;\n}\n\n.detail-tabs th.firstTab,\n.detail-tabs td.firstTab .app-history {\n  min-width: 160px;\n}\n\n.detail-tabs th.firstTab,\n.detail-tabs td.firstTab {\n  min-width: 160px;\n  padding-left: 0 !important;\n}\n\n.actSpace {\n  padding-left: 1.5rem !important;\n  width: 100px;\n}\n\n.secBox .form-floating {\n  width: 100%;\n}\n\n.form-floating.doc_form {\n  max-width: 100%;\n  /*z-index: 1;*/\n  position: relative;\n  /* margin-bottom: -40px;*/\n  margin-bottom: 20px;\n  width: 350px;\n}\n\n.e-pv-sidebar-toolbar-splitter {\n  background: #e0e0e0;\n  bottom: 0;\n  height: calc(100% - 56px);\n  position: absolute;\n  width: 1px;\n  z-index: 0 !important;\n}\n.form-floating.doc_form .form-control {\n  font-size: 14px;\n  width: 100%;\n  padding: 5px 0.75rem;\n  height: 40px;\n  min-height: auto;\n}\n.form-floating.doc_form > label {\n  padding: 0.5rem 0.75rem;\n  font-size: 14px;\n}\n.pdfHeight_limit {\n  height: 45vh;\n  min-height: auto !important;\n  overflow-y: auto;\n}\n\n.e-pdfviewer:not(.e-pv-mobile-view) .e-pv-main-container {\n  min-height: auto;\n}\n\n.width-flex {\n  padding: 0 1em;\n}\n.width-flex .task-count {\n  padding: 0;\n}\n\n.rightCont .width-flex .hd-can-review.newPad,\n.rightCont .algSing_head .hd-can-review.newPad {\n  padding-left: 0;\n}\n\n.alignHead_review .task-count {\n  margin: 0;\n}\n\n.algSing_head {\n  display: block !important;\n  justify-content: inherit !important;\n  flex-direction: column;\n  padding: 0 1em !important;\n}\n.alignHead_review {\n  justify-content: space-between;\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n\n.form-floating.doc_form > .form-control:focus ~ label,\n.form-floating.doc_form > .form-control:not(:placeholder-shown) ~ label {\n  transform: scale(0.85) translateY(-1.23rem) translateX(0.15rem);\n  font-size: 13px;\n  padding-bottom: 0;\n  min-height: inherit;\n  height: auto;\n}\n.form-floating.doc_form > .form-control:not(:placeholder-shown) {\n  padding: 0.5rem 0.75rem;\n}\n\n.e-toolbar-item .e-tbar-btn.e-tbtn-txt.e-control#download {\n  background: var(--color1) !important;\n  color: #fff;\n  border-radius: 5px;\n  padding: 6px 25px;\n  border: 1px solid var(--color1);\n  margin-top: -3px;\n  min-height: 39px;\n  outline: 0;\n  box-shadow: inherit;\n  margin-right: -4px;\n}\n.e-toolbar-item .e-tbar-btn.e-tbtn-txt.e-control#download .e-tbar-btn-text {\n  color: #fff !important;\n  padding: 0;\n  margin: 0;\n}\n\n.txtfComp .public-DraftStyleDefault-block.public-DraftStyleDefault-ltr {\n  margin: 0 0 10px;\n  width: auto;\n  /* min-width: 300px; */\n  padding: 0;\n}\n.txtfComp .public-DraftEditorPlaceholder-root {\n  margin: 0;\n}\n\n.txtfComp .inpTxt.textArea.pl-0.rdw-editor-main,\n.newHeight-edit {\n  min-height: auto !important;\n  padding-bottom: 0 !important;\n  padding-right: 0;\n  height: inherit !important;\n}\n.newHeight-edit .public-DraftEditorPlaceholder-root {\n  margin-top: 0;\n}\n\n.tooltip.cent .tooltiptext {\n  left: -100px;\n  right: inherit;\n}\n.tooltip.cent .tooltiptext::after {\n  bottom: -8px;\n  left: 45%;\n  right: inherit;\n}\n\n.tooltiptext::after {\n  content: \" \";\n  width: 0;\n  height: 0;\n  /*border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 8px solid #ddd;*/\n  position: absolute;\n  bottom: -8px;\n  right: 5px;\n}\n.outer-tool.tooltip {\n  z-index: 0 !important;\n}\n.tooltip {\n  position: relative;\n  display: inline-block;\n  opacity: 1 !important;\n  border: 0;\n  z-index: 0 !important;\n}\n\n.tooltip .tooltiptext {\n  /* visibility: hidden;\n    min-width: 280px;\n    font-family: 'Manrope', sans-serif !important;\n    background-color: #FFF;\n    border: 1px solid #ddd;\n    color: var(--color2);\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px;\n    line-height: 18px;\n    text-align: center;\n    font-size: 13px;\n    position: absolute;\n    z-index: 1;\n    right: 10px;\n    bottom: 30px;\n    width: 100%;*/\n  visibility: hidden;\n  width: 100%;\n  font-family: \"Manrope\", sans-serif !important;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  color: var(--color2);\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  line-height: 18px;\n  right: 10px;\n  top: -60px;\n  min-width: 250px;\n\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1;\n}\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n}\n\n.tempList .form-floating > label,\n.form-floating.doc_form {\n  color: #a4a4a4;\n  font-size: 14px;\n}\n\n/* .e-toolbar .e-toolbar-item .e-tbar-btn#chooseTemplates {\n    background: #ffffff !important;\n    color: #fff;\n    border-radius: 5px;\n    padding: 6px 15px !important;\n    border: 1px solid var(--color1) !important;\n    margin-top: -3px;\n    min-height: 39px;\n    outline: 0;\n    box-shadow: inherit;\n} */\n/* .e-toolbar .e-toolbar-item .e-tbar-btn#chooseTemplates .e-tbar-btn-text{  color: var(--color1) ; } */\n\n.e-toolbar-items.e-tbar-pos .e-toolbar-center {\n  margin: 0 0 0 371px !important;\n  float: left;\n  display: inline-block !important;\n}\n\n.hd-can-review.neSp.create-form-wrp .task-count {\n  margin: 0;\n}\n\n.task-itms {\n  font-size: 15px;\n  width: 190px;\n}\n\n.btnAlg_same {\n  /*margin-bottom: -38px !important;*/\n  float: left;\n}\n.btnAlg_same .confirm-btn {\n  min-height: 40px;\n  margin-bottom: 0 !important;\n  border-radius: 7px !important;\n}\n\n.task-count.mr-0 {\n  margin: 0;\n}\n\n.listTmplt.alignDiv .icon-dele {\n  margin: 0;\n  float: right;\n  width: 35px;\n  cursor: pointer;\n  padding-left: 5px;\n}\n.listTmplt.alignDiv .create-comp {\n  border: 0 !important;\n}\n\n.listTmplt.alignDiv {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf) !important;\n}\n.btnAlg_same {\n  /*margin-bottom: -42px !important;*/\n  float: left;\n  margin-top: -20px;\n  margin: -15px 0px 10px 0px;\n}\n.alertField {\n  position: relative;\n}\n\n.alertField .alertRight {\n  color: red;\n  position: absolute;\n  right: 0;\n  bottom: -17px;\n  line-height: 13px;\n  font-size: 12px;\n  margin: 0;\n  letter-spacing: -0.1px;\n  min-width: 237px;\n  text-align: left;\n  /*min-width: 260px;\n    text-align: end;*/\n}\n.input-group-append.pass-div-width.secure-field {\n  width: 60% !important;\n}\n.form-floating.wraper.minH.mb-3.over-ride {\n  width: 90%;\n  margin: 0 auto;\n  position: relative;\n  left: 20px;\n}\n.alertField .alertLeft {\n  color: red;\n  position: absolute;\n  left: 0;\n  bottom: -19px;\n  line-height: 13px;\n  font-size: 12px;\n  margin: 0;\n  letter-spacing: -0.1px;\n  min-width: 260px;\n  text-align: left;\n}\n.lastChld {\n  text-align: center;\n  padding: 5px 0;\n  width: calc(100% - 10px);\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.savePopus .modal-title img.create-icon {\n  width: 23px;\n}\n\n.savePopus .modal-footer.footer-marg-pdf {\n  margin: 0px;\n}\n\n.savePopus .modal-close {\n  top: 14px;\n}\n\n.rdw-editor-toolbar a.rdw-dropdown-selectedtext {\n  color: #949494;\n}\n\n.rdw-editor-toolbar .rdw-dropdown-carettoopen {\n  border-top: 6px solid #949494;\n}\n\n.rdw-editor-toolbar .rdw-dropdown-wrapper:hover {\n  box-shadow: inherit;\n}\n\n.rdw-editor-toolbar .rdw-option-wrapper {\n  position: relative;\n}\n\n.formSect .alinBx hr {\n  margin: 0.6rem 0 1rem;\n  opacity: 0.08;\n}\n\n.rdw-editor-wrapper .rdw-editor-toolbar {\n  padding: 0;\n  border-radius: 0;\n  border: 0;\n}\n.rdw-editor-toolbar .rdw-option-wrapper {\n  border: 1px solid transparent;\n  padding: 2px;\n  min-width: 25px;\n  height: 25px;\n  box-shadow: inherit;\n  outline: 0;\n  border-radius: 0;\n  margin: 0 10px 0 0;\n}\n.rdw-editor-toolbar .rdw-option-wrapper:hover,\n.rdw-text-align-wrapper .rdw-option-wrapper:hover,\n.rdw-link-wrapper .rdw-option-wrapper:hover,\n.rdw-list-wrapper .rdw-option-wrapper:hover,\n.rdw-history-wrapper .rdw-option-wrapper:hover {\n  box-shadow: inherit;\n  border: 1px solid transparent;\n}\n\n.rdw-editor-toolbar .rdw-option-wrapper.rdw-option-active,\n.rdw-text-align-wrapper .rdw-option-wrapper.rdw-option-active,\n.rdw-link-wrapper .rdw-option-wrapper.rdw-option-active,\n.rdw-list-wrapper .rdw-option-wrapper.rdw-option-active,\n.rdw-history-wrapper .rdw-option-wrapper.rdw-option-active {\n  box-shadow: inherit;\n  border: 1px solid #dadada;\n}\n.rdw-inline-wrapper .rdw-option-wrapper:nth-child(1) img,\n.rdw-inline-wrapper .rdw-option-wrapper:nth-child(2) img,\n.rdw-inline-wrapper .rdw-option-wrapper:nth-child(3) img,\n.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(1) img,\n.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(2) img,\n.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(3) img,\n.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(4) img,\n.rdw-link-wrapper .rdw-option-wrapper img,\n.rdw-list-wrapper .rdw-option-wrapper img,\n.rdw-history-wrapper .rdw-option-wrapper:nth-child(1) img,\n.rdw-history-wrapper .rdw-option-wrapper:nth-child(2) img {\n  opacity: 0;\n}\n\n.rdw-inline-wrapper .rdw-option-wrapper:nth-child(1) {\n  background: url(../images/bold_font.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n.rdw-inline-wrapper .rdw-option-wrapper:nth-child(2) {\n  background: url(../images/italic_font.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n.rdw-inline-wrapper .rdw-option-wrapper:nth-child(3) {\n  background: url(../images/underline_font.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n\n.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(1) {\n  background: url(../images/align-left.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(2) {\n  background: url(../images/align-center.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(3) {\n  background: url(../images/align-right.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n.rdw-text-align-wrapper .rdw-option-wrapper:nth-child(4) {\n  background: url(../images/align-justify.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n.rdw-link-wrapper .rdw-option-wrapper {\n  background: url(../images/link.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n.rdw-list-wrapper .rdw-option-wrapper {\n  background: url(../images/list_order.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n.rdw-history-wrapper .rdw-option-wrapper:nth-child(1) {\n  background: url(../images/undo.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n.rdw-history-wrapper .rdw-option-wrapper:nth-child(2) {\n  background: url(../images/redo.svg);\n  background-position: center center !important;\n  background-repeat: no-repeat !important;\n}\n\n.public-DraftStyleDefault-ltr {\n  text-align: justify !important;\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.rdw-editor-wrapper {\n  width: 100% !important;\n}\n\nheader ul.dropdown-menu.mt-1.profile-width.show {\n  transform: translate3d(0px, 48px, 0px) !important;\n  position: absolute !important;\n  right: 0 !important;\n  top: 0 !important;\n  left: inherit !important;\n}\n\n/* ===== Scrollbar CSS ===== */\n/* Firefox */\n* {\n  scrollbar-width: 3px !important;\n  scrollbar-color: transparent !important;\n}\n\n/* Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n  width: 3px !important;\n}\n\n*::-webkit-scrollbar-track {\n  background: transparent !important;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: transparent;\n  border-radius: 60px;\n  border: 3px solid #a3a3a3 !important;\n}\n/* ===== Scrollbar CSS End ===== */\n\n.wrapAlign.full-drp.padNew {\n  padding: 15px !important;\n}\n.cer-temps.mt-2 {\n  height: auto;\n}\n\n.create-form-wrp.hegNew {\n  min-height: auto;\n}\n\n.bor_drag {\n  position: relative;\n}\n\n.bor_drag .leftDivs::before {\n  content: \" \";\n  position: absolute;\n  left: 0px;\n  top: 35%;\n  width: 3px;\n  min-height: 22px;\n  background-color: transparent;\n  border-radius: 20px;\n  z-index: 0;\n}\n\n.bor_drag:focus,\n.bor_drag:hover {\n  border: 1px solid #3a68d8 !important;\n}\n\n.bor_drag:focus .leftDivs::before,\n.bor_drag:hover .leftDivs::before {\n  background-color: #3a68d8;\n}\n\nbutton.btn.dragBtn {\n  border: 0;\n  box-shadow: inherit;\n}\n\n.ediBtns .Actbtn,\n.ediBtns:hover .bfBtn {\n  display: none;\n}\n.ediBtns:hover .Actbtn {\n  display: inline-block;\n}\n\n.ReactModal__Overlay.ReactModal__Overlay--after-open:has(.dltPops) {\n  /*z-index: 1600;*/\n}\n\n.ReactModal__Content.ReactModal__Content--after-open:has(.dltPops) {\n  max-width: 470px;\n}\n\nbutton.upBtn.aligBtn-view {\n  top: 0;\n  position: relative;\n  left: inherit;\n  margin: 0 0 0 15px;\n}\n\n.inptFiles_up.aligDivs_rev. {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.inptFiles_up.aligDivs_rev p {\n  /*margin: 0;*/\n  margin: 0px 0px 0px 110px;\n}\n\n.aligDivs_rev .upBtn.aligBtn-view {\n  top: 0;\n  position: relative;\n  left: inherit;\n  margin: 0 0 0 15px !important;\n}\n.cardSpace {\n  padding: 0 25px;\n}\nbutton.download-icon.case-left-down-icon1.visible-dw-btn {\n  left: inherit !important;\n}\n\n@media screen and (max-width: 767px) {\n  /*today*/\n  .sidebar_open.main-content.edit.hight-av {\n    height: 75vh !important;\n  }\n\n  .trash-edit {\n    float: right;\n    /* right: 5%; */\n    position: relative;\n    display: flex;\n    height: 0px;\n    margin-top: 0px;\n    width: 100%;\n    color: #000;\n    min-width: 200px;\n  }\n  button.dropbtn.btnArw {\n    background: #fff;\n    background: var(--White, #fff);\n    border: 1px solid #dfdfdf;\n    border: 1px solid var(--light-gray-outline, #dfdfdf);\n    border-radius: 10px;\n    font-size: 15px;\n    padding: 10px;\n    width: 100% !important;\n    color: black;\n  }\n  .icons-ed {\n    float: right;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    min-width: 100px;\n  }\n  .componentScroll .sub-acc {\n    background-color: #fff;\n    top: 10px;\n    right: 0px;\n    flex: 0 0 auto;\n    width: 100% !important;\n    z-index: 100;\n    display: inline-block;\n    justify-content: flex-end;\n    flex-direction: row-reverse;\n    position: relative;\n  }\n  .create-process {\n    min-height: 60vh;\n  }\n  button.Save.top-save-bbtn {\n    display: flex;\n    float: left;\n    margin-top: 50px;\n    width: 50%;\n  }\n\n  .trash-icon-popups {\n    float: right;\n    width: 100%;\n    display: flex;\n  }\n\n  .e-toolbar-items.e-tbar-pos {\n    display: contents !important;\n    justify-content: space-between !important;\n    align-items: center;\n    padding: 10px 0px;\n  }\n  .e-pdfviewer .e-pv-viewer-main-container {\n    width: 100% !important;\n    /*position: relative;*/\n  }\n\n  /*today*/\n\n  nav.sidebar {\n    position: fixed;\n    left: -290px;\n  }\n\n  Header nav {\n    display: none;\n  }\n\n  .userarea {\n    display: none;\n  }\n\n  .onb-actions a,\n  .onb-actions select {\n    width: 100%;\n    background: #fff;\n    margin-bottom: 5px;\n    padding: 2px 12px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    justify-content: flex-start;\n    margin-right: 0px;\n  }\n\n  .f-itm {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .sidebar_open {\n    margin: 7px !important;\n    /* border: 0; */\n    /* background: #fbfbfb; */\n    padding: 10px !important;\n  }\n\n  .onb-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .action-itms-forms h6 {\n    margin-bottom: 10px !important;\n    text-align: left !important;\n  }\n\n  .action-itms-forms {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .form-features {\n    padding: 5px !important;\n  }\n\n  .create-sec.onb-actions a {\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n  }\n\n  .create-sec.onb-actions {\n    flex-direction: row-reverse;\n  }\n  button.up-btn.btn {\n    width: 100%;\n  }\n  .upload-btns button {\n    margin-right: 0px !important;\n  }\n  .upload-btns span {\n    margin-right: 0px !important;\n  }\n  .upload-btns {\n    flex-direction: column !important;\n    display: flex;\n    align-items: center;\n    width: 100%;\n  }\n  .ReactModal__Content.ReactModal__Content--after-open {\n    position: inherit;\n    width: 100%;\n    inset: 0px !important;\n  }\n\n  .action-itms.d-flex.align-items-center.justifycontent-between {\n    flex-direction: column;\n  }\n  .tm-buttons .men-btn {\n    flex-direction: column !important;\n  }\n  .tm-buttons {\n    width: 100%;\n  }\n  .men-btn.d-flex.align-items-center button {\n    width: 100%;\n    margin-right: 0px;\n    margin-bottom: 5px;\n  }\n  .search {\n    width: 100% !important;\n  }\n  .searchere img {\n    width: 20px !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .col-lg-5.padd-ajust {\n    width: 46.66666667%;\n  }\n  .col-lg-3.padd-ajL {\n    width: 20%;\n  }\n  .container_main.containerSpace.mainWrap .componentScroll .sub-acc {\n    max-width: 24.3%;\n  }\n  .create-process {\n    min-height: 60vh;\n  }\n}\n\n/* @media only screen and (max-width: 2880px) and (min-width: 1920px)  {\n\n    .sidebar .nav span.menu-title, button.status-btn, .user-itm .ca-details h3, .ca-details h3, .react-tabs__tab, .table-text, .table-text-body, span.username, .detail-user .dropdown .dropbtn.btnArw \n    { font-size: 16px !important; }\n    .sidebar .nav a.nav-link .menuIcon_bx img {  width: 24px; }\n    .userlist .hd-can h4.allTxt, .candidate.newDes .text-success, .candidate .text-warning, .candidate .text-danger{ font-size: 20px; }\n    .detail-user .candidate .text-warning, .detail-user .candidate .text-danger, .detail-user .candidate.newDes .text-success{ font-size: 19px; }\n\n} */\n@media screen and (min-device-height: 630px) and (max-device-height: 700px) {\n  .create-process {\n    min-height: 60vh;\n  }\n  .alignBox.fn-main ul li .component {\n    min-height: 90px;\n  }\n}\n@media screen and (min-device-height: 580px) and (max-device-height: 629px) {\n  .alignBox.fn-main ul li .component {\n    min-height: 80px;\n  }\n  .component h6 {\n    font-size: 13px;\n  }\n  .create-process {\n    min-height: 60vh;\n  }\n}\n@media screen and (min-device-height: 430px) and (max-device-height: 579px) {\n  .temp-top-section {\n    display: inline-block;\n    justify-content: space-between;\n  }\n  .componentScroll .sub-acc {\n    background-color: #fff;\n\n    top: 10px;\n    right: 0px;\n    flex: 0 0 auto;\n    width: 100% !important;\n    z-index: 100;\n    display: inline-block;\n    justify-content: flex-end;\n    flex-direction: row-reverse;\n    position: relative;\n  }\n  .create-process {\n    min-height: 60vh;\n  }\n  .action-itms.full-drp {\n    flex-direction: row !important;\n    align-items: flex-start !important;\n    display: flex !important;\n    justify-content: flex-end !important;\n  }\n  .alignBox.fn-main ul li .component {\n    min-height: 65px;\n  }\n  .component img.create-icon {\n    width: auto;\n    max-width: 27px;\n    margin-bottom: 13px;\n    max-height: 20px;\n  }\n}\n@media (min-device-height: 680px) and (max-device-height: 720px) {\n  .container_main.containerSpace.mainWrap .componentScroll .sub-acc {\n    max-width: 30.3%;\n    width: 24.38% !important;\n  }\n  .create-process {\n    min-height: 60vh;\n  }\n}\n@media (min-device-height: 720px) and (max-device-height: 800px) {\n  .create-process {\n    min-height: 60vh;\n  }\n  .container_main.containerSpace.mainWrap .componentScroll .sub-acc {\n    max-width: 30.3%;\n    width: 25.38% !important;\n  }\n}\n@media (min-device-height: 720px) and (max-device-height: 991px) {\n  .container_main.containerSpace.mainWrap .componentScroll .sub-acc {\n    /* max-width: 30.3%; */\n    /*width: 25.38% !important;*/\n    /* width: 24.38% !important; */\n  }\n  .create-process {\n    min-height: 35vh;\n  }\n\n  .wraper.scrlHe-tab.scroll.scroll1.temppos-height {\n    height: 68vh;\n  }\n}\n\n@media (min-device-height: 800px) and (max-device-height: 991px) {\n  .create-process {\n    min-height: 55vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
